import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, UseMutationOptions } from 'react-query';
import { fetchCoreApi } from '../../fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSJSON: any;
  AWSTimestamp: any;
  Long: any;
};

export type AcknowledgeNotificationInput = {
  eventId: Scalars['ID'];
};

export type AddAssistantDocumentInput = {
  assistantId: Scalars['ID'];
  documentName: Scalars['String'];
};

export type AddCardContentBlockInput = {
  blockType: ContentBlockType;
  cardId: Scalars['ID'];
  tabId: Scalars['ID'];
};

export type AddCardScopeInput = {
  cardId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type AddCardTabInput = {
  cardId: Scalars['ID'];
  title: Scalars['String'];
};

export type AddDecisionTreeNodeInput = {
  parentId: Scalars['ID'];
  parentValue: Scalars['String'];
};

export type AddProjectAssignmentInput = {
  projectId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type AddProjectToExcelCardImporterInput = {
  id: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type AddWordingInput = {
  phrasingSubjectId: Scalars['ID'];
  text: Scalars['String'];
};

export type AnnotateAudioInput = {
  id: Scalars['ID'];
  status?: InputMaybe<DetectionStatus>;
};

export type ArchiveProjectInput = {
  projectId: Scalars['ID'];
};

export type ArchiveTopicInput = {
  text: Scalars['String'];
};

export type AsrCommand = {
  __typename?: 'AsrCommand';
  alternatives?: Maybe<Array<Scalars['String']>>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  language: Scalars['String'];
  levenshteinDistance?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  prefixSize?: Maybe<Scalars['Int']>;
};

export type AsrCommandConnection = {
  __typename?: 'AsrCommandConnection';
  items: Array<AsrCommand>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AsrCommandFilterInput = {
  enabled?: InputMaybe<TableBooleanFilterInput>;
  id?: InputMaybe<TableIdFilterInput>;
  language?: InputMaybe<TableStringFilterInput>;
  levenshteinDistance?: InputMaybe<TableIntFilterInput>;
  name?: InputMaybe<TableStringFilterInput>;
  prefixSize?: InputMaybe<TableIntFilterInput>;
};

export type AsrSession = {
  __typename?: 'AsrSession';
  duration: Scalars['Int'];
  matchTranscript: Array<Scalars['String']>;
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
  projectName: Scalars['String'];
  sessionId: Scalars['ID'];
  timestamp: Scalars['Long'];
  userDisplayName: Scalars['String'];
  userEmail: Scalars['String'];
  userId: Scalars['ID'];
};

export type AsrSessionConnection = {
  __typename?: 'AsrSessionConnection';
  count: Scalars['Int'];
  items: Array<AsrSession>;
  nextItem?: Maybe<Scalars['Int']>;
};

export type AssignmentInput = {
  assigneeId: Scalars['ID'];
  to: Scalars['ID'];
};

export type AttributeFilter = {
  attribute: Scalars['String'];
  floatFilter?: InputMaybe<TableFloatFilterInput>;
  stringFilter?: InputMaybe<TableStringFilterInput>;
};

export type BatchCreateUserAssignmentsInput = {
  projectIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};

export type BatchDeleteUserAssignmentsInput = {
  projectIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};

export type BooleanInput = {
  value: Scalars['Boolean'];
};

export type Card = {
  __typename?: 'Card';
  author: Scalars['ID'];
  authorUser: User;
  clientId?: Maybe<Scalars['String']>;
  /**   New content */
  content: CardContentV2;
  date: Scalars['AWSTimestamp'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  deletedBy?: Maybe<Scalars['ID']>;
  expirationDate?: Maybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  importId?: Maybe<Scalars['String']>;
  isFavorite?: Maybe<Scalars['Boolean']>;
  isLibrary?: Maybe<Scalars['Boolean']>;
  organisationId: Scalars['String'];
  scopes: ScopeConnection;
  tags: ContentTagConnection;
  title: Scalars['String'];
  updatedAt: Scalars['AWSTimestamp'];
  updatedBy?: Maybe<Scalars['ID']>;
  updatedByUser?: Maybe<User>;
  /**   Legacy content */
  version: CardVersion;
};

export type CardCommand = {
  __typename?: 'CardCommand';
  command?: Maybe<AsrCommand>;
  commandId: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
  detectionCounts: DetectionCountConnection;
  projectId: Scalars['ID'];
  scopeId: Scalars['ID'];
};


export type CardCommandDetectionCountsArgs = {
  date: TableStringFilterInput;
};

export type CardCommandConnection = {
  __typename?: 'CardCommandConnection';
  items: Array<CardCommand>;
  nextToken?: Maybe<Scalars['String']>;
  scannedCount: Scalars['Int'];
};

export type CardCommandContextInput = {
  cardId: Scalars['String'];
  commandContextTextLower: Scalars['String'];
};

export type CardConnection = {
  __typename?: 'CardConnection';
  items: Array<Card>;
};

export type CardContent = {
  __typename?: 'CardContent';
  cardVersionId: Scalars['ID'];
  tabs: Array<CardTab>;
};

export type CardContentV2 = {
  __typename?: 'CardContentV2';
  cardId: Scalars['ID'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  organisationId: Scalars['String'];
  tabs: Array<CardTabV2>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
};

export type CardDeleteOutput = {
  __typename?: 'CardDeleteOutput';
  id: Scalars['ID'];
};

export type CardGenerationTaskConnection = {
  __typename?: 'CardGenerationTaskConnection';
  items: Array<MvpGeneratedCardsFromPdf>;
  nextToken?: Maybe<Scalars['String']>;
};

export type CardLink = {
  __typename?: 'CardLink';
  date: Scalars['AWSTimestamp'];
  sourceScopeId: Scalars['ID'];
  targetScope: CardScope;
  targetScopeId: Scalars['ID'];
};

export type CardLinkConnection = {
  __typename?: 'CardLinkConnection';
  items: Array<CardLink>;
  nextToken?: Maybe<Scalars['String']>;
  scannedCount: Scalars['Int'];
};

export type CardScope = {
  __typename?: 'CardScope';
  author: Scalars['ID'];
  card: Card;
  cardId: Scalars['ID'];
  commandCount: Scalars['Int'];
  date: Scalars['AWSTimestamp'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  deletedBy?: Maybe<Scalars['String']>;
  feedbackCounts: FeedbackCountConnection;
  id: Scalars['ID'];
  importId?: Maybe<Scalars['String']>;
  links: CardLinkConnection;
  projectCommands: Array<ProjectCommand>;
  projectId: Scalars['ID'];
};


export type CardScopeFeedbackCountsArgs = {
  date: TableStringFilterInput;
};

export type CardSearchInput = {
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  text: Scalars['String'];
};

export type CardStatId = StatId & {
  __typename?: 'CardStatId';
  card: Card;
  cardId: Scalars['ID'];
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
};


export type CardStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type CardTab = {
  __typename?: 'CardTab';
  blocks: Array<ContentBlock>;
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  title: Scalars['String'];
  updatedAt: Scalars['AWSTimestamp'];
};

export type CardTabV2 = {
  __typename?: 'CardTabV2';
  blocks: Array<ContentBlockV2>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  id: Scalars['ID'];
  title: Scalars['String'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
};

export type CardTendency = {
  __typename?: 'CardTendency';
  current: Scalars['Int'];
  previous: Scalars['Int'];
};

export type CardVersion = {
  __typename?: 'CardVersion';
  author: Scalars['ID'];
  cardId: Scalars['ID'];
  content: CardContent;
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type Catalog = {
  __typename?: 'Catalog';
  columns: Array<RenamedColumn>;
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  createdByUser: User;
  dataColumns: Array<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['String']>;
  draft?: Maybe<Scalars['String']>;
  files: Array<Scalars['String']>;
  id: Scalars['ID'];
  organisationId: Scalars['String'];
  projects: Array<CatalogProject>;
  publishedAt?: Maybe<Scalars['Long']>;
  publishedBy?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
};

export type CatalogConnection = {
  __typename?: 'CatalogConnection';
  items: Array<Catalog>;
  nextToken?: Maybe<Scalars['String']>;
};

export type CatalogProject = {
  __typename?: 'CatalogProject';
  project: Project;
  projectId: Scalars['ID'];
};

export enum Category {
  Concurrent = 'Concurrent',
  FormulationNotRecommended = 'FormulationNotRecommended',
  Objection = 'Objection',
  Product = 'Product'
}

export type CheckCommandInput = {
  language: Scalars['String'];
  text: Scalars['String'];
};

export type Command = {
  __typename?: 'Command';
  alternatives?: Maybe<Array<Scalars['String']>>;
  associations: Array<ProjectCommand>;
  commandRequest?: Maybe<CommandRequest>;
  date: Scalars['AWSTimestamp'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  enabled: Scalars['Boolean'];
  forbiddenWordings?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  language: Scalars['String'];
  onlyAlternative?: Maybe<Scalars['Boolean']>;
  projectCommand?: Maybe<ProjectCommand>;
  text: Scalars['String'];
  textLower: Scalars['String'];
};


export type CommandProjectCommandArgs = {
  projectId?: InputMaybe<Scalars['ID']>;
};

export enum CommandComplianceType {
  NotRecommended = 'NotRecommended',
  Recommended = 'Recommended'
}

export type CommandConnection = {
  __typename?: 'CommandConnection';
  items: Array<Command>;
  nextToken?: Maybe<Scalars['String']>;
};

export type CommandContext = {
  __typename?: 'CommandContext';
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
  text: Scalars['String'];
  textLower: Scalars['String'];
  user: User;
};

export type CommandRequest = {
  __typename?: 'CommandRequest';
  command: Command;
  commandId: Scalars['ID'];
  createdBy: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  organisationId: Scalars['ID'];
  status: CommandRequestStatus;
  updateDate: Scalars['AWSTimestamp'];
};

export type CommandRequestConnection = {
  __typename?: 'CommandRequestConnection';
  items: Array<CommandRequest>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum CommandRequestStatus {
  Cancelled = 'Cancelled',
  Denied = 'Denied',
  Generic = 'Generic',
  Ok = 'Ok',
  Pending = 'Pending'
}

export type CommandStatId = StatId & {
  __typename?: 'CommandStatId';
  command: Command;
  commandId: Scalars['String'];
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
};


export type CommandStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type Comment = {
  __typename?: 'Comment';
  commentType: CommentType;
  content: Scalars['String'];
  date: Scalars['Long'];
  deletedAt?: Maybe<Scalars['Long']>;
  id: Scalars['String'];
  isReply?: Maybe<Scalars['Boolean']>;
  numReplies?: Maybe<Scalars['Int']>;
  organisationId: Scalars['String'];
  parentId: Scalars['String'];
  updateDate?: Maybe<Scalars['Long']>;
  user: User;
  userId: Scalars['String'];
};

export type CommentConnection = {
  __typename?: 'CommentConnection';
  items: Array<Comment>;
};

export enum CommentType {
  Card = 'Card',
  ContentRequest = 'ContentRequest'
}

export type ConditionTopic = {
  __typename?: 'ConditionTopic';
  textLower: Scalars['String'];
  topic: Topic;
};

export type ConfirmAccountInput = {
  displayName: Scalars['String'];
  password: Scalars['String'];
};

export type ContentBlock = {
  __typename?: 'ContentBlock';
  blockType: ContentBlockType;
  content: Scalars['String'];
  createdAt?: Maybe<Scalars['Long']>;
  createdBy?: Maybe<Scalars['String']>;
  date: Scalars['Long'];
  displayType: ContentBlockDisplayType;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Long']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export enum ContentBlockDisplayType {
  Always = 'Always',
  Cta = 'Cta'
}

export enum ContentBlockType {
  Richtext = 'Richtext'
}

export type ContentBlockV2 = {
  __typename?: 'ContentBlockV2';
  blockType: ContentBlockType;
  content: Scalars['String'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  displayType: ContentBlockDisplayType;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
};

export type ContentGenerationAssistant = {
  __typename?: 'ContentGenerationAssistant';
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['Long']>;
  documentNames: Array<Scalars['String']>;
  documents: Array<UploadedDocuments>;
  id: Scalars['ID'];
  indexedAt?: Maybe<Scalars['Long']>;
  listThreads: ContentGenerationAssistantThreadConnection;
  organisationId: Scalars['String'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['Long']>;
  user: User;
};


export type ContentGenerationAssistantListThreadsArgs = {
  input: InfiniteQueryInput;
};

export type ContentGenerationAssistantConnection = {
  __typename?: 'ContentGenerationAssistantConnection';
  items: Array<ContentGenerationAssistant>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ContentGenerationAssistantMutation = {
  __typename?: 'ContentGenerationAssistantMutation';
  addDocument: ContentGenerationAssistant;
  create: ContentGenerationAssistant;
  generateTag: Scalars['String'];
  removeDocument: ContentGenerationAssistant;
};


export type ContentGenerationAssistantMutationAddDocumentArgs = {
  input: AddAssistantDocumentInput;
};


export type ContentGenerationAssistantMutationCreateArgs = {
  input: CreateContentGenerationAssistantInput;
};


export type ContentGenerationAssistantMutationGenerateTagArgs = {
  input: IdInput;
};


export type ContentGenerationAssistantMutationRemoveDocumentArgs = {
  input: RemoveAssistantDocumentInput;
};

export type ContentGenerationAssistantQuery = {
  __typename?: 'ContentGenerationAssistantQuery';
  get: ContentGenerationAssistant;
  list: ContentGenerationAssistantConnection;
};


export type ContentGenerationAssistantQueryGetArgs = {
  input: IdInput;
};


export type ContentGenerationAssistantQueryListArgs = {
  input: InfiniteQueryInput;
};

export type ContentGenerationAssistantThread = {
  __typename?: 'ContentGenerationAssistantThread';
  assistantId: Scalars['ID'];
  createdAt: Scalars['Long'];
  id: Scalars['ID'];
  messages: Array<ContentGenerationAssistantThreadMessage>;
  organisationId: Scalars['String'];
};

export type ContentGenerationAssistantThreadConnection = {
  __typename?: 'ContentGenerationAssistantThreadConnection';
  items: Array<ContentGenerationAssistantThread>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ContentGenerationAssistantThreadMessage = {
  __typename?: 'ContentGenerationAssistantThreadMessage';
  createdAt: Scalars['Long'];
  message: Scalars['String'];
  role: ContentGenerationAssistantThreadMessageRole;
};

export enum ContentGenerationAssistantThreadMessageRole {
  Assistant = 'Assistant',
  System = 'System',
  User = 'User'
}

export enum ContentGenerationModel {
  Llama2_7 = 'Llama2_7',
  Llama2_13 = 'Llama2_13',
  Llama2_70 = 'Llama2_70'
}

export type ContentRequest = {
  __typename?: 'ContentRequest';
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['String']>;
  card?: Maybe<Card>;
  cardId?: Maybe<Scalars['String']>;
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['Long']>;
  details: Scalars['String'];
  organisationId: Scalars['String'];
  project: Project;
  projectId: Scalars['String'];
  state: ContentRequestState;
  title: Scalars['String'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
  user: User;
};

export type ContentRequestConnection = {
  __typename?: 'ContentRequestConnection';
  items: Array<ContentRequest>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum ContentRequestState {
  Cancelled = 'Cancelled',
  Denied = 'Denied',
  Done = 'Done',
  InProgress = 'InProgress',
  Pending = 'Pending'
}

export type ContentTag = {
  __typename?: 'ContentTag';
  author: Scalars['ID'];
  contentId: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  deletedBy?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  organisationId: Scalars['String'];
  text: Scalars['String'];
};

export type ContentTagConnection = {
  __typename?: 'ContentTagConnection';
  items: Array<ContentTag>;
};

export type CreateAsrCommandInput = {
  alternatives: Array<Scalars['String']>;
  language: Scalars['String'];
  levenshteinDistance: Scalars['String'];
  name: Scalars['String'];
  prefixSize: Scalars['Int'];
};

export type CreateCardInput = {
  expirationDate?: InputMaybe<Scalars['AWSTimestamp']>;
  projectId?: InputMaybe<Scalars['ID']>;
  tabs?: InputMaybe<Scalars['AWSJSON']>;
  title: Scalars['String'];
};

export type CreateCommandContextInput = {
  projectId: Scalars['ID'];
  text: Scalars['String'];
};

export type CreateCommandNewInput = {
  alternatives: Array<Scalars['String']>;
  language: Scalars['String'];
  text: Scalars['String'];
};

export type CreateCommentInput = {
  commentType: CommentType;
  content: Scalars['String'];
  isReply: Scalars['Boolean'];
  parentId: Scalars['String'];
};

/**   === Mutations === */
export type CreateContentGenerationAssistantInput = {
  name: Scalars['String'];
};

export type CreateContentRequestInput = {
  details: Scalars['String'];
  projectId: Scalars['String'];
  title: Scalars['String'];
};

export type CreateContentTagInput = {
  contentId: Scalars['ID'];
  text: Scalars['String'];
};

export type CreateDecisionTreeInput = {
  name: Scalars['String'];
  projectId?: InputMaybe<Scalars['ID']>;
};

export type CreateDetectionInput = {
  ASRText?: InputMaybe<Scalars['String']>;
  cardId: Scalars['ID'];
  commandId: Scalars['String'];
  id: Scalars['ID'];
  model: Scalars['String'];
  projectId: Scalars['ID'];
  sessionId: Scalars['ID'];
};

export type CreateDisplayInput = {
  cardId: Scalars['ID'];
  detectionId?: InputMaybe<Scalars['ID']>;
  displayType: DisplayType;
  id?: InputMaybe<Scalars['ID']>;
  isVisible: Scalars['Boolean'];
  projectId: Scalars['ID'];
  sessionId?: InputMaybe<Scalars['ID']>;
  user: Scalars['ID'];
};

export type CreateExcelCardImporterInput = {
  name: Scalars['String'];
  organisationId: Scalars['ID'];
};

export type CreateIntegrationInput = {
  type: IntegrationType;
};

export type CreateMandatoryTopicInput = {
  complianceExample?: InputMaybe<Scalars['String']>;
  conditionTopics?: InputMaybe<Array<Scalars['String']>>;
  minimumDuration?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['String'];
  sessionStepCondition?: InputMaybe<MandatoryTopicSessionStep>;
  topicTextLower: Scalars['String'];
};

export type CreateNewsInput = {
  content: Scalars['String'];
  title: Scalars['String'];
};

export type CreatePhrasingSubjectInput = {
  name: Scalars['String'];
  wordings: Array<Scalars['String']>;
};

export type CreateProjectCommandInput = {
  cardCommandContexts?: InputMaybe<Array<CardCommandContextInput>>;
  cardId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Category>;
  commandContextTextLower?: InputMaybe<Scalars['String']>;
  isAlerting?: InputMaybe<Scalars['Boolean']>;
  isSpecific: Scalars['Boolean'];
  language: Scalars['String'];
  permissiveMatching?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
  text: Scalars['String'];
  topicTextLower?: InputMaybe<Scalars['String']>;
};

export type CreateProjectInput = {
  asrLanguage: Scalars['String'];
  name: Scalars['String'];
};

export type CreateRecommenderColumnSpecInput = {
  columnName: Scalars['String'];
  defaultSpec: RecommenderStringColumnSpecInput;
  displaySpec?: InputMaybe<RecommenderColumnSpecDisplayInput>;
  numberSpec?: InputMaybe<RecommenderNumberColumnSpecInput>;
  recommenderId: Scalars['ID'];
};

export type CreateRecommenderInput = {
  name: Scalars['String'];
  organisationId: Scalars['String'];
};

export type CreateSessionInput = {
  externalCallId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  projectId: Scalars['ID'];
};

export type CreateTeamInput = {
  color: Scalars['String'];
  title: Scalars['String'];
};

export type CreateTopicInput = {
  color: Scalars['String'];
  text: Scalars['String'];
};

export type DatasetSummary = {
  __typename?: 'DatasetSummary';
  firstDataPoints: Array<Scalars['AWSJSON']>;
  numDataPoints: Scalars['Int'];
};

export type DateInput = {
  value: Scalars['AWSTimestamp'];
};

export type DecisionTree = {
  __typename?: 'DecisionTree';
  allowComments?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nodes: Array<DecisionTreeNode>;
  organisationId: Scalars['String'];
  projectCount: Scalars['Long'];
  projects: Array<DecisionTreeProject>;
  root: DecisionTreeNode;
  rootId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
  updatedByUser: User;
};

export type DecisionTreeChildNode = {
  __typename?: 'DecisionTreeChildNode';
  id: Scalars['ID'];
  nodeValue: Scalars['String'];
};

export type DecisionTreeChildNodeInput = {
  id: Scalars['ID'];
  nodeValue: Scalars['String'];
};

export type DecisionTreeNode = {
  __typename?: 'DecisionTreeNode';
  cleanedAt?: Maybe<Scalars['Long']>;
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  createdByUser: User;
  decisionTreeId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  newChildren?: Maybe<Array<DecisionTreeChildNode>>;
  organisationId: Scalars['String'];
  parentId?: Maybe<Scalars['ID']>;
  parentIds?: Maybe<Array<Scalars['ID']>>;
  richText?: Maybe<Scalars['String']>;
  type: DecisionTreeNodeType;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
  updatedByUser: User;
};

export enum DecisionTreeNodeType {
  ActionClient = 'ActionClient',
  Information = 'Information',
  Question = 'Question'
}

export type DecisionTreeProject = {
  __typename?: 'DecisionTreeProject';
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  decisionTreeId: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Long']>;
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
};

export type DecisionTreeProjectInput = {
  decisionTreeId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type DecisionTreeRun = {
  __typename?: 'DecisionTreeRun';
  comments: Array<DecisionTreeRunComment>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  decisionTree?: Maybe<DecisionTree>;
  decisionTreeId: Scalars['ID'];
  finishedAt?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  isPreviewRun?: Maybe<Scalars['Boolean']>;
  nodes: Array<DecisionTreeRunNode>;
  organisationId: Scalars['String'];
  sessionId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
};

export type DecisionTreeRunComment = {
  __typename?: 'DecisionTreeRunComment';
  nodeId: Scalars['ID'];
  userComment: Scalars['String'];
};

export type DecisionTreeRunNode = {
  __typename?: 'DecisionTreeRunNode';
  id: Scalars['ID'];
  node: DecisionTreeNode;
};

export type DeleteCardInput = {
  id: Scalars['ID'];
};

export type DeleteCommandContextInput = {
  projectId: Scalars['ID'];
  textLower: Scalars['String'];
};

export type DeleteCommandInput = {
  id: Scalars['ID'];
};

export type DeleteCommentInput = {
  id: Scalars['String'];
};

export type DeleteContentTagInput = {
  id: Scalars['ID'];
};

export type DeleteRecommenderColumnSpecInput = {
  columnName: Scalars['String'];
  recommenderId: Scalars['ID'];
};

export type DeleteRecommenderInput = {
  id: Scalars['ID'];
};

export type DeleteUserInput = {
  id: Scalars['ID'];
};

export type DesynchronizeDecisionTreeNodeInput = {
  nodeId: Scalars['ID'];
  parentId: Scalars['ID'];
};

export type Detection = {
  __typename?: 'Detection';
  ASRText?: Maybe<Scalars['String']>;
  cardId?: Maybe<Scalars['ID']>;
  command?: Maybe<AsrCommand>;
  commandId: Scalars['String'];
  creationDate: Scalars['String'];
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  model: Scalars['String'];
  projectId: Scalars['ID'];
  scope?: Maybe<CardScope>;
  session: Session;
  sessionId: Scalars['ID'];
  status?: Maybe<DetectionStatus>;
};

export type DetectionConnection = {
  __typename?: 'DetectionConnection';
  items: Array<Detection>;
  nextToken?: Maybe<Scalars['String']>;
  scannedCount: Scalars['Int'];
};

export type DetectionCount = {
  __typename?: 'DetectionCount';
  command?: Maybe<AsrCommand>;
  commandId: Scalars['ID'];
  count: Scalars['Int'];
  date: Scalars['String'];
  projectId: Scalars['ID'];
  projectUserCommandIndex: Scalars['String'];
  userId: Scalars['ID'];
};

export type DetectionCountConnection = {
  __typename?: 'DetectionCountConnection';
  items: Array<DetectionCount>;
  nextToken?: Maybe<Scalars['String']>;
  scannedCount: Scalars['Int'];
};

export type DetectionFilterInput = {
  ASRText?: InputMaybe<TableStringFilterInput>;
  commandId?: InputMaybe<TableIdFilterInput>;
  status?: InputMaybe<TableDetectionStatusFilterInput>;
};

export type DetectionQueryInput = {
  date?: InputMaybe<TableIntFilterInput>;
  projectId: TableIdFilterInput;
};

export enum DetectionStatus {
  Bad = 'BAD',
  Good = 'GOOD',
  Noise = 'NOISE'
}

export type DisableIntegrationInput = {
  type: IntegrationType;
};

export type Display = {
  __typename?: 'Display';
  card: Card;
  cardId: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
  detection?: Maybe<Detection>;
  detectionId?: Maybe<Scalars['ID']>;
  displayType: DisplayType;
  feedback?: Maybe<Feedback>;
  id: Scalars['ID'];
  isVisible?: Maybe<Scalars['Boolean']>;
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
  sessionId?: Maybe<Scalars['ID']>;
  user: Scalars['ID'];
};

export type DisplayOriginRepartition = {
  __typename?: 'DisplayOriginRepartition';
  CardLink?: Maybe<Scalars['Int']>;
  ClientDisplay?: Maybe<Scalars['Int']>;
  Detection?: Maybe<Scalars['Int']>;
  Favorite?: Maybe<Scalars['Int']>;
  History?: Maybe<Scalars['Int']>;
  InitialDisplay?: Maybe<Scalars['Int']>;
  Search?: Maybe<Scalars['Int']>;
  SessionEndDisplay?: Maybe<Scalars['Int']>;
};

export enum DisplayType {
  CardLink = 'CardLink',
  ClientDisplay = 'ClientDisplay',
  Detection = 'Detection',
  Favorite = 'Favorite',
  History = 'History',
  InitialDisplay = 'InitialDisplay',
  Search = 'Search',
  SessionEndDisplay = 'SessionEndDisplay'
}

export type DissociateCommandInput = {
  cardId?: InputMaybe<Scalars['ID']>;
  commandId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type DuplicateCardInput = {
  id: Scalars['ID'];
  projectId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type DuplicateDecisionTreeInput = {
  decisionTreeId: Scalars['ID'];
  projectId?: InputMaybe<Scalars['ID']>;
};

export type DuplicateDecisionTreeNodeInput = {
  dissociate?: InputMaybe<Scalars['Boolean']>;
  nodeId: Scalars['ID'];
  parentId: Scalars['ID'];
  parentValue: Scalars['String'];
};

export type DuplicateProjectCommandInput = {
  commandId: Scalars['String'];
  newProjectId: Scalars['String'];
  projectId: Scalars['String'];
};

export type DuplicateProjectInput = {
  name: Scalars['String'];
  projectId: Scalars['ID'];
};

export type EnableIntegrationInput = {
  type: IntegrationType;
};

export type ExcelCardImporter = {
  __typename?: 'ExcelCardImporter';
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organisationId: Scalars['ID'];
  projects: Array<ExcelCardImporterProject>;
  status: ExcelCardImporterStatus;
  updatedAt?: Maybe<Scalars['Long']>;
  updatedBy?: Maybe<Scalars['ID']>;
};

export type ExcelCardImporterProject = {
  __typename?: 'ExcelCardImporterProject';
  id: Scalars['ID'];
  project: Project;
};

export enum ExcelCardImporterStatus {
  Failed = 'Failed',
  Init = 'Init',
  Processing = 'Processing',
  Success = 'Success'
}

export type ExcelExportInput = {
  endDate: Scalars['AWSTimestamp'];
  language: Scalars['String'];
  startDate: Scalars['AWSTimestamp'];
};

export enum ExcelStatType {
  Compliance = 'Compliance'
}

export type ExternalCall = {
  __typename?: 'ExternalCall';
  clientCard?: Maybe<Card>;
  cogneedDate?: Maybe<Scalars['Long']>;
  cogneedExternalClientId?: Maybe<Scalars['String']>;
  cogneedHangUpDate?: Maybe<Scalars['Long']>;
  cogneedId: Scalars['String'];
  cogneedOrganisationId?: Maybe<Scalars['String']>;
  cogneedPartner: Scalars['String'];
  cogneedPartnerProjectId?: Maybe<Scalars['String']>;
  cogneedPartnerUserId?: Maybe<Scalars['String']>;
  cogneedProjectId?: Maybe<Scalars['String']>;
  cogneedUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type FavoriteCard = {
  __typename?: 'FavoriteCard';
  card: Card;
  cardId: Scalars['ID'];
  organisationId: Scalars['String'];
  userId: Scalars['ID'];
};

export type FavoriteCardConnection = {
  __typename?: 'FavoriteCardConnection';
  items: Array<FavoriteCard>;
  nextToken?: Maybe<Scalars['String']>;
  scannedCount: Scalars['Int'];
};

export enum Feedback {
  Negative = 'Negative',
  Positive = 'Positive'
}

export type FeedbackCount = {
  __typename?: 'FeedbackCount';
  card: Card;
  cardId: Scalars['String'];
  date: Scalars['String'];
  numNegativeFeedbacks?: Maybe<Scalars['Int']>;
  numPositiveFeedbacks?: Maybe<Scalars['Int']>;
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type FeedbackCountConnection = {
  __typename?: 'FeedbackCountConnection';
  items: Array<FeedbackCount>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ForgotPasswordInput = {
  email: Scalars['String'];
  locale: Scalars['String'];
};

export type GenerateContentInput = {
  language: Scalars['String'];
  text: Scalars['String'];
};

export type GenerateContentResponse = {
  __typename?: 'GenerateContentResponse';
  text: Scalars['String'];
};

export type GenerateExcelStatUrlForStaffInput = {
  endDate: Scalars['Long'];
  projectId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Long'];
};

export type GenerateExcelStatUrlInput = {
  endDate: Scalars['Long'];
  language: Scalars['String'];
  projectId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Long'];
  type: ExcelStatType;
};

export type GetAudioInput = {
  id: Scalars['ID'];
};

export type GetCardInstanceInput = {
  cardId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type GetStatIdInput = {
  endDate: Scalars['Long'];
  projectId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Long'];
  teamId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type GetUploadUrlInput = {
  filePath: Scalars['String'];
  metadataMap?: InputMaybe<Scalars['String']>;
};

export type GetUserPerformanceStatsInput = {
  weeksAgo: Scalars['Int'];
};

export type GlobalStatId = StatId & {
  __typename?: 'GlobalStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
};


export type GlobalStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type IdInput = {
  id: Scalars['ID'];
};

export type InfiniteProjectQueryInput = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['ID']>;
  textSearch?: InputMaybe<Scalars['String']>;
};

export type InfiniteQueryInput = {
  limit: Scalars['Int'];
  nextToken?: InputMaybe<Scalars['String']>;
  textSearch?: InputMaybe<Scalars['String']>;
};

export type IntRangeFilter = {
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
};

export type Integration = {
  __typename?: 'Integration';
  createdAt: Scalars['AWSTimestamp'];
  createdBy: Scalars['ID'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  deletedBy?: Maybe<Scalars['ID']>;
  organisationId: Scalars['String'];
  type: IntegrationType;
};

export enum IntegrationPartner {
  Aircall = 'Aircall',
  Genesys = 'Genesys',
  Inocx = 'Inocx',
  OpenPhone = 'OpenPhone',
  Public = 'Public',
  Ringover = 'Ringover',
  Viadialog = 'Viadialog'
}

export enum IntegrationType {
  Aircall = 'AIRCALL',
  Inocx = 'INOCX',
  Ringover = 'RINGOVER'
}

export type InviteUserInput = {
  emails: Array<Scalars['String']>;
  locale: Scalars['String'];
  projectIds: Array<Scalars['ID']>;
  role: Scalars['Int'];
  teamsIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type LegacySettings = {
  __typename?: 'LegacySettings';
  expandPluginOnDetection: Scalars['Boolean'];
  pluginResetPosition: Scalars['Int'];
  userMaxDetection?: Maybe<Scalars['Int']>;
};

export type LinkInput = {
  sourceScopeId: Scalars['ID'];
  targetScopeId: Scalars['ID'];
};

export type ListAsrSessionTranscriptsInput = {
  embeddingSearch?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['ID'];
};

export type ListAsrSessionsEmbeddingSearchInput = {
  excludedSessionIds: Array<Scalars['ID']>;
  text: Scalars['String'];
};

export type ListAsrSessionsFiltersInput = {
  date?: InputMaybe<LongRangeFilter>;
  duration?: InputMaybe<IntRangeFilter>;
  projectId?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  userDisplayName?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ListAsrSessionsInput = {
  embeddingSearch?: InputMaybe<ListAsrSessionsEmbeddingSearchInput>;
  filters: ListAsrSessionsFiltersInput;
  from?: InputMaybe<Scalars['Int']>;
  size: Scalars['Int'];
};

export type ListCardGenerationTasksInput = {
  limit: Scalars['Int'];
  nextToken?: InputMaybe<Scalars['String']>;
};

export type ListContentRequestsInput = {
  assigneeFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  stateFilter?: InputMaybe<ContentRequestState>;
  textSearch?: InputMaybe<Scalars['String']>;
};

export type ListIntegration = {
  __typename?: 'ListIntegration';
  items: Array<Integration>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ListSessionEventsOfUserWithTopicInput = {
  endDate: Scalars['Long'];
  eventType: SessionEventType;
  limit: Scalars['Int'];
  nextToken?: InputMaybe<Scalars['String']>;
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
  startDate: Scalars['Long'];
  topicTextLower: Scalars['String'];
  userId: Scalars['ID'];
};

export type ListStatIdsInput = {
  element: StatElement;
  endDate: Scalars['Long'];
  filters: StatIdFilterInput;
  startDate: Scalars['Long'];
};

export enum LiveNotificationType {
  BrowserNotification = 'BrowserNotification',
  FocusWindow = 'FocusWindow'
}

export type LlmMessage = {
  content: Scalars['String'];
  role: LlmMessageRole;
};

export enum LlmMessageRole {
  Assistant = 'Assistant',
  System = 'System',
  User = 'User'
}

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LongRangeFilter = {
  from?: InputMaybe<Scalars['Long']>;
  to?: InputMaybe<Scalars['Long']>;
};

export type MandatoryTopic = {
  __typename?: 'MandatoryTopic';
  complianceExample?: Maybe<Scalars['String']>;
  conditionTopics?: Maybe<Array<ConditionTopic>>;
  createdAt: Scalars['AWSTimestamp'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  hasExample?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  minimumDuration?: Maybe<Scalars['Int']>;
  organisationId: Scalars['String'];
  projectCommands?: Maybe<ProjectCommandConnection>;
  projectId: Scalars['ID'];
  sessionStepCondition?: Maybe<MandatoryTopicSessionStep>;
  textLower: Scalars['String'];
  topic: Topic;
};

export enum MandatoryTopicSessionStep {
  ConversationEngaged = 'ConversationEngaged'
}

export type MetricsFilter = {
  endDate: Scalars['Long'];
  startDate: Scalars['Long'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeAllNotifications: Array<Notification>;
  acknowledgeNotification: Notification;
  addAutoStartUrl: Scalars['String'];
  addCardContentBlock: ContentBlockV2;
  /**   Links */
  addCardLink: CardLink;
  addCardTab: CardTabV2;
  /**   decision tree node */
  addDecisionTreeNodeChild: DecisionTreeNode;
  addProjectAssignment: ProjectAssignment;
  addProjectToExcelCardImporter: ExcelCardImporter;
  /**   Favorites */
  addToFavorite: FavoriteCard;
  annotateAudio: Detection;
  /**   Project */
  archiveProject: Project;
  archiveTopic: Topic;
  assignCatalog: Catalog;
  assignDecisionTreeToProject: DecisionTreeProject;
  assignNews: News;
  assignTeam: TeamMembership;
  checkCommand: Scalars['Boolean'];
  contentGenerationAssistant: ContentGenerationAssistantMutation;
  createCard?: Maybe<Card>;
  createCommandContext: CommandContext;
  createCommandNew?: Maybe<Command>;
  createComment: Comment;
  /**   Content Requests */
  createContentRequest: ContentRequest;
  createContentTag: ContentTag;
  createDecisionTree: DecisionTree;
  createDetection: Detection;
  createDisplay: Display;
  createExcelCardImporter: ExcelCardImporter;
  createExcelExport: Scalars['String'];
  createIntegration: Integration;
  createMandatoryTopic: MandatoryTopic;
  createNews: News;
  createProject: Project;
  /**   Project Command */
  createProjectCommand: ProjectCommand;
  createRecommender: Recommender;
  createRecommenderColumnSpec: RecommenderColumnSpec;
  createSession: Session;
  createTeam: Team;
  createTopic: Topic;
  deleteCard?: Maybe<CardDeleteOutput>;
  deleteCommand?: Maybe<Command>;
  deleteCommandContext: CommandContext;
  deleteComment: Comment;
  /**   Tags */
  deleteContentTag: ContentTag;
  deleteDecisionTree: DecisionTree;
  deleteExcelCardImporter: ExcelCardImporter;
  deleteMandatoryTopic: MandatoryTopic;
  deleteNews: News;
  deleteRecommender: Recommender;
  deleteRecommenderColumnSpec: RecommenderColumnSpec;
  deleteTeam: Team;
  deleteUser: User;
  desynchronizeDecisionTreeNode: DecisionTreeNode;
  disableIntegration: Integration;
  dissociateCommand: ProjectCommand;
  /**   new endpoints */
  duplicateCard: Card;
  duplicateDecisionTree: DecisionTree;
  duplicateDecisionTreeNode: DecisionTreeNode;
  duplicateProject: Project;
  duplicateProjectCommand: ProjectCommand;
  enableIntegration: Integration;
  generateContent: GenerateContentResponse;
  generateExcelStatUrl: Scalars['String'];
  generateExcelStatUrlForStaff: Scalars['String'];
  generateMvpCardsFromPdf: MvpGeneratedCardsFromPdf;
  generateToken: Scalars['String'];
  getAudio: Scalars['String'];
  getRecommendation: Recommendation;
  inviteUsers: Array<User>;
  promptLlm: Scalars['String'];
  /**   Library */
  publish: CardScope;
  publishCatalog: Catalog;
  removeAutoStartUrl: Scalars['String'];
  removeCardContentBlock: ContentBlockV2;
  removeCardLink: CardLink;
  removeCardTab: CardTabV2;
  removeDecisionTreeNodeChild: DecisionTreeNode;
  removeFromFavorite: FavoriteCard;
  removeProjectAssignment: ProjectAssignment;
  removeProjectFromExcelCardImporter: ExcelCardImporter;
  renameCard: Card;
  renameCardTab: CardTabV2;
  renameCatalog: Catalog;
  renameCatalogColumn: Catalog;
  /**   clean up */
  renameProject: Project;
  reorderCardContentBlocks: CardTabV2;
  reorderCardTabs: CardContentV2;
  reorderDecisionTreeNodeChildren: DecisionTreeNode;
  resendInvitation: User;
  revertCatalog: Catalog;
  setIntegrations: Organisation;
  /**   decision tree run */
  startDecisionTreeRun: DecisionTreeRun;
  startLlmModel: Scalars['Boolean'];
  stopLlmModel: Scalars['Boolean'];
  subscribeAlerting: ProjectAlertingSubscription;
  transcript: TranscriptMutation;
  transfer: Card;
  transitionContentRequest: ContentRequest;
  unassignCatalog: Catalog;
  unassignDecisionTreeToProject: DecisionTreeProject;
  unassignNews: News;
  unassignTeam: TeamMembership;
  unpublish: CardScope;
  unpublishCatalog: Catalog;
  unsubscribeAlerting: ProjectAlertingSubscription;
  updateCard?: Maybe<Card>;
  updateCardContentBlock: ContentBlockV2;
  updateCatalogDraft: Catalog;
  updateCommandNew?: Maybe<Command>;
  updateCommandRequest: CommandRequest;
  updateComment: Comment;
  updateDecisionTree: DecisionTree;
  updateDecisionTreeNode: DecisionTreeNode;
  updateDecisionTreeNodeChildValue: DecisionTreeNode;
  updateDecisionTreeNodeColor: DecisionTreeNode;
  updateDecisionTreeRunHistory: DecisionTreeRun;
  updateDisplay: Display;
  updateDisplayFeedback: Display;
  updateExcelCardImporter: ExcelCardImporter;
  updateLastEmailSent: User;
  updateMandatoryTopic: MandatoryTopic;
  updateNews: News;
  updatePassword: User;
  updatePersonalInfo: User;
  updateProject: Project;
  updateProjectCommand: ProjectCommand;
  updatePushSubscription: User;
  updateRecommender: Recommender;
  updateRecommenderColumnSpec: RecommenderColumnSpec;
  updateSessionDuration2: Session;
  updateStripeInfo: Scalars['Boolean'];
  updateTeam: Team;
  updateTopicColor: Topic;
  updateTopicThreshold: Topic;
  updateUserPermissions: User;
  updateUserSettings: User;
  writeDecisionTreeRunComment: DecisionTreeRun;
};


export type MutationAcknowledgeNotificationArgs = {
  input: AcknowledgeNotificationInput;
};


export type MutationAddAutoStartUrlArgs = {
  input: UpdateAutoStartUrlInput;
};


export type MutationAddCardContentBlockArgs = {
  input: AddCardContentBlockInput;
};


export type MutationAddCardLinkArgs = {
  input: LinkInput;
};


export type MutationAddCardTabArgs = {
  input: AddCardTabInput;
};


export type MutationAddDecisionTreeNodeChildArgs = {
  input: AddDecisionTreeNodeInput;
};


export type MutationAddProjectAssignmentArgs = {
  input: AddProjectAssignmentInput;
};


export type MutationAddProjectToExcelCardImporterArgs = {
  input: AddProjectToExcelCardImporterInput;
};


export type MutationAddToFavoriteArgs = {
  cardId: Scalars['ID'];
};


export type MutationAnnotateAudioArgs = {
  input: AnnotateAudioInput;
};


export type MutationArchiveProjectArgs = {
  input: ArchiveProjectInput;
};


export type MutationArchiveTopicArgs = {
  input: ArchiveTopicInput;
};


export type MutationAssignCatalogArgs = {
  input: ProjectAssignmentInput;
};


export type MutationAssignDecisionTreeToProjectArgs = {
  input: DecisionTreeProjectInput;
};


export type MutationAssignNewsArgs = {
  input: NewsAssignmentInput;
};


export type MutationAssignTeamArgs = {
  input: AssignmentInput;
};


export type MutationCheckCommandArgs = {
  input: CheckCommandInput;
};


export type MutationCreateCardArgs = {
  input: CreateCardInput;
};


export type MutationCreateCommandContextArgs = {
  input: CreateCommandContextInput;
};


export type MutationCreateCommandNewArgs = {
  input: CreateCommandNewInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateContentRequestArgs = {
  input: CreateContentRequestInput;
};


export type MutationCreateContentTagArgs = {
  input: CreateContentTagInput;
};


export type MutationCreateDecisionTreeArgs = {
  input: CreateDecisionTreeInput;
};


export type MutationCreateDetectionArgs = {
  input: CreateDetectionInput;
};


export type MutationCreateDisplayArgs = {
  input: CreateDisplayInput;
};


export type MutationCreateExcelCardImporterArgs = {
  input: CreateExcelCardImporterInput;
};


export type MutationCreateExcelExportArgs = {
  input: ExcelExportInput;
};


export type MutationCreateIntegrationArgs = {
  input?: InputMaybe<CreateIntegrationInput>;
};


export type MutationCreateMandatoryTopicArgs = {
  input: CreateMandatoryTopicInput;
};


export type MutationCreateNewsArgs = {
  input: CreateNewsInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateProjectCommandArgs = {
  input: CreateProjectCommandInput;
};


export type MutationCreateRecommenderArgs = {
  input: CreateRecommenderInput;
};


export type MutationCreateRecommenderColumnSpecArgs = {
  input: CreateRecommenderColumnSpecInput;
};


export type MutationCreateSessionArgs = {
  input?: InputMaybe<CreateSessionInput>;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateTopicArgs = {
  input: CreateTopicInput;
};


export type MutationDeleteCardArgs = {
  input: DeleteCardInput;
};


export type MutationDeleteCommandArgs = {
  input: DeleteCommandInput;
};


export type MutationDeleteCommandContextArgs = {
  input: DeleteCommandContextInput;
};


export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


export type MutationDeleteContentTagArgs = {
  input: DeleteContentTagInput;
};


export type MutationDeleteDecisionTreeArgs = {
  input: IdInput;
};


export type MutationDeleteExcelCardImporterArgs = {
  input: IdInput;
};


export type MutationDeleteMandatoryTopicArgs = {
  input: IdInput;
};


export type MutationDeleteNewsArgs = {
  input: IdInput;
};


export type MutationDeleteRecommenderArgs = {
  input: DeleteRecommenderInput;
};


export type MutationDeleteRecommenderColumnSpecArgs = {
  input: DeleteRecommenderColumnSpecInput;
};


export type MutationDeleteTeamArgs = {
  input: IdInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDesynchronizeDecisionTreeNodeArgs = {
  input: DesynchronizeDecisionTreeNodeInput;
};


export type MutationDisableIntegrationArgs = {
  input?: InputMaybe<DisableIntegrationInput>;
};


export type MutationDissociateCommandArgs = {
  input: DissociateCommandInput;
};


export type MutationDuplicateCardArgs = {
  input: DuplicateCardInput;
};


export type MutationDuplicateDecisionTreeArgs = {
  input: DuplicateDecisionTreeInput;
};


export type MutationDuplicateDecisionTreeNodeArgs = {
  input: DuplicateDecisionTreeNodeInput;
};


export type MutationDuplicateProjectArgs = {
  input: DuplicateProjectInput;
};


export type MutationDuplicateProjectCommandArgs = {
  input: DuplicateProjectCommandInput;
};


export type MutationEnableIntegrationArgs = {
  input?: InputMaybe<EnableIntegrationInput>;
};


export type MutationGenerateContentArgs = {
  input: GenerateContentInput;
};


export type MutationGenerateExcelStatUrlArgs = {
  input: GenerateExcelStatUrlInput;
};


export type MutationGenerateExcelStatUrlForStaffArgs = {
  input: GenerateExcelStatUrlForStaffInput;
};


export type MutationGenerateMvpCardsFromPdfArgs = {
  input?: InputMaybe<Scalars['String']>;
};


export type MutationGetAudioArgs = {
  input: GetAudioInput;
};


export type MutationGetRecommendationArgs = {
  input: RecommenderQueryInput;
};


export type MutationInviteUsersArgs = {
  input: InviteUserInput;
};


export type MutationPromptLlmArgs = {
  input: PromptLlmInput;
};


export type MutationPublishArgs = {
  input: PublishInput;
};


export type MutationPublishCatalogArgs = {
  input: IdInput;
};


export type MutationRemoveAutoStartUrlArgs = {
  input: UpdateAutoStartUrlInput;
};


export type MutationRemoveCardContentBlockArgs = {
  input: RemoveCardContentBlockInput;
};


export type MutationRemoveCardLinkArgs = {
  input: LinkInput;
};


export type MutationRemoveCardTabArgs = {
  input: RemoveCardTabInput;
};


export type MutationRemoveDecisionTreeNodeChildArgs = {
  input: RemoveDecisionTreeNodeChildInput;
};


export type MutationRemoveFromFavoriteArgs = {
  cardId: Scalars['ID'];
};


export type MutationRemoveProjectAssignmentArgs = {
  input: RemoveProjectAssignmentInput;
};


export type MutationRemoveProjectFromExcelCardImporterArgs = {
  input: AddProjectToExcelCardImporterInput;
};


export type MutationRenameCardArgs = {
  input: RenameCardInput;
};


export type MutationRenameCardTabArgs = {
  input: RenameCardTabInput;
};


export type MutationRenameCatalogArgs = {
  input: RenameCatalogInput;
};


export type MutationRenameCatalogColumnArgs = {
  input: RenameCatalogColumnInput;
};


export type MutationRenameProjectArgs = {
  input: RenameProjectInput;
};


export type MutationReorderCardContentBlocksArgs = {
  input: ReorderCardContentBlocksInput;
};


export type MutationReorderCardTabsArgs = {
  input: ReorderCardTabsInput;
};


export type MutationReorderDecisionTreeNodeChildrenArgs = {
  input: ReorderDecisionTreeNodeChildrenInput;
};


export type MutationResendInvitationArgs = {
  input: ResendInvitationInput;
};


export type MutationRevertCatalogArgs = {
  input: IdInput;
};


export type MutationSetIntegrationsArgs = {
  input: SetIntegrationsInput;
};


export type MutationStartDecisionTreeRunArgs = {
  input: StartDecisionTreeRunInput;
};


export type MutationStartLlmModelArgs = {
  input: ContentGenerationModel;
};


export type MutationSubscribeAlertingArgs = {
  input: IdInput;
};


export type MutationTransferArgs = {
  cardId: Scalars['ID'];
};


export type MutationTransitionContentRequestArgs = {
  input: TransitionContentRequestInput;
};


export type MutationUnassignCatalogArgs = {
  input: ProjectAssignmentInput;
};


export type MutationUnassignDecisionTreeToProjectArgs = {
  input: DecisionTreeProjectInput;
};


export type MutationUnassignNewsArgs = {
  input: NewsAssignmentInput;
};


export type MutationUnassignTeamArgs = {
  input: AssignmentInput;
};


export type MutationUnpublishArgs = {
  input: PublishInput;
};


export type MutationUnpublishCatalogArgs = {
  input: IdInput;
};


export type MutationUnsubscribeAlertingArgs = {
  input: IdInput;
};


export type MutationUpdateCardArgs = {
  input: UpdateCardInput;
};


export type MutationUpdateCardContentBlockArgs = {
  input: UpdateCardContentBlockInput;
};


export type MutationUpdateCatalogDraftArgs = {
  input: UpdateCatalogDraftInput;
};


export type MutationUpdateCommandNewArgs = {
  input: UpdateCommandNewInput;
};


export type MutationUpdateCommandRequestArgs = {
  input: UpdateCommandRequestInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateDecisionTreeArgs = {
  input: UpdateDecisionTreeInput;
};


export type MutationUpdateDecisionTreeNodeArgs = {
  input: UpdateDecisionTreeNodeInput;
};


export type MutationUpdateDecisionTreeNodeChildValueArgs = {
  input: UpdateDecisionTreeNodeChildValueInput;
};


export type MutationUpdateDecisionTreeNodeColorArgs = {
  input: UpdateDecisionTreeNodeColorInput;
};


export type MutationUpdateDecisionTreeRunHistoryArgs = {
  input: UpdateDecisionTreeRunHistoryInput;
};


export type MutationUpdateDisplayArgs = {
  input: UpdateDisplayInput;
};


export type MutationUpdateDisplayFeedbackArgs = {
  input: UpdateDisplayFeedbackInput;
};


export type MutationUpdateExcelCardImporterArgs = {
  input: UpdateExcelCardImporterInput;
};


export type MutationUpdateLastEmailSentArgs = {
  input: IdInput;
};


export type MutationUpdateMandatoryTopicArgs = {
  input: UpdateMandatoryTopicInput;
};


export type MutationUpdateNewsArgs = {
  input: UpdateNewsInput;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdatePersonalInfoArgs = {
  input: UpdatePersonalInfoInput;
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


export type MutationUpdateProjectCommandArgs = {
  input: UpdateProjectCommandInput;
};


export type MutationUpdatePushSubscriptionArgs = {
  input: UpdatePushSubscriptionInput;
};


export type MutationUpdateRecommenderArgs = {
  input: UpdateRecommenderInput;
};


export type MutationUpdateRecommenderColumnSpecArgs = {
  input: CreateRecommenderColumnSpecInput;
};


export type MutationUpdateSessionDuration2Args = {
  input: UpateSessionInput;
};


export type MutationUpdateStripeInfoArgs = {
  input: UpdateStripeInfoInput;
};


export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationUpdateTopicColorArgs = {
  input: UpdateTopicColorInput;
};


export type MutationUpdateTopicThresholdArgs = {
  input: UpdateTopicThresholdInput;
};


export type MutationUpdateUserPermissionsArgs = {
  input: UpdateUserPermissionsInput;
};


export type MutationUpdateUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};


export type MutationWriteDecisionTreeRunCommentArgs = {
  input: WriteDecisionTreeRunCommentInput;
};

export type MvpGeneratedCard = {
  __typename?: 'MvpGeneratedCard';
  content: Scalars['String'];
  title: Scalars['String'];
};

export type MvpGeneratedCardsFromPdf = {
  __typename?: 'MvpGeneratedCardsFromPdf';
  cards: Array<MvpGeneratedCard>;
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  deletedAt?: Maybe<Scalars['Long']>;
  organisationId: Scalars['String'];
  pdfPath: Scalars['String'];
  status: Scalars['String'];
  topics: Array<Scalars['String']>;
  updatedAt: Scalars['Long'];
};

export type News = {
  __typename?: 'News';
  content: Scalars['String'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  endDate?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  organisationId: Scalars['String'];
  projectIds: Array<Scalars['ID']>;
  publications: Array<NewsPublication>;
  startDate?: Maybe<Scalars['Long']>;
  status: NewsStatus;
  title: Scalars['String'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
};

export type NewsAssignmentInput = {
  id: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type NewsConnection = {
  __typename?: 'NewsConnection';
  items: Array<News>;
  nextToken?: Maybe<Scalars['String']>;
};

export type NewsPublication = {
  __typename?: 'NewsPublication';
  projectId: Scalars['ID'];
};

export enum NewsStatus {
  Draft = 'Draft',
  Published = 'Published'
}

export type Notification = {
  __typename?: 'Notification';
  acknowledgeDate?: Maybe<Scalars['AWSTimestamp']>;
  date: Scalars['AWSTimestamp'];
  event: NotificationEvent;
  eventId: Scalars['ID'];
  organisationId: Scalars['String'];
  userId: Scalars['ID'];
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  items: Array<Notification>;
  nextToken?: Maybe<Scalars['String']>;
};

export type NotificationEvent = {
  __typename?: 'NotificationEvent';
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['ID']>;
  card?: Maybe<Card>;
  cardId?: Maybe<Scalars['ID']>;
  command?: Maybe<Command>;
  commandId?: Maybe<Scalars['ID']>;
  contentRequest?: Maybe<ContentRequest>;
  contentRequestCounter?: Maybe<Scalars['Int']>;
  date: Scalars['AWSTimestamp'];
  eventType?: Maybe<NotificationType>;
  id: Scalars['ID'];
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
  organisationId: Scalars['String'];
  project?: Maybe<Project>;
  projectCommand?: Maybe<ProjectCommand>;
  projectId?: Maybe<Scalars['ID']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
};

export enum NotificationType {
  AvailableCommand = 'AvailableCommand',
  CardComment = 'CardComment',
  CommandRequestStatusChanged = 'CommandRequestStatusChanged',
  CommentReply = 'CommentReply',
  ContentRequestCommented = 'ContentRequestCommented',
  ContentRequestCreated = 'ContentRequestCreated',
  ContentRequestUpdated = 'ContentRequestUpdated',
  NewContent = 'NewContent',
  ProjectAssigned = 'ProjectAssigned',
  UserConfirmed = 'UserConfirmed',
  UserInvited = 'UserInvited',
  UserRoleChanged = 'UserRoleChanged'
}

export type NumberIdInput = {
  id: Scalars['Int'];
};

export type Organisation = {
  __typename?: 'Organisation';
  aircallIntegration?: Maybe<Scalars['Boolean']>;
  autoStartUrls?: Maybe<Array<Scalars['String']>>;
  date: Scalars['AWSTimestamp'];
  defaultAudioSettings_enableAudioAutoGainControl?: Maybe<Scalars['Boolean']>;
  defaultAudioSettings_enableAudioEchoCancellation?: Maybe<Scalars['Boolean']>;
  defaultAudioSettings_enableAudioNoiseSuppression?: Maybe<Scalars['Boolean']>;
  enableAlternativeAsrApi?: Maybe<Scalars['Boolean']>;
  enableCoreAsrApi?: Maybe<Scalars['Boolean']>;
  enableFeature_coveredCallStatistics?: Maybe<Scalars['Boolean']>;
  enableFeature_phrasingPerformance?: Maybe<Scalars['Boolean']>;
  enableFeature_useNewAudioEncoding?: Maybe<Scalars['Boolean']>;
  enableFeature_wysiwygTerminationFeeComputation?: Maybe<Scalars['Boolean']>;
  excelCardImports: Array<ExcelCardImporter>;
  freezeStripeSeats?: Maybe<Scalars['Boolean']>;
  genesysIntegration?: Maybe<Scalars['Boolean']>;
  inocxIntegration?: Maybe<Scalars['Boolean']>;
  invitation?: Maybe<Scalars['AWSJSON']>;
  licenseBillingOverride?: Maybe<Scalars['Boolean']>;
  minLicenses: Scalars['Int'];
  name: Scalars['String'];
  numSeats?: Maybe<Scalars['Int']>;
  openPhoneIntegration?: Maybe<Scalars['Boolean']>;
  preferHttpConnection?: Maybe<Scalars['Boolean']>;
  ringoverIntegration?: Maybe<Scalars['Boolean']>;
  sharepointTenantId?: Maybe<Scalars['String']>;
  skipStripe?: Maybe<Scalars['Boolean']>;
  slackToken?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInterval?: Maybe<Scalars['String']>;
  subscription?: Maybe<StripeSubscription>;
  uploadedDocuments?: Maybe<UploadedDocumentsConnection>;
  viadialogIntegration?: Maybe<Scalars['Boolean']>;
};


export type OrganisationUploadedDocumentsArgs = {
  input?: InputMaybe<InfiniteQueryInput>;
};

export type PhrasingSubject = {
  __typename?: 'PhrasingSubject';
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  createdByUser?: Maybe<User>;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mostDifferentSentences: Array<Transcript>;
  name: Scalars['String'];
  nameTextLower: Scalars['String'];
  organisationId: Scalars['String'];
  projectIds: Array<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['Long']>;
  updatedBy?: Maybe<Scalars['String']>;
  wordings: Array<Wording>;
};

export type PhrasingSubjectConnection = {
  __typename?: 'PhrasingSubjectConnection';
  items: Array<PhrasingSubject>;
  nextToken?: Maybe<Scalars['String']>;
};

export type PhrasingSubjectConnectionRecord = {
  __typename?: 'PhrasingSubjectConnectionRecord';
  items: Array<PhrasingSubjectRecord>;
  nextToken?: Maybe<Scalars['String']>;
};

export type PhrasingSubjectMutation = {
  __typename?: 'PhrasingSubjectMutation';
  addWording: PhrasingSubject;
  assign: PhrasingSubject;
  create: PhrasingSubject;
  delete: PhrasingSubject;
  removeWording: PhrasingSubject;
  unassign: PhrasingSubject;
  update: PhrasingSubject;
};


export type PhrasingSubjectMutationAddWordingArgs = {
  input: AddWordingInput;
};


export type PhrasingSubjectMutationAssignArgs = {
  input: AssignmentInput;
};


export type PhrasingSubjectMutationCreateArgs = {
  input: CreatePhrasingSubjectInput;
};


export type PhrasingSubjectMutationDeleteArgs = {
  input: IdInput;
};


export type PhrasingSubjectMutationRemoveWordingArgs = {
  input: RemoveWordingInput;
};


export type PhrasingSubjectMutationUnassignArgs = {
  input: AssignmentInput;
};


export type PhrasingSubjectMutationUpdateArgs = {
  input: UpdatePhrasingSubjectInput;
};

export type PhrasingSubjectRecord = {
  __typename?: 'PhrasingSubjectRecord';
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameTextLower: Scalars['String'];
  organisationId: Scalars['String'];
  projectIds: Array<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['Long']>;
  updatedBy?: Maybe<Scalars['String']>;
  wordings: Array<Wording>;
};

export type PhrasingSubjectStatId = StatId & {
  __typename?: 'PhrasingSubjectStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  phrasingSubjectId: Scalars['ID'];
  startDate: Scalars['Long'];
};


export type PhrasingSubjectStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type PhrasingSubjectWordingStatId = StatId & {
  __typename?: 'PhrasingSubjectWordingStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  phrasingSubjectId: Scalars['ID'];
  startDate: Scalars['Long'];
  wordingId: Scalars['ID'];
};


export type PhrasingSubjectWordingStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type Project = {
  __typename?: 'Project';
  archived: Scalars['Boolean'];
  asrLanguage: Scalars['String'];
  autoStartUrls?: Maybe<Array<Scalars['String']>>;
  cardCommandCount: Scalars['Int'];
  cardCount: Scalars['Int'];
  commandContexts: Array<CommandContext>;
  commands: ProjectCommandConnection;
  complianceTopics: Array<MandatoryTopic>;
  date: Scalars['AWSTimestamp'];
  decisionTrees: Array<DecisionTree>;
  decisionTreesCount: Scalars['Int'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  detectionCounts: DetectionCountConnection;
  formulationTopicCount: Scalars['Int'];
  id: Scalars['ID'];
  isSubscriber: Scalars['Boolean'];
  ksModelId?: Maybe<Scalars['ID']>;
  listProjectSessionSummaries: SessionSummaryConnection;
  mandatoryTopicCount: Scalars['Int'];
  name: Scalars['String'];
  organisationId: Scalars['String'];
  scopeCount: Scalars['Int'];
  scopes: ScopeConnection;
  search: SearchResults;
  sessionEndCard?: Maybe<CardScope>;
  sessionEndCardId?: Maybe<Scalars['String']>;
  sessions: SessionSummaryConnection;
  topics: Array<Topic>;
  trackingCommandCount: Scalars['Int'];
};


export type ProjectComplianceTopicsArgs = {
  input: BooleanInput;
};


export type ProjectDetectionCountsArgs = {
  date: TableStringFilterInput;
};


export type ProjectListProjectSessionSummariesArgs = {
  date: TableStringFilterInput;
};


export type ProjectScopesArgs = {
  includeImported?: InputMaybe<Scalars['Boolean']>;
  maxDeletedDate?: InputMaybe<Scalars['String']>;
};


export type ProjectSearchArgs = {
  input: CardSearchInput;
};


export type ProjectSessionsArgs = {
  date: TableStringFilterInput;
};

export type ProjectAlertingSubscription = {
  __typename?: 'ProjectAlertingSubscription';
  deleteDate?: Maybe<Scalars['AWSTimestamp']>;
  deletedBy?: Maybe<Scalars['ID']>;
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type ProjectAssignment = {
  __typename?: 'ProjectAssignment';
  author?: Maybe<Scalars['ID']>;
  deleteDate?: Maybe<Scalars['AWSTimestamp']>;
  deletedBy?: Maybe<Scalars['ID']>;
  organisationId?: Maybe<Scalars['String']>;
  projectId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type ProjectAssignmentConnection = {
  __typename?: 'ProjectAssignmentConnection';
  items: Array<ProjectAssignment>;
};

export type ProjectAssignmentInput = {
  id: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type ProjectCommand = {
  __typename?: 'ProjectCommand';
  card?: Maybe<Card>;
  cardCommandContexts: Array<ProjectCommandContext>;
  cardId?: Maybe<Scalars['ID']>;
  category?: Maybe<Category>;
  command: Command;
  commandContextTextLower?: Maybe<Scalars['String']>;
  commandId: Scalars['ID'];
  compliance?: Maybe<CommandComplianceType>;
  date: Scalars['AWSTimestamp'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  detectionCounts: DetectionCountConnection;
  isAlerting?: Maybe<Scalars['Boolean']>;
  organisationId: Scalars['ID'];
  permissiveMatching?: Maybe<Scalars['Boolean']>;
  project: Project;
  projectId: Scalars['ID'];
  topic?: Maybe<Topic>;
  topicTextLower?: Maybe<Scalars['String']>;
  triggeredContext?: Maybe<CommandContext>;
  userId: Scalars['ID'];
};


export type ProjectCommandDetectionCountsArgs = {
  date: TableStringFilterInput;
};

export type ProjectCommandConnection = {
  __typename?: 'ProjectCommandConnection';
  items: Array<ProjectCommand>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ProjectCommandContext = {
  __typename?: 'ProjectCommandContext';
  card: Card;
  cardId: Scalars['String'];
  commandContextTextLower: Scalars['String'];
  commandId: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Long']>;
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
  projectId_commandId: Scalars['ID'];
};

export type ProjectStatId = StatId & {
  __typename?: 'ProjectStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  project: Project;
  projectId: Scalars['ID'];
  startDate: Scalars['Long'];
};


export type ProjectStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type PromptLlmInput = {
  inputs: Array<LlmMessage>;
  parameters?: InputMaybe<PromptLlmParametersInput>;
};

export type PromptLlmParametersInput = {
  max_new_tokens?: InputMaybe<Scalars['Int']>;
  repetition_penalty?: InputMaybe<Scalars['Float']>;
  temperature?: InputMaybe<Scalars['Float']>;
};

export type PublishInput = {
  cardId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type Query = {
  __typename?: 'Query';
  availableUsedCommands: Array<Command>;
  contentGenerationAssistant: ContentGenerationAssistantQuery;
  getAsrCommand?: Maybe<AsrCommand>;
  getCard?: Maybe<Card>;
  getCardCount: Scalars['Int'];
  getCardInstance: CardScope;
  getCatalog: Catalog;
  getCatalogUploadUrl: Scalars['String'];
  getCommand: Command;
  getCommandAssociation?: Maybe<CardCommand>;
  getContentRequest: ContentRequest;
  getDecisionTree: DecisionTree;
  getDecisionTreeNode: DecisionTreeNode;
  /**   decision tree run */
  getDecisionTreeRun: DecisionTreeRun;
  getDetection: Detection;
  /**   display */
  getDisplay: Display;
  getDocumentUploadUrl: Scalars['String'];
  getExcelCardImporterUploadUrl: Scalars['String'];
  /**   Content generation */
  getLlmEndpointStatus?: Maybe<SagemakerModel>;
  getMvpGeneratedCardsFromPdf?: Maybe<MvpGeneratedCardsFromPdf>;
  getNotification: Notification;
  getOrganisation: Organisation;
  getPhrasingSubject: PhrasingSubject;
  getProject: Project;
  getRandomRow: Scalars['String'];
  getRecommender: Recommender;
  getRecommenderDatasetUploadUrl: Scalars['String'];
  getSession: Session;
  getStatId: StatId;
  getTeam: Team;
  getUserInfo: User;
  getUserPerformanceStats: UserPerformanceStats;
  listAllUploadedDocuments?: Maybe<UploadedDocumentsConnection>;
  listAsrCommands: AsrCommandConnection;
  listAsrSessionTranscripts: TranscriptConnection;
  listAsrSessions: AsrSessionConnection;
  listAssociatedCommandsNew: ProjectCommandConnection;
  listAvailableTopics: TopicConnection;
  listCardGenerationTasks: CardGenerationTaskConnection;
  /**  Card Project Content Statistics */
  listCardProjectFeedbackCounts: FeedbackCountConnection;
  listCatalogs: CatalogConnection;
  listCommandRequests: CommandRequestConnection;
  listCommands: CommandConnection;
  /**   Content Requests */
  listContentRequests: ContentRequestConnection;
  listContentTags: ContentTagConnection;
  listCurrentNews: Array<News>;
  listDecisionTrees: Array<DecisionTree>;
  listDetections: DetectionConnection;
  listFavoriteCards: FavoriteCardConnection;
  listInfiniteUsers: UserConnection;
  listIntegration: ListIntegration;
  listOrgCards: CardConnection;
  listOrgLibraryCards: CardConnection;
  listOrganisationNews: NewsConnection;
  listOrganisations: Array<Organisation>;
  listOrganizationTopics: TopicConnection;
  listPhrasingSubjects: PhrasingSubjectConnection;
  listProjectCards: ScopeConnection;
  listProjects: Array<Project>;
  listRecommenders: RecommenderConnection;
  listSessionEventsOfUserWithTopic: SessionEventConnection;
  listSessions: SessionConnection;
  listStatIds: StatIdConnection;
  listTeams: TeamConnection;
  listUserDetections: DetectionConnection;
  /**  User Project Content Statistics */
  listUserProjectFeedbackCounts: FeedbackCountConnection;
  /**   Org Statistics */
  listUserSessionSummaries: SessionSummaryConnection;
  /**  Project Session Statistics */
  listUserSessions: SessionConnection;
  listUsers: Array<User>;
  queryComments: CommentConnection;
  queryIdentityNotifications: NotificationConnection;
};


export type QueryAvailableUsedCommandsArgs = {
  input: Scalars['ID'];
};


export type QueryGetAsrCommandArgs = {
  id: Scalars['ID'];
};


export type QueryGetCardArgs = {
  id: Scalars['ID'];
};


export type QueryGetCardCountArgs = {
  date?: InputMaybe<TableLongFilterInput>;
};


export type QueryGetCardInstanceArgs = {
  input: GetCardInstanceInput;
};


export type QueryGetCatalogArgs = {
  input: IdInput;
};


export type QueryGetCatalogUploadUrlArgs = {
  input: GetUploadUrlInput;
};


export type QueryGetCommandArgs = {
  input: IdInput;
};


export type QueryGetCommandAssociationArgs = {
  commandId: Scalars['ID'];
  projectId: Scalars['ID'];
};


export type QueryGetContentRequestArgs = {
  input: NumberIdInput;
};


export type QueryGetDecisionTreeArgs = {
  input: IdInput;
};


export type QueryGetDecisionTreeNodeArgs = {
  input: IdInput;
};


export type QueryGetDecisionTreeRunArgs = {
  input: IdInput;
};


export type QueryGetDetectionArgs = {
  id: Scalars['ID'];
};


export type QueryGetDisplayArgs = {
  input: IdInput;
};


export type QueryGetDocumentUploadUrlArgs = {
  input: UploadUrlInput;
};


export type QueryGetExcelCardImporterUploadUrlArgs = {
  input: IdInput;
};


export type QueryGetMvpGeneratedCardsFromPdfArgs = {
  input: Scalars['Int'];
};


export type QueryGetNotificationArgs = {
  id: Scalars['ID'];
};


export type QueryGetPhrasingSubjectArgs = {
  input: IdInput;
};


export type QueryGetProjectArgs = {
  input: IdInput;
};


export type QueryGetRandomRowArgs = {
  input: IdInput;
};


export type QueryGetRecommenderArgs = {
  input: IdInput;
};


export type QueryGetRecommenderDatasetUploadUrlArgs = {
  input: IdInput;
};


export type QueryGetSessionArgs = {
  input: IdInput;
};


export type QueryGetStatIdArgs = {
  input: GetStatIdInput;
};


export type QueryGetTeamArgs = {
  input: IdInput;
};


export type QueryListAllUploadedDocumentsArgs = {
  input?: InputMaybe<InfiniteQueryInput>;
};


export type QueryListAsrCommandsArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type QueryListAsrSessionTranscriptsArgs = {
  input: ListAsrSessionTranscriptsInput;
};


export type QueryListAsrSessionsArgs = {
  input: ListAsrSessionsInput;
};


export type QueryListAssociatedCommandsNewArgs = {
  cardId?: InputMaybe<Scalars['ID']>;
  projectId: Scalars['ID'];
};


export type QueryListAvailableTopicsArgs = {
  input?: InputMaybe<IdInput>;
};


export type QueryListCardGenerationTasksArgs = {
  input: ListCardGenerationTasksInput;
};


export type QueryListCardProjectFeedbackCountsArgs = {
  cardId: Scalars['ID'];
  date: TableStringFilterInput;
  projectId?: InputMaybe<Scalars['ID']>;
};


export type QueryListCatalogsArgs = {
  input: InfiniteProjectQueryInput;
};


export type QueryListCommandRequestsArgs = {
  nextToken?: InputMaybe<Scalars['String']>;
  status: CommandRequestStatus;
};


export type QueryListCommandsArgs = {
  language: Scalars['String'];
  nextToken?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};


export type QueryListContentRequestsArgs = {
  input?: InputMaybe<ListContentRequestsInput>;
};


export type QueryListContentTagsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryListCurrentNewsArgs = {
  input: IdInput;
};


export type QueryListDetectionsArgs = {
  filter?: InputMaybe<DetectionFilterInput>;
  limit: Scalars['Int'];
  nextToken?: InputMaybe<Scalars['String']>;
  query: DetectionQueryInput;
};


export type QueryListFavoriteCardsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryListInfiniteUsersArgs = {
  input: InfiniteQueryInput;
};


export type QueryListOrgCardsArgs = {
  input?: InputMaybe<DateInput>;
};


export type QueryListOrganisationNewsArgs = {
  input?: InputMaybe<InfiniteQueryInput>;
};


export type QueryListOrganizationTopicsArgs = {
  input?: InputMaybe<InfiniteQueryInput>;
};


export type QueryListPhrasingSubjectsArgs = {
  input?: InputMaybe<InfiniteProjectQueryInput>;
};


export type QueryListProjectCardsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
};


export type QueryListProjectsArgs = {
  organisationId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['ID']>;
};


export type QueryListRecommendersArgs = {
  input: QueryRecommendersInput;
};


export type QueryListSessionEventsOfUserWithTopicArgs = {
  input: ListSessionEventsOfUserWithTopicInput;
};


export type QueryListSessionsArgs = {
  filter?: InputMaybe<SessionFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryListStatIdsArgs = {
  input: ListStatIdsInput;
};


export type QueryListTeamsArgs = {
  input?: InputMaybe<InfiniteQueryInput>;
};


export type QueryListUserDetectionsArgs = {
  date: TableLongFilterInput;
};


export type QueryListUserProjectFeedbackCountsArgs = {
  date: TableStringFilterInput;
  projectId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type QueryListUserSessionSummariesArgs = {
  date: TableStringFilterInput;
};


export type QueryListUserSessionsArgs = {
  date: TableLongFilterInput;
  projectId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type QueryListUsersArgs = {
  organisationId?: InputMaybe<Scalars['String']>;
};


export type QueryQueryCommentsArgs = {
  id: Scalars['ID'];
};


export type QueryQueryIdentityNotificationsArgs = {
  nextToken?: InputMaybe<Scalars['String']>;
};

export type QueryRecommendersInput = {
  nameContains?: InputMaybe<Scalars['String']>;
  nextToken?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['String']>;
};

export type Recommendation = {
  __typename?: 'Recommendation';
  nextAttribute?: Maybe<RecommenderColumnSpec>;
};

export type Recommender = {
  __typename?: 'Recommender';
  author: User;
  columnSpecs: Array<RecommenderColumnSpec>;
  columns?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  datasetSummary: DatasetSummary;
  deletedAt?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organisationId: Scalars['String'];
  showNumbers?: Maybe<Scalars['Boolean']>;
  target?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
};


export type RecommenderDatasetSummaryArgs = {
  input: RecommenderQueryInput;
};

export enum RecommenderColumnDisplayType {
  Image = 'Image',
  Link = 'Link',
  Text = 'Text'
}

export type RecommenderColumnSpec = {
  author: User;
  columnName: Scalars['String'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  disabled?: Maybe<Scalars['Boolean']>;
  displayName: Scalars['String'];
  displayOnly?: Maybe<Scalars['Boolean']>;
  displayType?: Maybe<RecommenderColumnDisplayType>;
  histogram: RecommenderHistogram;
  recommenderId: Scalars['ID'];
  text: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
};


export type RecommenderColumnSpecHistogramArgs = {
  input: RecommenderQueryInput;
};

export type RecommenderColumnSpecDisplayInput = {
  displayOnly?: InputMaybe<Scalars['Boolean']>;
  displayType: RecommenderColumnDisplayType;
};

export type RecommenderConnection = {
  __typename?: 'RecommenderConnection';
  items: Array<Recommender>;
  nextToken?: Maybe<Scalars['String']>;
};

export type RecommenderHistogram = {
  __typename?: 'RecommenderHistogram';
  bars: Array<RecommenderHistogramBar>;
};

export type RecommenderHistogramBar = {
  __typename?: 'RecommenderHistogramBar';
  count: Scalars['Int'];
  selected?: Maybe<Scalars['Boolean']>;
  value: Scalars['String'];
};

export type RecommenderNumberColumnSpec = RecommenderColumnSpec & {
  __typename?: 'RecommenderNumberColumnSpec';
  author: User;
  columnName: Scalars['String'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  disabled?: Maybe<Scalars['Boolean']>;
  displayName: Scalars['String'];
  displayOnly?: Maybe<Scalars['Boolean']>;
  displayType?: Maybe<RecommenderColumnDisplayType>;
  histogram: RecommenderHistogram;
  max: Scalars['Float'];
  min: Scalars['Float'];
  recommenderId: Scalars['ID'];
  splits: Array<Scalars['Float']>;
  step: Scalars['Float'];
  text: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
};


export type RecommenderNumberColumnSpecHistogramArgs = {
  input: RecommenderQueryInput;
};

export type RecommenderNumberColumnSpecInput = {
  max: Scalars['Float'];
  min: Scalars['Float'];
  splits: Array<Scalars['Float']>;
  step: Scalars['Float'];
};

export type RecommenderQueryInput = {
  filters: Array<AttributeFilter>;
  recommenderId: Scalars['ID'];
};

export type RecommenderStringColumnSpec = RecommenderColumnSpec & {
  __typename?: 'RecommenderStringColumnSpec';
  author: User;
  columnName: Scalars['String'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  disabled?: Maybe<Scalars['Boolean']>;
  displayName: Scalars['String'];
  displayOnly?: Maybe<Scalars['Boolean']>;
  displayType?: Maybe<RecommenderColumnDisplayType>;
  histogram: RecommenderHistogram;
  recommenderId: Scalars['ID'];
  text: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
};


export type RecommenderStringColumnSpecHistogramArgs = {
  input: RecommenderQueryInput;
};

export type RecommenderStringColumnSpecInput = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  displayName: Scalars['String'];
  text: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
};

export type RelativeMetric = {
  __typename?: 'RelativeMetric';
  denominator: Scalars['Int'];
  numerator: Scalars['Int'];
  ratio: Scalars['Float'];
};

export type RemoveAssistantDocumentInput = {
  assistantId: Scalars['ID'];
  documentName: Scalars['String'];
};

export type RemoveCardContentBlockInput = {
  blockId: Scalars['ID'];
  cardId: Scalars['ID'];
  tabId: Scalars['ID'];
};

export type RemoveCardScopeInput = {
  cardId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type RemoveCardTabInput = {
  cardId: Scalars['ID'];
  tabId: Scalars['ID'];
};

export type RemoveDecisionTreeNodeChildInput = {
  id: Scalars['ID'];
  parentId: Scalars['ID'];
};

export type RemoveProjectAssignmentInput = {
  projectId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type RemoveWordingInput = {
  phrasingSubjectId: Scalars['ID'];
  wordingId: Scalars['String'];
};

export type RenameCardInput = {
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type RenameCardTabInput = {
  cardId: Scalars['ID'];
  tabId: Scalars['ID'];
  title: Scalars['String'];
};

export type RenameCatalogColumnInput = {
  columnName: Scalars['String'];
  id: Scalars['ID'];
  newName: Scalars['String'];
};

export type RenameCatalogInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

/**   clean up */
export type RenameProjectInput = {
  name: Scalars['String'];
  projectId: Scalars['ID'];
};

export type RenamedColumn = {
  __typename?: 'RenamedColumn';
  newName: Scalars['String'];
  originName: Scalars['String'];
};

export type ReorderCardContentBlocksInput = {
  blockId: Scalars['ID'];
  cardId: Scalars['ID'];
  newIndex: Scalars['Int'];
  tabId: Scalars['ID'];
};

export type ReorderCardTabsInput = {
  cardId: Scalars['ID'];
  newIndex: Scalars['Int'];
  tabId: Scalars['ID'];
};

export type ReorderDecisionTreeNodeChildrenInput = {
  id: Scalars['ID'];
  newIndex: Scalars['Int'];
  parentId: Scalars['ID'];
};

export type ResendInvitationInput = {
  id: Scalars['ID'];
  locale: Scalars['String'];
};

export type ResetPasswordInput = {
  password: Scalars['String'];
};

export type SagemakerModel = {
  __typename?: 'SagemakerModel';
  model: ContentGenerationModel;
  status: SagemakerModelStatus;
};

export enum SagemakerModelStatus {
  Creating = 'Creating',
  Deleting = 'Deleting',
  Failed = 'Failed',
  InService = 'InService',
  OutOfService = 'OutOfService',
  RollingBack = 'RollingBack',
  SystemUpdating = 'SystemUpdating',
  UpdateRollbackFailed = 'UpdateRollbackFailed',
  Updating = 'Updating'
}

export type ScopeConnection = {
  __typename?: 'ScopeConnection';
  items: Array<CardScope>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum SearchMatchType {
  CardTitle = 'CardTitle',
  Content = 'Content',
  TabTitle = 'TabTitle'
}

export type SearchResult = {
  __typename?: 'SearchResult';
  cardId: Scalars['ID'];
  cardTitle: Scalars['String'];
  contentMatch?: Maybe<Scalars['String']>;
  contentMatches?: Maybe<Array<Scalars['String']>>;
  matchType: SearchMatchType;
  tabId?: Maybe<Scalars['ID']>;
  tabTitle?: Maybe<Scalars['String']>;
  tabTitleMatch?: Maybe<Scalars['String']>;
  /**   legacy to delete */
  textMatch: Scalars['String'];
  titleMatch?: Maybe<Scalars['String']>;
};

export type SearchResults = {
  __typename?: 'SearchResults';
  count: Scalars['Int'];
  items: Array<SearchResult>;
  nextItem?: Maybe<Scalars['Int']>;
};

export type Session = {
  __typename?: 'Session';
  alternativeTranscript?: Maybe<Array<Transcript>>;
  conversationEngagedAt?: Maybe<Scalars['Long']>;
  date: Scalars['AWSTimestamp'];
  detections: Array<Detection>;
  duration: Scalars['Int'];
  endCause?: Maybe<Scalars['String']>;
  externalCall?: Maybe<ExternalCall>;
  externalCallId?: Maybe<Scalars['ID']>;
  finishedAt?: Maybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  lastUpdate?: Maybe<Scalars['String']>;
  notation?: Maybe<Scalars['Int']>;
  organisationId: Scalars['String'];
  project: Project;
  projectId: Scalars['ID'];
  updatedAt?: Maybe<Scalars['Long']>;
  user: Scalars['ID'];
  whisperTranscript?: Maybe<Array<Transcript>>;
};

export type SessionConnection = {
  __typename?: 'SessionConnection';
  items: Array<Session>;
  nextToken?: Maybe<Scalars['String']>;
};

export type SessionEvent = {
  __typename?: 'SessionEvent';
  date: Scalars['Long'];
  id: Scalars['ID'];
  mention?: Maybe<SessionTopicMention>;
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
  required?: Maybe<SessionTopicRequired>;
  session: Session;
  sessionId: Scalars['ID'];
  topic: Topic;
  topicTextLower: Scalars['String'];
  userId: Scalars['ID'];
};

export type SessionEventConnection = {
  __typename?: 'SessionEventConnection';
  items: Array<SessionEvent>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum SessionEventType {
  FormulationTopicMentioned = 'FormulationTopicMentioned',
  TopicRequired = 'TopicRequired'
}

export type SessionFilterInput = {
  date?: InputMaybe<TableIntFilterInput>;
  id?: InputMaybe<TableIdFilterInput>;
  organisationId?: InputMaybe<TableStringFilterInput>;
  user?: InputMaybe<TableStringFilterInput>;
};

export type SessionStatId = StatId & {
  __typename?: 'SessionStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  session: Session;
  sessionId: Scalars['ID'];
  startDate: Scalars['Long'];
};


export type SessionStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type SessionSummary = {
  __typename?: 'SessionSummary';
  count: Scalars['Int'];
  date: Scalars['String'];
  duration: Scalars['Int'];
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
  userId: Scalars['String'];
};

export type SessionSummaryConnection = {
  __typename?: 'SessionSummaryConnection';
  items: Array<SessionSummary>;
  nextToken?: Maybe<Scalars['String']>;
};

export type SessionTopicMention = {
  __typename?: 'SessionTopicMention';
  detectedCommand: Command;
  detectedCommandId: Scalars['String'];
  formulationScore?: Maybe<CommandComplianceType>;
  topicMentionedAt: Scalars['Long'];
  topicMentionedVerbatim: Scalars['String'];
};

export type SessionTopicRequired = {
  topicRequiredAt: Scalars['Long'];
};

export type SessionTopicRequiredByConditionTopics = SessionTopicRequired & {
  __typename?: 'SessionTopicRequiredByConditionTopics';
  conditionTopics: Array<ConditionTopic>;
  topicRequiredAt: Scalars['Long'];
};

export type SessionTopicRequiredByDuration = SessionTopicRequired & {
  __typename?: 'SessionTopicRequiredByDuration';
  minDuration: Scalars['Int'];
  topicRequiredAt: Scalars['Long'];
};

export type SessionTopicRequiredBySessionStep = SessionTopicRequired & {
  __typename?: 'SessionTopicRequiredBySessionStep';
  sessionStep: MandatoryTopicSessionStep;
  topicRequiredAt: Scalars['Long'];
};

export type SetIntegrationsInput = {
  aircallIntegration?: InputMaybe<Scalars['Boolean']>;
  genesysIntegration?: InputMaybe<Scalars['Boolean']>;
  inocxIntegration?: InputMaybe<Scalars['Boolean']>;
  openPhoneIntegration?: InputMaybe<Scalars['Boolean']>;
  ringoverIntegration?: InputMaybe<Scalars['Boolean']>;
  viadialogIntegration?: InputMaybe<Scalars['Boolean']>;
};

export type StartDecisionTreeRunInput = {
  id: Scalars['ID'];
  isPreviewRun?: InputMaybe<Scalars['Boolean']>;
  sessionId?: InputMaybe<Scalars['ID']>;
};

export enum StatElement {
  Card = 'Card',
  Command = 'Command',
  FormulationTopic = 'FormulationTopic',
  MandatoryTopic = 'MandatoryTopic',
  PhrasingSubject = 'PhrasingSubject',
  PhrasingSubjectWording = 'PhrasingSubjectWording',
  Project = 'Project',
  Session = 'Session',
  Topic = 'Topic',
  User = 'User'
}

export type StatId = {
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
};


export type StatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type StatIdConnection = {
  __typename?: 'StatIdConnection';
  items?: Maybe<Array<StatId>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type StatIdFilterInput = {
  cardId?: InputMaybe<Scalars['ID']>;
  commandCategory?: InputMaybe<Category>;
  commandId?: InputMaybe<Scalars['String']>;
  importedCards?: InputMaybe<Scalars['Boolean']>;
  projectId?: InputMaybe<Scalars['ID']>;
  sessionId?: InputMaybe<Scalars['ID']>;
  teamId?: InputMaybe<Scalars['ID']>;
  topicTextLower?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type StatIdFilters = {
  __typename?: 'StatIdFilters';
  cardId?: Maybe<Scalars['ID']>;
  commandCategory?: Maybe<Category>;
  commandId?: Maybe<Scalars['String']>;
  importedCards?: Maybe<Scalars['Boolean']>;
  projectId?: Maybe<Scalars['ID']>;
  sessionId?: Maybe<Scalars['ID']>;
  teamId?: Maybe<Scalars['ID']>;
  topicTextLower?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type StatMetricConnection = {
  __typename?: 'StatMetricConnection';
  items?: Maybe<Array<StatMetrics>>;
};

export type StatMetricFilterInput = {
  endDate: Scalars['Long'];
};

export type StatMetrics = WithMetrics & {
  __typename?: 'StatMetrics';
  compliancyCompletedCount?: Maybe<Scalars['Int']>;
  compliancyRequiredCount?: Maybe<Scalars['Int']>;
  compliancyRequiredSessionCount?: Maybe<Scalars['Int']>;
  compliantSessionCount?: Maybe<Scalars['Int']>;
  date: Scalars['String'];
  detectionCount?: Maybe<Scalars['Int']>;
  displayCount?: Maybe<Scalars['Int']>;
  displayOriginRepartition?: Maybe<DisplayOriginRepartition>;
  externalCallCoveredDuration?: Maybe<Scalars['Long']>;
  externalCallDuration?: Maybe<Scalars['Long']>;
  externalCalls?: Maybe<Scalars['Long']>;
  externalCallsCovered?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  negativeFeedbackCount?: Maybe<Scalars['Int']>;
  notRecommendedComplianceCount?: Maybe<Scalars['Int']>;
  numDaysWithSession?: Maybe<Scalars['Int']>;
  positiveFeedbackCount?: Maybe<Scalars['Int']>;
  recommendedComplianceCount?: Maybe<Scalars['Int']>;
  sessionCount?: Maybe<Scalars['Int']>;
  sessionDuration?: Maybe<Scalars['Long']>;
  type: Scalars['String'];
  visibleDisplayCount?: Maybe<Scalars['Int']>;
  visibleDisplayOriginRepartition?: Maybe<DisplayOriginRepartition>;
  wordingSuccessCount?: Maybe<Scalars['Int']>;
  wordingUtteranceCount?: Maybe<Scalars['Int']>;
};

export type StripeAddress = {
  __typename?: 'StripeAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type StripeBillingInfo = {
  __typename?: 'StripeBillingInfo';
  address?: Maybe<StripeAddress>;
  name: Scalars['String'];
  preferredLocale: Scalars['String'];
};

export type StripeCard = {
  __typename?: 'StripeCard';
  brand: Scalars['String'];
  last4: Scalars['String'];
};

export type StripeNextPayment = {
  __typename?: 'StripeNextPayment';
  amount: Scalars['Float'];
  date: Scalars['Int'];
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  billingInfo?: Maybe<StripeBillingInfo>;
  card?: Maybe<StripeCard>;
  endOfTrial?: Maybe<Scalars['Int']>;
  nextPayment: StripeNextPayment;
  numSeats: Scalars['Int'];
  paymentIntent?: Maybe<Scalars['String']>;
  productDescription: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  addedDetection?: Maybe<Detection>;
};


export type SubscriptionAddedDetectionArgs = {
  sessionId: Scalars['String'];
};

export type TableBooleanFilterInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  eq?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
};

export type TableDetectionStatusFilterInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  eq?: InputMaybe<DetectionStatus>;
};

export type TableFloatFilterInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  contains?: InputMaybe<Scalars['Float']>;
  eq?: InputMaybe<Scalars['Float']>;
  ge?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  le?: InputMaybe<Scalars['Float']>;
  lt?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  notContains?: InputMaybe<Scalars['Float']>;
};

export type TableIdFilterInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  beginsWith?: InputMaybe<Scalars['ID']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contains?: InputMaybe<Scalars['ID']>;
  eq?: InputMaybe<Scalars['ID']>;
  ge?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  le?: InputMaybe<Scalars['ID']>;
  lt?: InputMaybe<Scalars['ID']>;
  ne?: InputMaybe<Scalars['ID']>;
  notContains?: InputMaybe<Scalars['ID']>;
};

export type TableIntFilterInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  contains?: InputMaybe<Scalars['Int']>;
  eq?: InputMaybe<Scalars['Int']>;
  ge?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  le?: InputMaybe<Scalars['Int']>;
  lt?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  notContains?: InputMaybe<Scalars['Int']>;
};

export type TableLongFilterInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['AWSTimestamp']>>>;
  contains?: InputMaybe<Scalars['AWSTimestamp']>;
  eq?: InputMaybe<Scalars['AWSTimestamp']>;
  ge?: InputMaybe<Scalars['AWSTimestamp']>;
  gt?: InputMaybe<Scalars['AWSTimestamp']>;
  le?: InputMaybe<Scalars['AWSTimestamp']>;
  lt?: InputMaybe<Scalars['AWSTimestamp']>;
  ne?: InputMaybe<Scalars['AWSTimestamp']>;
  notContains?: InputMaybe<Scalars['AWSTimestamp']>;
};

export type TableStringFilterInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  beginsWith?: InputMaybe<Scalars['String']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  ge?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  le?: InputMaybe<Scalars['String']>;
  lt?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  notContains?: InputMaybe<Scalars['String']>;
};

export type TableTagFilterInput = {
  author?: InputMaybe<TableIdFilterInput>;
  contentId?: InputMaybe<TableIdFilterInput>;
  date?: InputMaybe<TableIntFilterInput>;
  deletedAt?: InputMaybe<TableIntFilterInput>;
  deletedBy?: InputMaybe<TableIdFilterInput>;
  id?: InputMaybe<TableIdFilterInput>;
  organisationId?: InputMaybe<TableStringFilterInput>;
  text?: InputMaybe<TableStringFilterInput>;
};

export type Team = {
  __typename?: 'Team';
  color: Scalars['String'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  memberCount: Scalars['Int'];
  members: Array<TeamMembership>;
  organisationId: Scalars['ID'];
  title: Scalars['String'];
  titleLowerCase: Scalars['String'];
  updatedAt: Scalars['Long'];
};

export type TeamConnection = {
  __typename?: 'TeamConnection';
  items: Array<Team>;
  nextToken?: Maybe<Scalars['String']>;
};

export type TeamMembership = {
  __typename?: 'TeamMembership';
  deletedAt?: Maybe<Scalars['Long']>;
  organisationId: Scalars['ID'];
  team: Team;
  teamId: Scalars['ID'];
  user: User;
  userId: Scalars['ID'];
};

export type Topic = {
  __typename?: 'Topic';
  color: Scalars['String'];
  createdAt: Scalars['AWSTimestamp'];
  createdBy?: Maybe<Scalars['ID']>;
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  mandatoryTopic?: Maybe<MandatoryTopic>;
  organisationId: Scalars['ID'];
  projectCommands?: Maybe<ProjectCommandConnection>;
  text: Scalars['String'];
  textLower: Scalars['String'];
  threshold: TopicThreshold;
  user?: Maybe<User>;
};


export type TopicMandatoryTopicArgs = {
  input: IdInput;
};


export type TopicProjectCommandsArgs = {
  input?: InputMaybe<IdInput>;
};

export type TopicComplianceStat = {
  __typename?: 'TopicComplianceStat';
  current: RelativeMetric;
  previous?: Maybe<RelativeMetric>;
  topic: Topic;
  topicTextLower: Scalars['String'];
};

export type TopicConnection = {
  __typename?: 'TopicConnection';
  items: Array<Topic>;
  nextToken?: Maybe<Scalars['String']>;
};

export type TopicStatId = StatId & {
  __typename?: 'TopicStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
  topic?: Maybe<Topic>;
  topicTextLower?: Maybe<Scalars['String']>;
};


export type TopicStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type TopicThreshold = {
  __typename?: 'TopicThreshold';
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export type Transcript = {
  __typename?: 'Transcript';
  duration?: Maybe<Scalars['Long']>;
  score?: Maybe<Scalars['Float']>;
  text: Scalars['String'];
  timestamp: Scalars['Long'];
};

export type TranscriptConnection = {
  __typename?: 'TranscriptConnection';
  transcripts: Array<Transcript>;
};

export type TranscriptMutation = {
  __typename?: 'TranscriptMutation';
  phrasingSubject: PhrasingSubjectMutation;
};

export type TransitionContentRequestInput = {
  assigneeId?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  counter: Scalars['Int'];
  state?: InputMaybe<ContentRequestState>;
};

export type UpateSessionInput = {
  duration: Scalars['Int'];
  endCause?: InputMaybe<Scalars['String']>;
  endSession?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type UpdateAsrCommandInput = {
  alternatives: Array<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  language: Scalars['String'];
  levenshteinDistance: Scalars['String'];
  name: Scalars['String'];
  prefixSize: Scalars['Int'];
};

export type UpdateAutoStartUrlInput = {
  projectId?: InputMaybe<Scalars['ID']>;
  url: Scalars['String'];
};

export type UpdateCardContentBlockInput = {
  blockId: Scalars['ID'];
  cardId: Scalars['ID'];
  content?: InputMaybe<Scalars['String']>;
  displayType?: InputMaybe<ContentBlockDisplayType>;
  tabId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateCardInput = {
  expirationDate?: InputMaybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateCardMetaInput = {
  expirationDate?: InputMaybe<Scalars['AWSTimestamp']>;
  isLibrary?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCatalogDraftInput = {
  content: Scalars['String'];
  id: Scalars['ID'];
};

export type UpdateCommandNewInput = {
  alternatives?: InputMaybe<Array<Scalars['String']>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  forbiddenWordings?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  onlyAlternative?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCommandRequestInput = {
  commandId: Scalars['ID'];
  organisationId: Scalars['ID'];
  status: CommandRequestStatus;
};

export type UpdateCommentInput = {
  content: Scalars['String'];
  id: Scalars['String'];
};

export type UpdateDecisionTreeInput = {
  allowComments?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateDecisionTreeNodeChildValueInput = {
  childID: Scalars['ID'];
  childValue: Scalars['String'];
  id: Scalars['ID'];
};

export type UpdateDecisionTreeNodeColorInput = {
  color: Scalars['String'];
  id: Scalars['ID'];
};

export type UpdateDecisionTreeNodeInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  richText?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DecisionTreeNodeType>;
};

export type UpdateDecisionTreeRunHistoryInput = {
  id: Scalars['ID'];
  nodeHistory: Array<Scalars['String']>;
};

export type UpdateDisplayFeedbackInput = {
  feedback?: InputMaybe<Feedback>;
  id: Scalars['ID'];
};

export type UpdateDisplayInput = {
  feedback?: InputMaybe<Feedback>;
  id: Scalars['ID'];
  isVisible?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateExcelCardImporterInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateMandatoryTopicInput = {
  complianceExample?: InputMaybe<Scalars['String']>;
  conditionTopics?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  minimumDuration?: InputMaybe<Scalars['Int']>;
  sessionStepCondition?: InputMaybe<MandatoryTopicSessionStep>;
};

export type UpdateNewsInput = {
  content?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Long']>;
  id: Scalars['ID'];
  startDate?: InputMaybe<Scalars['Long']>;
  status?: InputMaybe<NewsStatus>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdatePasswordInput = {
  oldPassword: Scalars['String'];
  password: Scalars['String'];
};

export type UpdatePersonalInfoInput = {
  displayName: Scalars['String'];
};

export type UpdatePhrasingSubjectInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateProjectCommandInput = {
  cardCommandContexts?: InputMaybe<Array<CardCommandContextInput>>;
  cardId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Category>;
  commandContextTextLower?: InputMaybe<Scalars['String']>;
  commandId: Scalars['String'];
  compliance?: InputMaybe<CommandComplianceType>;
  isAlerting?: InputMaybe<Scalars['Boolean']>;
  permissiveMatching?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
  topicTextLower?: InputMaybe<Scalars['String']>;
};

export type UpdateProjectInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  sessionEndCardId?: InputMaybe<Scalars['String']>;
};

export type UpdatePushSubscriptionInput = {
  locale: Scalars['String'];
  pushSubscription: Scalars['String'];
};

export type UpdateRecommenderInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['String']>;
};

export type UpdateStripeInfoInput = {
  name: Scalars['String'];
  preferredLocale: Scalars['String'];
};

export type UpdateTeamInput = {
  color?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateTopicColorInput = {
  color: Scalars['String'];
  textLower: Scalars['String'];
};

export type UpdateTopicThresholdInput = {
  max: Scalars['Float'];
  min: Scalars['Float'];
  textLower: Scalars['String'];
};

export type UpdateUserNotificationSettingsInput = {
  notifyOnDetection?: InputMaybe<LiveNotificationType>;
  notifyOnExternalCall?: InputMaybe<LiveNotificationType>;
  notifyOnNewMandatoryTopic?: InputMaybe<LiveNotificationType>;
};

export type UpdateUserPermissionsInput = {
  id: Scalars['ID'];
  role: Scalars['Int'];
};

export type UpdateUserPreferencesSettingsInput = {
  recordDetection?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateUserSettingsInput = {
  expandPluginOnDetection?: InputMaybe<Scalars['Boolean']>;
  notifications?: InputMaybe<UpdateUserNotificationSettingsInput>;
  pluginResetPosition?: InputMaybe<Scalars['Int']>;
  preferences?: InputMaybe<UpdateUserPreferencesSettingsInput>;
  recordDetection?: InputMaybe<Scalars['Boolean']>;
  userMaxDetection?: InputMaybe<Scalars['Int']>;
};

export type UploadUrlInput = {
  fileType: Scalars['String'];
  id: Scalars['String'];
  metadataMap?: InputMaybe<Scalars['String']>;
  update: Scalars['Boolean'];
};

export type UploadedDocuments = {
  __typename?: 'UploadedDocuments';
  date: Scalars['Long'];
  name: Scalars['String'];
  size: Scalars['Int'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export type UploadedDocumentsConnection = {
  __typename?: 'UploadedDocumentsConnection';
  items: Array<UploadedDocuments>;
  nextToken?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  appSettings?: Maybe<UserSettings>;
  assignments: ProjectAssignmentConnection;
  deletedAt?: Maybe<Scalars['Long']>;
  detectionCounts: DetectionCountConnection;
  displayName: Scalars['String'];
  email: Scalars['String'];
  expandPluginOnDetection: Scalars['Boolean'];
  feedbackStats: FeedbackCountConnection;
  id: Scalars['String'];
  invitedAt?: Maybe<Scalars['Long']>;
  invitedBy?: Maybe<Scalars['ID']>;
  isConfirmed: Scalars['Boolean'];
  isStaff: Scalars['Boolean'];
  lastCallsCounter: Scalars['Int'];
  lastEmailAt?: Maybe<Scalars['Long']>;
  lastExternalCallAt?: Maybe<Scalars['Long']>;
  latestSession?: Maybe<Session>;
  locale?: Maybe<Scalars['String']>;
  nonCoveredCallsCounter: Scalars['Int'];
  numNotifications?: Maybe<Scalars['Int']>;
  organisationId: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  pluginResetPosition: Scalars['Int'];
  pushSubscription?: Maybe<Scalars['String']>;
  recentDisplayCount?: Maybe<Scalars['Int']>;
  recentUsageDuration?: Maybe<Scalars['Int']>;
  recordDetection?: Maybe<Scalars['Boolean']>;
  role: Scalars['Int'];
  sessionStats: SessionSummaryConnection;
  settings: LegacySettings;
  slackId?: Maybe<Scalars['String']>;
  teamAssignmentCount: Scalars['Int'];
  teamAssignments: Array<TeamMembership>;
  updatedBy?: Maybe<Scalars['ID']>;
  userMaxDetection?: Maybe<Scalars['Int']>;
};


export type UserDetectionCountsArgs = {
  date: TableStringFilterInput;
  projectId?: InputMaybe<Scalars['ID']>;
};


export type UserFeedbackStatsArgs = {
  date: TableStringFilterInput;
  projectId?: InputMaybe<Scalars['ID']>;
};


export type UserSessionStatsArgs = {
  date: TableStringFilterInput;
  projectId?: InputMaybe<Scalars['ID']>;
};

export type UserComplianceStats = {
  __typename?: 'UserComplianceStats';
  current: RelativeMetric;
  previous?: Maybe<RelativeMetric>;
  table: Array<TopicComplianceStat>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  items: Array<User>;
  nextToken?: Maybe<Scalars['String']>;
};

export type UserEngagementMetrics = {
  __typename?: 'UserEngagementMetrics';
  sessionCount: Scalars['Int'];
  sessionDuration: Scalars['Int'];
  sessionDurationAverage?: Maybe<Scalars['Float']>;
};

export type UserEngagementStats = {
  __typename?: 'UserEngagementStats';
  current: UserEngagementMetrics;
  previous: UserEngagementMetrics;
};

export type UserNotificationSettings = {
  __typename?: 'UserNotificationSettings';
  notifyOnDetection?: Maybe<LiveNotificationType>;
  notifyOnExternalCall?: Maybe<LiveNotificationType>;
  notifyOnNewMandatoryTopic?: Maybe<LiveNotificationType>;
};

export type UserPerformanceStats = {
  __typename?: 'UserPerformanceStats';
  compliance?: Maybe<UserComplianceStats>;
  engagement?: Maybe<UserEngagementStats>;
  quality?: Maybe<UserComplianceStats>;
};


export type UserPerformanceStatsComplianceArgs = {
  input: GetUserPerformanceStatsInput;
};


export type UserPerformanceStatsEngagementArgs = {
  input: GetUserPerformanceStatsInput;
};


export type UserPerformanceStatsQualityArgs = {
  input: GetUserPerformanceStatsInput;
};

export type UserPreferenceSettings = {
  __typename?: 'UserPreferenceSettings';
  recordDetection?: Maybe<Scalars['Boolean']>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  notifications?: Maybe<UserNotificationSettings>;
  preferences?: Maybe<UserPreferenceSettings>;
};

export type UserStatId = StatId & {
  __typename?: 'UserStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
  user: User;
  userId: Scalars['ID'];
};


export type UserStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type WithMetrics = {
  compliancyRequiredCount?: Maybe<Scalars['Int']>;
  compliancyRequiredSessionCount?: Maybe<Scalars['Int']>;
  detectionCount?: Maybe<Scalars['Int']>;
  displayCount?: Maybe<Scalars['Int']>;
  displayOriginRepartition?: Maybe<DisplayOriginRepartition>;
  externalCallCoveredDuration?: Maybe<Scalars['Long']>;
  externalCallDuration?: Maybe<Scalars['Long']>;
  externalCalls?: Maybe<Scalars['Long']>;
  externalCallsCovered?: Maybe<Scalars['Long']>;
  notRecommendedComplianceCount?: Maybe<Scalars['Int']>;
  recommendedComplianceCount?: Maybe<Scalars['Int']>;
  sessionCount?: Maybe<Scalars['Int']>;
  sessionDuration?: Maybe<Scalars['Long']>;
  visibleDisplayCount?: Maybe<Scalars['Int']>;
  visibleDisplayOriginRepartition?: Maybe<DisplayOriginRepartition>;
  wordingSuccessCount?: Maybe<Scalars['Int']>;
  wordingUtteranceCount?: Maybe<Scalars['Int']>;
};

export type Wording = {
  __typename?: 'Wording';
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type WriteDecisionTreeRunCommentInput = {
  nodeId: Scalars['ID'];
  runId: Scalars['ID'];
  userComment: Scalars['String'];
};

export type CardSummaryFieldsFragment = { __typename?: 'Card', id: string, deletedAt?: any | null, updatedAt: any, title: string, expirationDate?: any | null };

export type ListLiveFavoriteCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListLiveFavoriteCardsQuery = { __typename?: 'Query', listFavoriteCards: { __typename?: 'FavoriteCardConnection', items: Array<{ __typename?: 'FavoriteCard', card: { __typename?: 'Card', id: string, deletedAt?: any | null, updatedAt: any, title: string, expirationDate?: any | null, scopes: { __typename?: 'ScopeConnection', items: Array<{ __typename?: 'CardScope', projectId: string }> } } }> } };

export type SearchResultFieldsFragment = { __typename?: 'SearchResult', cardId: string, tabId?: string | null, cardTitle: string, tabTitle?: string | null, titleMatch?: string | null, tabTitleMatch?: string | null, contentMatches?: Array<string> | null };

export type SearchCardsQueryVariables = Exact<{
  projectId: IdInput;
  input: CardSearchInput;
}>;


export type SearchCardsQuery = { __typename?: 'Query', getProject: { __typename?: 'Project', search: { __typename?: 'SearchResults', count: number, nextItem?: number | null, items: Array<{ __typename?: 'SearchResult', cardId: string, tabId?: string | null, cardTitle: string, tabTitle?: string | null, titleMatch?: string | null, tabTitleMatch?: string | null, contentMatches?: Array<string> | null }> } } };

export type ListLiveSearchableCardsQueryVariables = Exact<{
  input: IdInput;
}>;


export type ListLiveSearchableCardsQuery = { __typename?: 'Query', getProject: { __typename?: 'Project', scopes: { __typename?: 'ScopeConnection', items: Array<{ __typename?: 'CardScope', card: { __typename?: 'Card', id: string, deletedAt?: any | null, updatedAt: any, title: string, expirationDate?: any | null } }> } } };

export type BlockFieldsFragment = { __typename?: 'ContentBlockV2', id: string, title?: string | null, blockType: ContentBlockType, displayType: ContentBlockDisplayType, content: string };

export type TabFieldsFragment = { __typename?: 'CardTabV2', id: string, updatedAt: any, title: string, date: any, blocks: Array<{ __typename?: 'ContentBlockV2', id: string, title?: string | null, blockType: ContentBlockType, displayType: ContentBlockDisplayType, content: string }> };

export type CardLinkFieldsFragment = { __typename?: 'CardLink', sourceScopeId: string, targetScopeId: string, targetScope: { __typename?: 'CardScope', card: { __typename?: 'Card', id: string, deletedAt?: any | null, updatedAt: any, title: string, expirationDate?: any | null } } };

export type CardFieldsFragment = { __typename?: 'Card', id: string, title: string, updatedAt: any, deletedAt?: any | null, isLibrary?: boolean | null, expirationDate?: any | null, isFavorite?: boolean | null, content: { __typename?: 'CardContentV2', tabs: Array<{ __typename?: 'CardTabV2', id: string, updatedAt: any, title: string, date: any, blocks: Array<{ __typename?: 'ContentBlockV2', id: string, title?: string | null, blockType: ContentBlockType, displayType: ContentBlockDisplayType, content: string }> }> }, tags: { __typename?: 'ContentTagConnection', items: Array<{ __typename?: 'ContentTag', id: string, contentId: string, text: string }> } };

export type DetailedCardFieldsFragment = { __typename?: 'CardScope', projectId: string, cardId: string, deletedAt?: any | null, card: { __typename?: 'Card', id: string, title: string, updatedAt: any, deletedAt?: any | null, isLibrary?: boolean | null, expirationDate?: any | null, isFavorite?: boolean | null, content: { __typename?: 'CardContentV2', tabs: Array<{ __typename?: 'CardTabV2', id: string, updatedAt: any, title: string, date: any, blocks: Array<{ __typename?: 'ContentBlockV2', id: string, title?: string | null, blockType: ContentBlockType, displayType: ContentBlockDisplayType, content: string }> }> }, tags: { __typename?: 'ContentTagConnection', items: Array<{ __typename?: 'ContentTag', id: string, contentId: string, text: string }> } }, links: { __typename?: 'CardLinkConnection', items: Array<{ __typename?: 'CardLink', sourceScopeId: string, targetScopeId: string, targetScope: { __typename?: 'CardScope', card: { __typename?: 'Card', id: string, deletedAt?: any | null, updatedAt: any, title: string, expirationDate?: any | null } } }> } };

export type GetLiveCardQueryVariables = Exact<{
  cardId: Scalars['ID'];
  projectId: Scalars['ID'];
}>;


export type GetLiveCardQuery = { __typename?: 'Query', getCardInstance: { __typename?: 'CardScope', projectId: string, cardId: string, deletedAt?: any | null, card: { __typename?: 'Card', id: string, title: string, updatedAt: any, deletedAt?: any | null, isLibrary?: boolean | null, expirationDate?: any | null, isFavorite?: boolean | null, content: { __typename?: 'CardContentV2', tabs: Array<{ __typename?: 'CardTabV2', id: string, updatedAt: any, title: string, date: any, blocks: Array<{ __typename?: 'ContentBlockV2', id: string, title?: string | null, blockType: ContentBlockType, displayType: ContentBlockDisplayType, content: string }> }> }, tags: { __typename?: 'ContentTagConnection', items: Array<{ __typename?: 'ContentTag', id: string, contentId: string, text: string }> } }, links: { __typename?: 'CardLinkConnection', items: Array<{ __typename?: 'CardLink', sourceScopeId: string, targetScopeId: string, targetScope: { __typename?: 'CardScope', card: { __typename?: 'Card', id: string, deletedAt?: any | null, updatedAt: any, title: string, expirationDate?: any | null } } }> } } };

export type PreloadCardsQueryVariables = Exact<{
  input: IdInput;
}>;


export type PreloadCardsQuery = { __typename?: 'Query', getProject: { __typename?: 'Project', scopes: { __typename?: 'ScopeConnection', items: Array<{ __typename?: 'CardScope', projectId: string, cardId: string, deletedAt?: any | null, card: { __typename?: 'Card', id: string, title: string, updatedAt: any, deletedAt?: any | null, isLibrary?: boolean | null, expirationDate?: any | null, isFavorite?: boolean | null, content: { __typename?: 'CardContentV2', tabs: Array<{ __typename?: 'CardTabV2', id: string, updatedAt: any, title: string, date: any, blocks: Array<{ __typename?: 'ContentBlockV2', id: string, title?: string | null, blockType: ContentBlockType, displayType: ContentBlockDisplayType, content: string }> }> }, tags: { __typename?: 'ContentTagConnection', items: Array<{ __typename?: 'ContentTag', id: string, contentId: string, text: string }> } }, links: { __typename?: 'CardLinkConnection', items: Array<{ __typename?: 'CardLink', sourceScopeId: string, targetScopeId: string, targetScope: { __typename?: 'CardScope', card: { __typename?: 'Card', id: string, deletedAt?: any | null, updatedAt: any, title: string, expirationDate?: any | null } } }> } }> } } };

export type GetCardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCardQuery = { __typename?: 'Query', getCard?: { __typename?: 'Card', id: string, title: string } | null };

export type RemoveFromFavoriteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveFromFavoriteMutation = { __typename?: 'Mutation', removeFromFavorite: { __typename?: 'FavoriteCard', cardId: string } };

export type AddToFavoriteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AddToFavoriteMutation = { __typename?: 'Mutation', addToFavorite: { __typename?: 'FavoriteCard', cardId: string } };

export type GetLibraryCardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLibraryCardQuery = { __typename?: 'Query', getCard?: { __typename?: 'Card', id: string, title: string, updatedAt: any, deletedAt?: any | null, isLibrary?: boolean | null, expirationDate?: any | null, isFavorite?: boolean | null, content: { __typename?: 'CardContentV2', tabs: Array<{ __typename?: 'CardTabV2', id: string, updatedAt: any, title: string, date: any, blocks: Array<{ __typename?: 'ContentBlockV2', id: string, title?: string | null, blockType: ContentBlockType, displayType: ContentBlockDisplayType, content: string }> }> }, tags: { __typename?: 'ContentTagConnection', items: Array<{ __typename?: 'ContentTag', id: string, contentId: string, text: string }> } } | null };

export type ListLatestUpdateCardsQueryVariables = Exact<{
  input: IdInput;
}>;


export type ListLatestUpdateCardsQuery = { __typename?: 'Query', getProject: { __typename?: 'Project', scopes: { __typename?: 'ScopeConnection', items: Array<{ __typename?: 'CardScope', card: { __typename?: 'Card', id: string, deletedAt?: any | null, updatedAt: any, title: string, expirationDate?: any | null } }> } } };

export type ScopeFieldsFragment = { __typename?: 'CardScope', id: string, projectId: string, commandCount: number, card: { __typename?: 'Card', id: string, title: string, updatedAt: any, deletedAt?: any | null, isLibrary?: boolean | null, expirationDate?: any | null, isFavorite?: boolean | null, content: { __typename?: 'CardContentV2', tabs: Array<{ __typename?: 'CardTabV2', id: string, updatedAt: any, title: string, date: any, blocks: Array<{ __typename?: 'ContentBlockV2', id: string, title?: string | null, blockType: ContentBlockType, displayType: ContentBlockDisplayType, content: string }> }> }, tags: { __typename?: 'ContentTagConnection', items: Array<{ __typename?: 'ContentTag', id: string, contentId: string, text: string }> } } };

export type ListLiveProjectCardsQueryVariables = Exact<{
  input: IdInput;
}>;


export type ListLiveProjectCardsQuery = { __typename?: 'Query', getProject: { __typename?: 'Project', scopes: { __typename?: 'ScopeConnection', items: Array<{ __typename?: 'CardScope', id: string, projectId: string, commandCount: number, card: { __typename?: 'Card', id: string, title: string, updatedAt: any, deletedAt?: any | null, isLibrary?: boolean | null, expirationDate?: any | null, isFavorite?: boolean | null, content: { __typename?: 'CardContentV2', tabs: Array<{ __typename?: 'CardTabV2', id: string, updatedAt: any, title: string, date: any, blocks: Array<{ __typename?: 'ContentBlockV2', id: string, title?: string | null, blockType: ContentBlockType, displayType: ContentBlockDisplayType, content: string }> }> }, tags: { __typename?: 'ContentTagConnection', items: Array<{ __typename?: 'ContentTag', id: string, contentId: string, text: string }> } } }> } } };

export type CardCommandContextsFieldsFragment = { __typename?: 'ProjectCommandContext', commandContextTextLower: string, cardId: string, card: { __typename?: 'Card', title: string } };

export type SimpleTopicFieldsFragment = { __typename?: 'Topic', text: string, textLower: string, color: string, mandatoryTopic?: { __typename?: 'MandatoryTopic', minimumDuration?: number | null } | null };

export type ProjectCommandFieldsFragment = { __typename?: 'ProjectCommand', cardId?: string | null, commandId: string, date: any, isAlerting?: boolean | null, projectId: string, deletedAt?: any | null, commandContextTextLower?: string | null, topic?: { __typename?: 'Topic', text: string, textLower: string, color: string, mandatoryTopic?: { __typename?: 'MandatoryTopic', minimumDuration?: number | null } | null } | null, command: { __typename?: 'Command', id: string, text: string, language: string, commandRequest?: { __typename?: 'CommandRequest', status: CommandRequestStatus } | null }, card?: { __typename?: 'Card', title: string, id: string } | null, cardCommandContexts: Array<{ __typename?: 'ProjectCommandContext', commandContextTextLower: string, cardId: string, card: { __typename?: 'Card', title: string } }>, triggeredContext?: { __typename?: 'CommandContext', text: string } | null };

export type ListCommandsQueryVariables = Exact<{
  input: IdInput;
}>;


export type ListCommandsQuery = { __typename?: 'Query', getProject: { __typename?: 'Project', commands: { __typename?: 'ProjectCommandConnection', items: Array<{ __typename?: 'ProjectCommand', cardId?: string | null, commandId: string, date: any, isAlerting?: boolean | null, projectId: string, deletedAt?: any | null, commandContextTextLower?: string | null, topic?: { __typename?: 'Topic', text: string, textLower: string, color: string, mandatoryTopic?: { __typename?: 'MandatoryTopic', minimumDuration?: number | null } | null } | null, command: { __typename?: 'Command', id: string, text: string, language: string, commandRequest?: { __typename?: 'CommandRequest', status: CommandRequestStatus } | null }, card?: { __typename?: 'Card', title: string, id: string } | null, cardCommandContexts: Array<{ __typename?: 'ProjectCommandContext', commandContextTextLower: string, cardId: string, card: { __typename?: 'Card', title: string } }>, triggeredContext?: { __typename?: 'CommandContext', text: string } | null }> } } };

export type CommentFieldsFragment = { __typename?: 'Comment', id: string, parentId: string, userId: string, date: any, updateDate?: any | null, content: string, numReplies?: number | null, user: { __typename?: 'User', id: string, email: string, displayName: string } };

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'Comment', id: string, parentId: string, userId: string, date: any, updateDate?: any | null, content: string, numReplies?: number | null, user: { __typename?: 'User', id: string, email: string, displayName: string } } };

export type UpdateCommentMutationVariables = Exact<{
  input: UpdateCommentInput;
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'Comment', id: string, parentId: string, userId: string, date: any, updateDate?: any | null, content: string, numReplies?: number | null, user: { __typename?: 'User', id: string, email: string, displayName: string } } };

export type DeleteCommentMutationVariables = Exact<{
  input: DeleteCommentInput;
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: { __typename?: 'Comment', id: string, parentId: string, userId: string, date: any, updateDate?: any | null, content: string, numReplies?: number | null, user: { __typename?: 'User', id: string, email: string, displayName: string } } };

export type ListCommentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ListCommentsQuery = { __typename?: 'Query', queryComments: { __typename?: 'CommentConnection', items: Array<{ __typename?: 'Comment', id: string, parentId: string, userId: string, date: any, updateDate?: any | null, content: string, numReplies?: number | null, user: { __typename?: 'User', id: string, email: string, displayName: string } }> } };

export type TopicFieldsFragment = { __typename?: 'Topic', text: string, textLower: string, color: string, mandatoryTopic?: { __typename?: 'MandatoryTopic', minimumDuration?: number | null, complianceExample?: string | null, conditionTopics?: Array<{ __typename?: 'ConditionTopic', textLower: string }> | null } | null, projectCommands?: { __typename?: 'ProjectCommandConnection', items: Array<{ __typename?: 'ProjectCommand', commandId: string, compliance?: CommandComplianceType | null, command: { __typename?: 'Command', text: string } }> } | null };

export type ConditionTopicFieldsFragment = { __typename?: 'ConditionTopic', textLower: string, topic: { __typename?: 'Topic', text: string, textLower: string, color: string, mandatoryTopic?: { __typename?: 'MandatoryTopic', minimumDuration?: number | null, complianceExample?: string | null, conditionTopics?: Array<{ __typename?: 'ConditionTopic', textLower: string }> | null } | null, projectCommands?: { __typename?: 'ProjectCommandConnection', items: Array<{ __typename?: 'ProjectCommand', commandId: string, compliance?: CommandComplianceType | null, command: { __typename?: 'Command', text: string } }> } | null } };

export type MandatoryTopicFieldsFragment = { __typename?: 'MandatoryTopic', id: string, minimumDuration?: number | null, sessionStepCondition?: MandatoryTopicSessionStep | null, textLower: string, projectId: string, complianceExample?: string | null, conditionTopics?: Array<{ __typename?: 'ConditionTopic', textLower: string, topic: { __typename?: 'Topic', text: string, textLower: string, color: string, mandatoryTopic?: { __typename?: 'MandatoryTopic', minimumDuration?: number | null, complianceExample?: string | null, conditionTopics?: Array<{ __typename?: 'ConditionTopic', textLower: string }> | null } | null, projectCommands?: { __typename?: 'ProjectCommandConnection', items: Array<{ __typename?: 'ProjectCommand', commandId: string, compliance?: CommandComplianceType | null, command: { __typename?: 'Command', text: string } }> } | null } }> | null, topic: { __typename?: 'Topic', text: string, textLower: string, color: string, mandatoryTopic?: { __typename?: 'MandatoryTopic', minimumDuration?: number | null, complianceExample?: string | null, conditionTopics?: Array<{ __typename?: 'ConditionTopic', textLower: string }> | null } | null, projectCommands?: { __typename?: 'ProjectCommandConnection', items: Array<{ __typename?: 'ProjectCommand', commandId: string, compliance?: CommandComplianceType | null, command: { __typename?: 'Command', text: string } }> } | null } };

export type GetComplianceQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetComplianceQuery = { __typename?: 'Query', topics: { __typename?: 'TopicConnection', items: Array<{ __typename?: 'Topic', text: string, textLower: string, color: string, mandatoryTopic?: { __typename?: 'MandatoryTopic', minimumDuration?: number | null, complianceExample?: string | null, conditionTopics?: Array<{ __typename?: 'ConditionTopic', textLower: string }> | null } | null, projectCommands?: { __typename?: 'ProjectCommandConnection', items: Array<{ __typename?: 'ProjectCommand', commandId: string, compliance?: CommandComplianceType | null, command: { __typename?: 'Command', text: string } }> } | null }> } };

export type GetProjectComplianceQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetProjectComplianceQuery = { __typename?: 'Query', getProject: { __typename?: 'Project', id: string, name: string, mandatoryTopics: Array<{ __typename?: 'MandatoryTopic', id: string, minimumDuration?: number | null, sessionStepCondition?: MandatoryTopicSessionStep | null, textLower: string, projectId: string, complianceExample?: string | null, conditionTopics?: Array<{ __typename?: 'ConditionTopic', textLower: string, topic: { __typename?: 'Topic', text: string, textLower: string, color: string, mandatoryTopic?: { __typename?: 'MandatoryTopic', minimumDuration?: number | null, complianceExample?: string | null, conditionTopics?: Array<{ __typename?: 'ConditionTopic', textLower: string }> | null } | null, projectCommands?: { __typename?: 'ProjectCommandConnection', items: Array<{ __typename?: 'ProjectCommand', commandId: string, compliance?: CommandComplianceType | null, command: { __typename?: 'Command', text: string } }> } | null } }> | null, topic: { __typename?: 'Topic', text: string, textLower: string, color: string, mandatoryTopic?: { __typename?: 'MandatoryTopic', minimumDuration?: number | null, complianceExample?: string | null, conditionTopics?: Array<{ __typename?: 'ConditionTopic', textLower: string }> | null } | null, projectCommands?: { __typename?: 'ProjectCommandConnection', items: Array<{ __typename?: 'ProjectCommand', commandId: string, compliance?: CommandComplianceType | null, command: { __typename?: 'Command', text: string } }> } | null } }>, formulationTopics: Array<{ __typename?: 'MandatoryTopic', id: string, minimumDuration?: number | null, sessionStepCondition?: MandatoryTopicSessionStep | null, textLower: string, projectId: string, complianceExample?: string | null, conditionTopics?: Array<{ __typename?: 'ConditionTopic', textLower: string, topic: { __typename?: 'Topic', text: string, textLower: string, color: string, mandatoryTopic?: { __typename?: 'MandatoryTopic', minimumDuration?: number | null, complianceExample?: string | null, conditionTopics?: Array<{ __typename?: 'ConditionTopic', textLower: string }> | null } | null, projectCommands?: { __typename?: 'ProjectCommandConnection', items: Array<{ __typename?: 'ProjectCommand', commandId: string, compliance?: CommandComplianceType | null, command: { __typename?: 'Command', text: string } }> } | null } }> | null, topic: { __typename?: 'Topic', text: string, textLower: string, color: string, mandatoryTopic?: { __typename?: 'MandatoryTopic', minimumDuration?: number | null, complianceExample?: string | null, conditionTopics?: Array<{ __typename?: 'ConditionTopic', textLower: string }> | null } | null, projectCommands?: { __typename?: 'ProjectCommandConnection', items: Array<{ __typename?: 'ProjectCommand', commandId: string, compliance?: CommandComplianceType | null, command: { __typename?: 'Command', text: string } }> } | null } }> } };

export type ContentRequestFieldsFragment = { __typename?: 'ContentRequest', organisationId: string, counter: number, title: string, createdAt: any, updatedAt: any, state: ContentRequestState, cardId?: string | null, projectId: string, details: string, project: { __typename?: 'Project', name: string, archived: boolean }, user: { __typename?: 'User', displayName: string, email: string }, card?: { __typename?: 'Card', title: string, deletedAt?: any | null } | null };

export type ListLiveUserContentRequestsQueryVariables = Exact<{
  input?: InputMaybe<ListContentRequestsInput>;
}>;


export type ListLiveUserContentRequestsQuery = { __typename?: 'Query', requests: { __typename?: 'ContentRequestConnection', nextToken?: string | null, items: Array<{ __typename?: 'ContentRequest', organisationId: string, counter: number, title: string, createdAt: any, updatedAt: any, state: ContentRequestState, cardId?: string | null, projectId: string, details: string, project: { __typename?: 'Project', name: string, archived: boolean }, user: { __typename?: 'User', displayName: string, email: string }, card?: { __typename?: 'Card', title: string, deletedAt?: any | null } | null }> } };

export type GetLiveContentRequestQueryVariables = Exact<{
  input: NumberIdInput;
}>;


export type GetLiveContentRequestQuery = { __typename?: 'Query', getContentRequest: { __typename?: 'ContentRequest', organisationId: string, counter: number, title: string, createdAt: any, updatedAt: any, state: ContentRequestState, cardId?: string | null, projectId: string, details: string, project: { __typename?: 'Project', name: string, archived: boolean }, user: { __typename?: 'User', displayName: string, email: string }, card?: { __typename?: 'Card', title: string, deletedAt?: any | null } | null } };

export type CreateContentRequestMutationVariables = Exact<{
  input: CreateContentRequestInput;
}>;


export type CreateContentRequestMutation = { __typename?: 'Mutation', createContentRequest: { __typename?: 'ContentRequest', createdAt: any } };

export type CommandContextFieldsFragment = { __typename?: 'CommandContext', text: string, textLower: string };

export type DecisionTreeNodeFieldsFragment = { __typename?: 'DecisionTreeNode', id: string, decisionTreeId: string, name: string, richText?: string | null, type: DecisionTreeNodeType, children?: Array<{ __typename?: 'DecisionTreeChildNode', id: string, nodeValue: string }> | null };

export type DecisionTreeFieldsFragment = { __typename?: 'DecisionTree', id: string, name: string, createdAt: any, createdBy: string, updatedAt: any, rootId: string, deletedAt?: any | null, allowComments?: boolean | null, projects: Array<{ __typename?: 'DecisionTreeProject', projectId: string }>, createdByUser: { __typename?: 'User', displayName: string, email: string } };

export type ListDecisionTreesQueryVariables = Exact<{
  input: IdInput;
}>;


export type ListDecisionTreesQuery = { __typename?: 'Query', getProject: { __typename?: 'Project', id: string, name: string, decisionTrees: Array<{ __typename?: 'DecisionTree', id: string, name: string, createdAt: any, createdBy: string, updatedAt: any, rootId: string, deletedAt?: any | null, allowComments?: boolean | null, projects: Array<{ __typename?: 'DecisionTreeProject', projectId: string }>, createdByUser: { __typename?: 'User', displayName: string, email: string } }> } };

export type GetDecisionTreeQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetDecisionTreeQuery = { __typename?: 'Query', getDecisionTree: { __typename?: 'DecisionTree', id: string, name: string, createdAt: any, createdBy: string, updatedAt: any, rootId: string, deletedAt?: any | null, allowComments?: boolean | null, nodes: Array<{ __typename?: 'DecisionTreeNode', id: string, decisionTreeId: string, name: string, richText?: string | null, type: DecisionTreeNodeType, children?: Array<{ __typename?: 'DecisionTreeChildNode', id: string, nodeValue: string }> | null }>, projects: Array<{ __typename?: 'DecisionTreeProject', projectId: string }>, createdByUser: { __typename?: 'User', displayName: string, email: string } } };

export type GetDecisionTreeNodeQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetDecisionTreeNodeQuery = { __typename?: 'Query', getDecisionTreeNode: { __typename?: 'DecisionTreeNode', id: string, decisionTreeId: string, name: string, richText?: string | null, type: DecisionTreeNodeType, children?: Array<{ __typename?: 'DecisionTreeChildNode', id: string, nodeValue: string }> | null } };

export type GetCurrentDecisionTreeQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetCurrentDecisionTreeQuery = { __typename?: 'Query', getDecisionTreeRun: { __typename?: 'DecisionTreeRun', id: string, decisionTree?: { __typename?: 'DecisionTree', id: string, name: string, createdAt: any, createdBy: string, updatedAt: any, rootId: string, deletedAt?: any | null, allowComments?: boolean | null, nodes: Array<{ __typename?: 'DecisionTreeNode', id: string, decisionTreeId: string, name: string, richText?: string | null, type: DecisionTreeNodeType, children?: Array<{ __typename?: 'DecisionTreeChildNode', id: string, nodeValue: string }> | null }>, projects: Array<{ __typename?: 'DecisionTreeProject', projectId: string }>, createdByUser: { __typename?: 'User', displayName: string, email: string } } | null } };

export type GetDecisionTreeRunQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetDecisionTreeRunQuery = { __typename?: 'Query', getDecisionTreeRun: { __typename?: 'DecisionTreeRun', id: string, comments: Array<{ __typename?: 'DecisionTreeRunComment', nodeId: string, userComment: string }>, nodes: Array<{ __typename?: 'DecisionTreeRunNode', node: { __typename?: 'DecisionTreeNode', id: string, decisionTreeId: string, name: string, richText?: string | null, type: DecisionTreeNodeType, children?: Array<{ __typename?: 'DecisionTreeChildNode', id: string, nodeValue: string }> | null } }> } };

export type StartDecisionTreeRunMutationVariables = Exact<{
  input: StartDecisionTreeRunInput;
}>;


export type StartDecisionTreeRunMutation = { __typename?: 'Mutation', startDecisionTreeRun: { __typename?: 'DecisionTreeRun', id: string } };

export type UpdateDecisionTreeRunHistoryMutationVariables = Exact<{
  input: UpdateDecisionTreeRunHistoryInput;
}>;


export type UpdateDecisionTreeRunHistoryMutation = { __typename?: 'Mutation', updateDecisionTreeRunHistory: { __typename?: 'DecisionTreeRun', id: string } };

export type WriteDecisionTreeRunCommentMutationVariables = Exact<{
  input: WriteDecisionTreeRunCommentInput;
}>;


export type WriteDecisionTreeRunCommentMutation = { __typename?: 'Mutation', writeDecisionTreeRunComment: { __typename?: 'DecisionTreeRun', id: string, comments: Array<{ __typename?: 'DecisionTreeRunComment', nodeId: string, userComment: string }> } };

export type DetectionMinimumFieldsFragment = { __typename?: 'Detection', date: any, command?: { __typename?: 'AsrCommand', name: string } | null };

export type DisplayFieldsFragment = { __typename?: 'Display', id: string, organisationId: string, projectId: string, cardId: string, user: string, date: any, displayType: DisplayType, sessionId?: string | null, feedback?: Feedback | null, detectionId?: string | null, isVisible?: boolean | null, detection?: { __typename?: 'Detection', date: any, command?: { __typename?: 'AsrCommand', name: string } | null } | null, card: { __typename?: 'Card', id: string, title: string } };

export type CreateLiveDisplayMutationVariables = Exact<{
  input: CreateDisplayInput;
}>;


export type CreateLiveDisplayMutation = { __typename?: 'Mutation', createDisplay: { __typename?: 'Display', id: string, organisationId: string, projectId: string, cardId: string, user: string, date: any, displayType: DisplayType, sessionId?: string | null, feedback?: Feedback | null, detectionId?: string | null, isVisible?: boolean | null, detection?: { __typename?: 'Detection', date: any, command?: { __typename?: 'AsrCommand', name: string } | null } | null, card: { __typename?: 'Card', id: string, title: string } } };

export type GetLiveDisplayQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetLiveDisplayQuery = { __typename?: 'Query', getDisplay: { __typename?: 'Display', id: string, organisationId: string, projectId: string, cardId: string, user: string, date: any, displayType: DisplayType, sessionId?: string | null, feedback?: Feedback | null, detectionId?: string | null, isVisible?: boolean | null, detection?: { __typename?: 'Detection', date: any, command?: { __typename?: 'AsrCommand', name: string } | null } | null, card: { __typename?: 'Card', id: string, title: string } } };

export type UpdateLiveDisplayFeedbackMutationVariables = Exact<{
  input: UpdateDisplayFeedbackInput;
}>;


export type UpdateLiveDisplayFeedbackMutation = { __typename?: 'Mutation', updateDisplayFeedback: { __typename?: 'Display', id: string, organisationId: string, projectId: string, cardId: string, user: string, date: any, displayType: DisplayType, sessionId?: string | null, feedback?: Feedback | null, detectionId?: string | null, isVisible?: boolean | null, detection?: { __typename?: 'Detection', date: any, command?: { __typename?: 'AsrCommand', name: string } | null } | null, card: { __typename?: 'Card', id: string, title: string } } };

export type UpdateLiveDisplayMutationVariables = Exact<{
  input: UpdateDisplayInput;
}>;


export type UpdateLiveDisplayMutation = { __typename?: 'Mutation', updateDisplay: { __typename?: 'Display', id: string, organisationId: string, projectId: string, cardId: string, user: string, date: any, displayType: DisplayType, sessionId?: string | null, feedback?: Feedback | null, detectionId?: string | null, isVisible?: boolean | null, detection?: { __typename?: 'Detection', date: any, command?: { __typename?: 'AsrCommand', name: string } | null } | null, card: { __typename?: 'Card', id: string, title: string } } };

export type NewsFieldsFragment = { __typename?: 'News', id: string, title: string, content: string, startDate?: any | null, status: NewsStatus, endDate?: any | null };

export type ListCurrentNewsQueryVariables = Exact<{
  input: IdInput;
}>;


export type ListCurrentNewsQuery = { __typename?: 'Query', news: Array<{ __typename?: 'News', id: string, title: string, content: string, startDate?: any | null, status: NewsStatus, endDate?: any | null }> };

export type NotificationFieldsFragment = { __typename?: 'Notification', eventId: string, organisationId: string, userId: string, date: any, acknowledgeDate?: any | null, event: { __typename?: 'NotificationEvent', organisationId: string, date: any, id: string, eventType?: NotificationType | null, authorId?: string | null, cardId?: string | null, projectId?: string | null, userId?: string | null, commandId?: string | null, contentRequestCounter?: number | null, oldValue?: string | null, newValue?: string | null, projectCommand?: { __typename?: 'ProjectCommand', deletedAt?: any | null } | null, command?: { __typename?: 'Command', text: string, commandRequest?: { __typename?: 'CommandRequest', status: CommandRequestStatus, deletedAt?: any | null } | null } | null, project?: { __typename?: 'Project', archived: boolean, name: string } | null, author?: { __typename?: 'User', displayName: string } | null, card?: { __typename?: 'Card', deletedAt?: any | null, isLibrary?: boolean | null, title: string, scopes: { __typename?: 'ScopeConnection', items: Array<{ __typename?: 'CardScope', projectId: string }> } } | null, contentRequest?: { __typename?: 'ContentRequest', deletedAt?: any | null, title: string } | null, user?: { __typename?: 'User', displayName: string, email: string } | null } };

export type IdentityNotificationsQueryVariables = Exact<{
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type IdentityNotificationsQuery = { __typename?: 'Query', queryIdentityNotifications: { __typename?: 'NotificationConnection', nextToken?: string | null, items: Array<{ __typename?: 'Notification', eventId: string, organisationId: string, userId: string, date: any, acknowledgeDate?: any | null, event: { __typename?: 'NotificationEvent', organisationId: string, date: any, id: string, eventType?: NotificationType | null, authorId?: string | null, cardId?: string | null, projectId?: string | null, userId?: string | null, commandId?: string | null, contentRequestCounter?: number | null, oldValue?: string | null, newValue?: string | null, projectCommand?: { __typename?: 'ProjectCommand', deletedAt?: any | null } | null, command?: { __typename?: 'Command', text: string, commandRequest?: { __typename?: 'CommandRequest', status: CommandRequestStatus, deletedAt?: any | null } | null } | null, project?: { __typename?: 'Project', archived: boolean, name: string } | null, author?: { __typename?: 'User', displayName: string } | null, card?: { __typename?: 'Card', deletedAt?: any | null, isLibrary?: boolean | null, title: string, scopes: { __typename?: 'ScopeConnection', items: Array<{ __typename?: 'CardScope', projectId: string }> } } | null, contentRequest?: { __typename?: 'ContentRequest', deletedAt?: any | null, title: string } | null, user?: { __typename?: 'User', displayName: string, email: string } | null } }> } };

export type IdentityNumNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentityNumNotificationsQuery = { __typename?: 'Query', getUserInfo: { __typename?: 'User', numNotifications?: number | null } };

export type AcknowledgeNotificationMutationVariables = Exact<{
  input: AcknowledgeNotificationInput;
}>;


export type AcknowledgeNotificationMutation = { __typename?: 'Mutation', acknowledgeNotification: { __typename?: 'Notification', eventId: string } };

export type AcknowledgeAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type AcknowledgeAllNotificationsMutation = { __typename?: 'Mutation', acknowledgeAllNotifications: Array<{ __typename?: 'Notification', eventId: string }> };

export type GetNotificationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetNotificationQuery = { __typename?: 'Query', getNotification: { __typename?: 'Notification', eventId: string, organisationId: string, userId: string, date: any, acknowledgeDate?: any | null, event: { __typename?: 'NotificationEvent', organisationId: string, date: any, id: string, eventType?: NotificationType | null, authorId?: string | null, cardId?: string | null, projectId?: string | null, userId?: string | null, commandId?: string | null, contentRequestCounter?: number | null, oldValue?: string | null, newValue?: string | null, projectCommand?: { __typename?: 'ProjectCommand', deletedAt?: any | null } | null, command?: { __typename?: 'Command', text: string, commandRequest?: { __typename?: 'CommandRequest', status: CommandRequestStatus, deletedAt?: any | null } | null } | null, project?: { __typename?: 'Project', archived: boolean, name: string } | null, author?: { __typename?: 'User', displayName: string } | null, card?: { __typename?: 'Card', deletedAt?: any | null, isLibrary?: boolean | null, title: string, scopes: { __typename?: 'ScopeConnection', items: Array<{ __typename?: 'CardScope', projectId: string }> } } | null, contentRequest?: { __typename?: 'ContentRequest', deletedAt?: any | null, title: string } | null, user?: { __typename?: 'User', displayName: string, email: string } | null } } };

export type OrganisationFieldsFragment = { __typename?: 'Organisation', enableCoreAsrApi?: boolean | null, enableAlternativeAsrApi?: boolean | null, enableFeature_useNewAudioEncoding?: boolean | null, defaultAudioSettings_enableAudioNoiseSuppression?: boolean | null, defaultAudioSettings_enableAudioEchoCancellation?: boolean | null, defaultAudioSettings_enableAudioAutoGainControl?: boolean | null };

export type GetOrganisationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationQuery = { __typename?: 'Query', org: { __typename?: 'Organisation', enableCoreAsrApi?: boolean | null, enableAlternativeAsrApi?: boolean | null, enableFeature_useNewAudioEncoding?: boolean | null, defaultAudioSettings_enableAudioNoiseSuppression?: boolean | null, defaultAudioSettings_enableAudioEchoCancellation?: boolean | null, defaultAudioSettings_enableAudioAutoGainControl?: boolean | null } };

export type ProjectFieldsFragment = { __typename?: 'Project', id: string, name: string, asrLanguage: string, date: any, autoStartUrls?: Array<string> | null, scopeCount: number };

export type ListLiveProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListLiveProjectsQuery = { __typename?: 'Query', listProjects: Array<{ __typename?: 'Project', id: string, name: string, asrLanguage: string, date: any, autoStartUrls?: Array<string> | null, scopeCount: number }> };

export type GetLiveProjectQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetLiveProjectQuery = { __typename?: 'Query', getProject: { __typename?: 'Project', id: string, name: string, asrLanguage: string, date: any, autoStartUrls?: Array<string> | null, scopeCount: number, commandContexts: Array<{ __typename?: 'CommandContext', text: string, textLower: string }> } };

export type SessionFieldsFragment = { __typename?: 'Session', id: string, date: any, projectId: string, duration: number, project: { __typename?: 'Project', asrLanguage: string, sessionEndCardId?: string | null }, externalCall?: { __typename?: 'ExternalCall', clientCard?: { __typename?: 'Card', title: string, id: string } | null } | null };

export type CreateSessionMutationVariables = Exact<{
  input: CreateSessionInput;
}>;


export type CreateSessionMutation = { __typename?: 'Mutation', createSession: { __typename?: 'Session', id: string, date: any, projectId: string, duration: number, project: { __typename?: 'Project', asrLanguage: string, sessionEndCardId?: string | null }, externalCall?: { __typename?: 'ExternalCall', clientCard?: { __typename?: 'Card', title: string, id: string } | null } | null } };

export type UpdateSessionDurationMutationVariables = Exact<{
  input: UpateSessionInput;
}>;


export type UpdateSessionDurationMutation = { __typename?: 'Mutation', updateSessionDuration2: { __typename?: 'Session', id: string, date: any, projectId: string, duration: number, project: { __typename?: 'Project', asrLanguage: string, sessionEndCardId?: string | null }, externalCall?: { __typename?: 'ExternalCall', clientCard?: { __typename?: 'Card', title: string, id: string } | null } | null } };

export type DetectionFieldsFragment = { __typename?: 'Detection', id: string, date: any, cardId?: string | null, projectId: string, command?: { __typename?: 'AsrCommand', name: string } | null, scope?: { __typename?: 'CardScope', card: { __typename?: 'Card', title: string } } | null };

export type GetLiveSessionQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetLiveSessionQuery = { __typename?: 'Query', getSession: { __typename?: 'Session', id: string, date: any, projectId: string, duration: number, detections: Array<{ __typename?: 'Detection', id: string, date: any, cardId?: string | null, projectId: string, command?: { __typename?: 'AsrCommand', name: string } | null, scope?: { __typename?: 'CardScope', card: { __typename?: 'Card', title: string } } | null }>, project: { __typename?: 'Project', asrLanguage: string, sessionEndCardId?: string | null }, externalCall?: { __typename?: 'ExternalCall', clientCard?: { __typename?: 'Card', title: string, id: string } | null } | null } };

export type UserEngagementMetricsFieldsFragment = { __typename?: 'UserEngagementMetrics', sessionCount: number, sessionDuration: number, sessionDurationAverage?: number | null };

export type RelativeMetricFieldsFragment = { __typename?: 'RelativeMetric', numerator: number, denominator: number, ratio: number };

export type TopicComplianceStatFieldsFragment = { __typename?: 'TopicComplianceStat', topicTextLower: string, topic: { __typename?: 'Topic', color: string, text: string }, current: { __typename?: 'RelativeMetric', numerator: number, denominator: number, ratio: number }, previous?: { __typename?: 'RelativeMetric', numerator: number, denominator: number, ratio: number } | null };

export type GetUserEngagementStatsQueryVariables = Exact<{
  input: GetUserPerformanceStatsInput;
}>;


export type GetUserEngagementStatsQuery = { __typename?: 'Query', getUserPerformanceStats: { __typename?: 'UserPerformanceStats', engagement?: { __typename?: 'UserEngagementStats', current: { __typename?: 'UserEngagementMetrics', sessionCount: number, sessionDuration: number, sessionDurationAverage?: number | null }, previous: { __typename?: 'UserEngagementMetrics', sessionCount: number, sessionDuration: number, sessionDurationAverage?: number | null } } | null } };

export type GetUserComplianceStatsQueryVariables = Exact<{
  input: GetUserPerformanceStatsInput;
}>;


export type GetUserComplianceStatsQuery = { __typename?: 'Query', getUserPerformanceStats: { __typename?: 'UserPerformanceStats', compliance?: { __typename?: 'UserComplianceStats', current: { __typename?: 'RelativeMetric', numerator: number, denominator: number, ratio: number }, previous?: { __typename?: 'RelativeMetric', numerator: number, denominator: number, ratio: number } | null, table: Array<{ __typename?: 'TopicComplianceStat', topicTextLower: string, topic: { __typename?: 'Topic', color: string, text: string }, current: { __typename?: 'RelativeMetric', numerator: number, denominator: number, ratio: number }, previous?: { __typename?: 'RelativeMetric', numerator: number, denominator: number, ratio: number } | null }> } | null } };

export type GetUserQualityStatsQueryVariables = Exact<{
  input: GetUserPerformanceStatsInput;
}>;


export type GetUserQualityStatsQuery = { __typename?: 'Query', getUserPerformanceStats: { __typename?: 'UserPerformanceStats', quality?: { __typename?: 'UserComplianceStats', current: { __typename?: 'RelativeMetric', numerator: number, denominator: number, ratio: number }, previous?: { __typename?: 'RelativeMetric', numerator: number, denominator: number, ratio: number } | null, table: Array<{ __typename?: 'TopicComplianceStat', topicTextLower: string, topic: { __typename?: 'Topic', color: string, text: string }, current: { __typename?: 'RelativeMetric', numerator: number, denominator: number, ratio: number }, previous?: { __typename?: 'RelativeMetric', numerator: number, denominator: number, ratio: number } | null }> } | null } };

export type UserFieldsFragment = { __typename?: 'User', id: string, organisationId: string, isConfirmed: boolean, role: number, displayName: string, email: string, isStaff: boolean, slackId?: string | null, appSettings?: { __typename?: 'UserSettings', notifications?: { __typename?: 'UserNotificationSettings', notifyOnDetection?: LiveNotificationType | null, notifyOnExternalCall?: LiveNotificationType | null, notifyOnNewMandatoryTopic?: LiveNotificationType | null } | null } | null };

export type GetLiveUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLiveUserInfoQuery = { __typename?: 'Query', getUserInfo: { __typename?: 'User', id: string, organisationId: string, isConfirmed: boolean, role: number, displayName: string, email: string, isStaff: boolean, slackId?: string | null, appSettings?: { __typename?: 'UserSettings', notifications?: { __typename?: 'UserNotificationSettings', notifyOnDetection?: LiveNotificationType | null, notifyOnExternalCall?: LiveNotificationType | null, notifyOnNewMandatoryTopic?: LiveNotificationType | null } | null } | null } };

export type UpdatePushSubscriptionMutationVariables = Exact<{
  input: UpdatePushSubscriptionInput;
}>;


export type UpdatePushSubscriptionMutation = { __typename?: 'Mutation', updatePushSubscription: { __typename?: 'User', id: string } };

export type UpdatePersonalInfoMutationVariables = Exact<{
  input: UpdatePersonalInfoInput;
}>;


export type UpdatePersonalInfoMutation = { __typename?: 'Mutation', updatePersonalInfo: { __typename?: 'User', id: string } };

export type UpdateUserSettingsMutationVariables = Exact<{
  input: UpdateUserSettingsInput;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', updateUserSettings: { __typename?: 'User', id: string } };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'User', id: string } };

export const SearchResultFieldsFragmentDoc = `
    fragment SearchResultFields on SearchResult {
  cardId
  tabId
  cardTitle
  tabTitle
  titleMatch
  tabTitleMatch
  contentMatches
}
    `;
export const BlockFieldsFragmentDoc = `
    fragment blockFields on ContentBlockV2 {
  id
  title
  blockType
  displayType
  content
}
    `;
export const TabFieldsFragmentDoc = `
    fragment tabFields on CardTabV2 {
  id
  date: createdAt
  updatedAt
  title
  blocks {
    ...blockFields
  }
}
    ${BlockFieldsFragmentDoc}`;
export const CardFieldsFragmentDoc = `
    fragment cardFields on Card {
  id
  title
  updatedAt
  deletedAt
  content {
    tabs {
      ...tabFields
    }
  }
  isLibrary
  expirationDate
  tags {
    items {
      id
      contentId
      text
    }
  }
  isFavorite
}
    ${TabFieldsFragmentDoc}`;
export const CardSummaryFieldsFragmentDoc = `
    fragment cardSummaryFields on Card {
  id
  deletedAt
  updatedAt
  title
  expirationDate
}
    `;
export const CardLinkFieldsFragmentDoc = `
    fragment cardLinkFields on CardLink {
  sourceScopeId
  targetScopeId
  targetScope {
    card {
      ...cardSummaryFields
    }
  }
}
    ${CardSummaryFieldsFragmentDoc}`;
export const DetailedCardFieldsFragmentDoc = `
    fragment detailedCardFields on CardScope {
  projectId
  cardId
  deletedAt
  card {
    ...cardFields
  }
  links {
    items {
      ...cardLinkFields
    }
  }
}
    ${CardFieldsFragmentDoc}
${CardLinkFieldsFragmentDoc}`;
export const ScopeFieldsFragmentDoc = `
    fragment scopeFields on CardScope {
  id
  projectId
  card {
    ...cardFields
  }
  commandCount
}
    ${CardFieldsFragmentDoc}`;
export const SimpleTopicFieldsFragmentDoc = `
    fragment simpleTopicFields on Topic {
  text
  textLower
  color
  mandatoryTopic(input: $input) {
    minimumDuration
  }
}
    `;
export const CardCommandContextsFieldsFragmentDoc = `
    fragment cardCommandContextsFields on ProjectCommandContext {
  commandContextTextLower
  cardId
  card {
    title
  }
}
    `;
export const ProjectCommandFieldsFragmentDoc = `
    fragment projectCommandFields on ProjectCommand {
  cardId
  commandId
  date
  topic {
    ...simpleTopicFields
  }
  isAlerting
  command {
    id
    text
    language
    commandRequest {
      status
    }
  }
  card {
    title
    id
  }
  projectId
  deletedAt
  cardCommandContexts {
    ...cardCommandContextsFields
  }
  commandContextTextLower
  triggeredContext {
    text
  }
}
    ${SimpleTopicFieldsFragmentDoc}
${CardCommandContextsFieldsFragmentDoc}`;
export const CommentFieldsFragmentDoc = `
    fragment commentFields on Comment {
  id
  parentId
  userId
  date
  updateDate
  content
  numReplies
  user {
    id
    email
    displayName
  }
}
    `;
export const TopicFieldsFragmentDoc = `
    fragment topicFields on Topic {
  text
  textLower
  color
  mandatoryTopic(input: $input) {
    minimumDuration
    complianceExample
    conditionTopics {
      textLower
    }
    complianceExample
  }
  projectCommands(input: $input) {
    items {
      commandId
      compliance
      command {
        text
      }
    }
  }
}
    `;
export const ConditionTopicFieldsFragmentDoc = `
    fragment conditionTopicFields on ConditionTopic {
  textLower
  topic {
    ...topicFields
  }
}
    ${TopicFieldsFragmentDoc}`;
export const MandatoryTopicFieldsFragmentDoc = `
    fragment mandatoryTopicFields on MandatoryTopic {
  id
  minimumDuration
  sessionStepCondition
  conditionTopics {
    ...conditionTopicFields
  }
  textLower
  projectId
  topic {
    ...topicFields
  }
  complianceExample
}
    ${ConditionTopicFieldsFragmentDoc}
${TopicFieldsFragmentDoc}`;
export const ContentRequestFieldsFragmentDoc = `
    fragment contentRequestFields on ContentRequest {
  organisationId
  counter
  title
  createdAt
  updatedAt
  state
  cardId
  projectId
  project {
    name
    archived
  }
  user {
    displayName
    email
  }
  details
  card {
    title
    deletedAt
  }
}
    `;
export const CommandContextFieldsFragmentDoc = `
    fragment commandContextFields on CommandContext {
  text
  textLower
}
    `;
export const DecisionTreeNodeFieldsFragmentDoc = `
    fragment decisionTreeNodeFields on DecisionTreeNode {
  id
  decisionTreeId
  name
  richText
  type
  children: newChildren {
    id
    nodeValue
  }
}
    `;
export const DecisionTreeFieldsFragmentDoc = `
    fragment decisionTreeFields on DecisionTree {
  id
  name
  createdAt
  createdBy
  updatedAt
  rootId
  deletedAt
  allowComments
  projects {
    projectId
  }
  createdByUser {
    displayName
    email
  }
}
    `;
export const DetectionMinimumFieldsFragmentDoc = `
    fragment detectionMinimumFields on Detection {
  date
  command {
    name
  }
}
    `;
export const DisplayFieldsFragmentDoc = `
    fragment displayFields on Display {
  id
  organisationId
  projectId
  cardId
  user
  date
  displayType
  sessionId
  feedback
  detectionId
  isVisible
  detection {
    ...detectionMinimumFields
  }
  card {
    id
    title
  }
}
    ${DetectionMinimumFieldsFragmentDoc}`;
export const NewsFieldsFragmentDoc = `
    fragment newsFields on News {
  id
  title
  content
  startDate
  status
  endDate
}
    `;
export const NotificationFieldsFragmentDoc = `
    fragment notificationFields on Notification {
  eventId
  organisationId
  userId
  date
  acknowledgeDate
  event {
    organisationId
    date
    id
    eventType
    authorId
    cardId
    projectId
    userId
    commandId
    contentRequestCounter
    projectCommand {
      deletedAt
    }
    command {
      text
      commandRequest {
        status
        deletedAt
      }
    }
    project {
      archived
      name
    }
    author {
      displayName
    }
    card {
      deletedAt
      isLibrary
      title
      scopes {
        items {
          projectId
        }
      }
    }
    contentRequest {
      deletedAt
      title
    }
    user {
      displayName
      email
    }
    oldValue
    newValue
  }
}
    `;
export const OrganisationFieldsFragmentDoc = `
    fragment organisationFields on Organisation {
  enableCoreAsrApi
  enableAlternativeAsrApi
  enableFeature_useNewAudioEncoding
  defaultAudioSettings_enableAudioNoiseSuppression
  defaultAudioSettings_enableAudioEchoCancellation
  defaultAudioSettings_enableAudioAutoGainControl
}
    `;
export const ProjectFieldsFragmentDoc = `
    fragment projectFields on Project {
  id
  name
  asrLanguage
  date
  autoStartUrls
  scopeCount
}
    `;
export const SessionFieldsFragmentDoc = `
    fragment sessionFields on Session {
  id
  date
  projectId
  duration
  project {
    asrLanguage
    sessionEndCardId
  }
  externalCall {
    clientCard {
      title
      id
    }
  }
}
    `;
export const DetectionFieldsFragmentDoc = `
    fragment detectionFields on Detection {
  id
  date
  command {
    name
  }
  cardId
  projectId
  scope {
    card {
      title
    }
  }
}
    `;
export const UserEngagementMetricsFieldsFragmentDoc = `
    fragment userEngagementMetricsFields on UserEngagementMetrics {
  sessionCount
  sessionDuration
  sessionDurationAverage
}
    `;
export const RelativeMetricFieldsFragmentDoc = `
    fragment relativeMetricFields on RelativeMetric {
  numerator
  denominator
  ratio
}
    `;
export const TopicComplianceStatFieldsFragmentDoc = `
    fragment topicComplianceStatFields on TopicComplianceStat {
  topicTextLower
  topic {
    color
    text
  }
  current {
    ...relativeMetricFields
  }
  previous {
    ...relativeMetricFields
  }
}
    ${RelativeMetricFieldsFragmentDoc}`;
export const UserFieldsFragmentDoc = `
    fragment userFields on User {
  id
  organisationId
  isConfirmed
  role
  displayName
  email
  isStaff
  slackId
  appSettings {
    notifications {
      notifyOnDetection
      notifyOnExternalCall
      notifyOnNewMandatoryTopic
    }
  }
}
    `;
export const ListLiveFavoriteCardsDocument = `
    query listLiveFavoriteCards {
  listFavoriteCards(limit: 1000) {
    items {
      card {
        ...cardSummaryFields
        scopes {
          items {
            projectId
          }
        }
      }
    }
  }
}
    ${CardSummaryFieldsFragmentDoc}`;
export const useListLiveFavoriteCardsQuery = <
      TData = ListLiveFavoriteCardsQuery,
      TError = unknown
    >(
      variables?: ListLiveFavoriteCardsQueryVariables,
      options?: UseQueryOptions<ListLiveFavoriteCardsQuery, TError, TData>
    ) =>
    useQuery<ListLiveFavoriteCardsQuery, TError, TData>(
      variables === undefined ? ['listLiveFavoriteCards'] : ['listLiveFavoriteCards', variables],
      fetchCoreApi<ListLiveFavoriteCardsQuery, ListLiveFavoriteCardsQueryVariables>(ListLiveFavoriteCardsDocument, variables),
      options
    );
export const useInfiniteListLiveFavoriteCardsQuery = <
      TData = ListLiveFavoriteCardsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ListLiveFavoriteCardsQueryVariables,
      variables?: ListLiveFavoriteCardsQueryVariables,
      options?: UseInfiniteQueryOptions<ListLiveFavoriteCardsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ListLiveFavoriteCardsQuery, TError, TData>(
      variables === undefined ? ['listLiveFavoriteCards.infinite'] : ['listLiveFavoriteCards.infinite', variables],
      (metaData) => fetchCoreApi<ListLiveFavoriteCardsQuery, ListLiveFavoriteCardsQueryVariables>(ListLiveFavoriteCardsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const SearchCardsDocument = `
    query searchCards($projectId: IDInput!, $input: CardSearchInput!) {
  getProject(input: $projectId) {
    search(input: $input) {
      items {
        ...SearchResultFields
      }
      count
      nextItem
    }
  }
}
    ${SearchResultFieldsFragmentDoc}`;
export const useSearchCardsQuery = <
      TData = SearchCardsQuery,
      TError = unknown
    >(
      variables: SearchCardsQueryVariables,
      options?: UseQueryOptions<SearchCardsQuery, TError, TData>
    ) =>
    useQuery<SearchCardsQuery, TError, TData>(
      ['searchCards', variables],
      fetchCoreApi<SearchCardsQuery, SearchCardsQueryVariables>(SearchCardsDocument, variables),
      options
    );
export const useInfiniteSearchCardsQuery = <
      TData = SearchCardsQuery,
      TError = unknown
    >(
      pageParamKey: keyof SearchCardsQueryVariables,
      variables: SearchCardsQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCardsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<SearchCardsQuery, TError, TData>(
      ['searchCards.infinite', variables],
      (metaData) => fetchCoreApi<SearchCardsQuery, SearchCardsQueryVariables>(SearchCardsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ListLiveSearchableCardsDocument = `
    query listLiveSearchableCards($input: IDInput!) {
  getProject(input: $input) {
    scopes(includeImported: true) {
      items {
        card {
          ...cardSummaryFields
        }
      }
    }
  }
}
    ${CardSummaryFieldsFragmentDoc}`;
export const useListLiveSearchableCardsQuery = <
      TData = ListLiveSearchableCardsQuery,
      TError = unknown
    >(
      variables: ListLiveSearchableCardsQueryVariables,
      options?: UseQueryOptions<ListLiveSearchableCardsQuery, TError, TData>
    ) =>
    useQuery<ListLiveSearchableCardsQuery, TError, TData>(
      ['listLiveSearchableCards', variables],
      fetchCoreApi<ListLiveSearchableCardsQuery, ListLiveSearchableCardsQueryVariables>(ListLiveSearchableCardsDocument, variables),
      options
    );
export const useInfiniteListLiveSearchableCardsQuery = <
      TData = ListLiveSearchableCardsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ListLiveSearchableCardsQueryVariables,
      variables: ListLiveSearchableCardsQueryVariables,
      options?: UseInfiniteQueryOptions<ListLiveSearchableCardsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ListLiveSearchableCardsQuery, TError, TData>(
      ['listLiveSearchableCards.infinite', variables],
      (metaData) => fetchCoreApi<ListLiveSearchableCardsQuery, ListLiveSearchableCardsQueryVariables>(ListLiveSearchableCardsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetLiveCardDocument = `
    query getLiveCard($cardId: ID!, $projectId: ID!) {
  getCardInstance(input: {cardId: $cardId, projectId: $projectId}) {
    ...detailedCardFields
  }
}
    ${DetailedCardFieldsFragmentDoc}`;
export const useGetLiveCardQuery = <
      TData = GetLiveCardQuery,
      TError = unknown
    >(
      variables: GetLiveCardQueryVariables,
      options?: UseQueryOptions<GetLiveCardQuery, TError, TData>
    ) =>
    useQuery<GetLiveCardQuery, TError, TData>(
      ['getLiveCard', variables],
      fetchCoreApi<GetLiveCardQuery, GetLiveCardQueryVariables>(GetLiveCardDocument, variables),
      options
    );
export const useInfiniteGetLiveCardQuery = <
      TData = GetLiveCardQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetLiveCardQueryVariables,
      variables: GetLiveCardQueryVariables,
      options?: UseInfiniteQueryOptions<GetLiveCardQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetLiveCardQuery, TError, TData>(
      ['getLiveCard.infinite', variables],
      (metaData) => fetchCoreApi<GetLiveCardQuery, GetLiveCardQueryVariables>(GetLiveCardDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const PreloadCardsDocument = `
    query preloadCards($input: IDInput!) {
  getProject(input: $input) {
    scopes(includeImported: false) {
      items {
        ...detailedCardFields
      }
    }
  }
}
    ${DetailedCardFieldsFragmentDoc}`;
export const usePreloadCardsQuery = <
      TData = PreloadCardsQuery,
      TError = unknown
    >(
      variables: PreloadCardsQueryVariables,
      options?: UseQueryOptions<PreloadCardsQuery, TError, TData>
    ) =>
    useQuery<PreloadCardsQuery, TError, TData>(
      ['preloadCards', variables],
      fetchCoreApi<PreloadCardsQuery, PreloadCardsQueryVariables>(PreloadCardsDocument, variables),
      options
    );
export const useInfinitePreloadCardsQuery = <
      TData = PreloadCardsQuery,
      TError = unknown
    >(
      pageParamKey: keyof PreloadCardsQueryVariables,
      variables: PreloadCardsQueryVariables,
      options?: UseInfiniteQueryOptions<PreloadCardsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<PreloadCardsQuery, TError, TData>(
      ['preloadCards.infinite', variables],
      (metaData) => fetchCoreApi<PreloadCardsQuery, PreloadCardsQueryVariables>(PreloadCardsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetCardDocument = `
    query getCard($id: ID!) {
  getCard(id: $id) {
    id
    title
  }
}
    `;
export const useGetCardQuery = <
      TData = GetCardQuery,
      TError = unknown
    >(
      variables: GetCardQueryVariables,
      options?: UseQueryOptions<GetCardQuery, TError, TData>
    ) =>
    useQuery<GetCardQuery, TError, TData>(
      ['getCard', variables],
      fetchCoreApi<GetCardQuery, GetCardQueryVariables>(GetCardDocument, variables),
      options
    );
export const useInfiniteGetCardQuery = <
      TData = GetCardQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetCardQueryVariables,
      variables: GetCardQueryVariables,
      options?: UseInfiniteQueryOptions<GetCardQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetCardQuery, TError, TData>(
      ['getCard.infinite', variables],
      (metaData) => fetchCoreApi<GetCardQuery, GetCardQueryVariables>(GetCardDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const RemoveFromFavoriteDocument = `
    mutation removeFromFavorite($id: ID!) {
  removeFromFavorite(cardId: $id) {
    cardId
  }
}
    `;
export const useRemoveFromFavoriteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveFromFavoriteMutation, TError, RemoveFromFavoriteMutationVariables, TContext>) =>
    useMutation<RemoveFromFavoriteMutation, TError, RemoveFromFavoriteMutationVariables, TContext>(
      ['removeFromFavorite'],
      (variables?: RemoveFromFavoriteMutationVariables) => fetchCoreApi<RemoveFromFavoriteMutation, RemoveFromFavoriteMutationVariables>(RemoveFromFavoriteDocument, variables)(),
      options
    );
export const AddToFavoriteDocument = `
    mutation addToFavorite($id: ID!) {
  addToFavorite(cardId: $id) {
    cardId
  }
}
    `;
export const useAddToFavoriteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddToFavoriteMutation, TError, AddToFavoriteMutationVariables, TContext>) =>
    useMutation<AddToFavoriteMutation, TError, AddToFavoriteMutationVariables, TContext>(
      ['addToFavorite'],
      (variables?: AddToFavoriteMutationVariables) => fetchCoreApi<AddToFavoriteMutation, AddToFavoriteMutationVariables>(AddToFavoriteDocument, variables)(),
      options
    );
export const GetLibraryCardDocument = `
    query getLibraryCard($id: ID!) {
  getCard(id: $id) {
    ...cardFields
  }
}
    ${CardFieldsFragmentDoc}`;
export const useGetLibraryCardQuery = <
      TData = GetLibraryCardQuery,
      TError = unknown
    >(
      variables: GetLibraryCardQueryVariables,
      options?: UseQueryOptions<GetLibraryCardQuery, TError, TData>
    ) =>
    useQuery<GetLibraryCardQuery, TError, TData>(
      ['getLibraryCard', variables],
      fetchCoreApi<GetLibraryCardQuery, GetLibraryCardQueryVariables>(GetLibraryCardDocument, variables),
      options
    );
export const useInfiniteGetLibraryCardQuery = <
      TData = GetLibraryCardQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetLibraryCardQueryVariables,
      variables: GetLibraryCardQueryVariables,
      options?: UseInfiniteQueryOptions<GetLibraryCardQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetLibraryCardQuery, TError, TData>(
      ['getLibraryCard.infinite', variables],
      (metaData) => fetchCoreApi<GetLibraryCardQuery, GetLibraryCardQueryVariables>(GetLibraryCardDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ListLatestUpdateCardsDocument = `
    query listLatestUpdateCards($input: IDInput!) {
  getProject(input: $input) {
    scopes {
      items {
        card {
          ...cardSummaryFields
        }
      }
    }
  }
}
    ${CardSummaryFieldsFragmentDoc}`;
export const useListLatestUpdateCardsQuery = <
      TData = ListLatestUpdateCardsQuery,
      TError = unknown
    >(
      variables: ListLatestUpdateCardsQueryVariables,
      options?: UseQueryOptions<ListLatestUpdateCardsQuery, TError, TData>
    ) =>
    useQuery<ListLatestUpdateCardsQuery, TError, TData>(
      ['listLatestUpdateCards', variables],
      fetchCoreApi<ListLatestUpdateCardsQuery, ListLatestUpdateCardsQueryVariables>(ListLatestUpdateCardsDocument, variables),
      options
    );
export const useInfiniteListLatestUpdateCardsQuery = <
      TData = ListLatestUpdateCardsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ListLatestUpdateCardsQueryVariables,
      variables: ListLatestUpdateCardsQueryVariables,
      options?: UseInfiniteQueryOptions<ListLatestUpdateCardsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ListLatestUpdateCardsQuery, TError, TData>(
      ['listLatestUpdateCards.infinite', variables],
      (metaData) => fetchCoreApi<ListLatestUpdateCardsQuery, ListLatestUpdateCardsQueryVariables>(ListLatestUpdateCardsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ListLiveProjectCardsDocument = `
    query listLiveProjectCards($input: IDInput!) {
  getProject(input: $input) {
    scopes {
      items {
        ...scopeFields
      }
    }
  }
}
    ${ScopeFieldsFragmentDoc}`;
export const useListLiveProjectCardsQuery = <
      TData = ListLiveProjectCardsQuery,
      TError = unknown
    >(
      variables: ListLiveProjectCardsQueryVariables,
      options?: UseQueryOptions<ListLiveProjectCardsQuery, TError, TData>
    ) =>
    useQuery<ListLiveProjectCardsQuery, TError, TData>(
      ['listLiveProjectCards', variables],
      fetchCoreApi<ListLiveProjectCardsQuery, ListLiveProjectCardsQueryVariables>(ListLiveProjectCardsDocument, variables),
      options
    );
export const useInfiniteListLiveProjectCardsQuery = <
      TData = ListLiveProjectCardsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ListLiveProjectCardsQueryVariables,
      variables: ListLiveProjectCardsQueryVariables,
      options?: UseInfiniteQueryOptions<ListLiveProjectCardsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ListLiveProjectCardsQuery, TError, TData>(
      ['listLiveProjectCards.infinite', variables],
      (metaData) => fetchCoreApi<ListLiveProjectCardsQuery, ListLiveProjectCardsQueryVariables>(ListLiveProjectCardsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ListCommandsDocument = `
    query listCommands($input: IDInput!) {
  getProject(input: $input) {
    commands {
      items {
        ...projectCommandFields
      }
    }
  }
}
    ${ProjectCommandFieldsFragmentDoc}`;
export const useListCommandsQuery = <
      TData = ListCommandsQuery,
      TError = unknown
    >(
      variables: ListCommandsQueryVariables,
      options?: UseQueryOptions<ListCommandsQuery, TError, TData>
    ) =>
    useQuery<ListCommandsQuery, TError, TData>(
      ['listCommands', variables],
      fetchCoreApi<ListCommandsQuery, ListCommandsQueryVariables>(ListCommandsDocument, variables),
      options
    );
export const useInfiniteListCommandsQuery = <
      TData = ListCommandsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ListCommandsQueryVariables,
      variables: ListCommandsQueryVariables,
      options?: UseInfiniteQueryOptions<ListCommandsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ListCommandsQuery, TError, TData>(
      ['listCommands.infinite', variables],
      (metaData) => fetchCoreApi<ListCommandsQuery, ListCommandsQueryVariables>(ListCommandsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const CreateCommentDocument = `
    mutation createComment($input: CreateCommentInput!) {
  createComment(input: $input) {
    ...commentFields
  }
}
    ${CommentFieldsFragmentDoc}`;
export const useCreateCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCommentMutation, TError, CreateCommentMutationVariables, TContext>) =>
    useMutation<CreateCommentMutation, TError, CreateCommentMutationVariables, TContext>(
      ['createComment'],
      (variables?: CreateCommentMutationVariables) => fetchCoreApi<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, variables)(),
      options
    );
export const UpdateCommentDocument = `
    mutation updateComment($input: UpdateCommentInput!) {
  updateComment(input: $input) {
    ...commentFields
  }
}
    ${CommentFieldsFragmentDoc}`;
export const useUpdateCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCommentMutation, TError, UpdateCommentMutationVariables, TContext>) =>
    useMutation<UpdateCommentMutation, TError, UpdateCommentMutationVariables, TContext>(
      ['updateComment'],
      (variables?: UpdateCommentMutationVariables) => fetchCoreApi<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, variables)(),
      options
    );
export const DeleteCommentDocument = `
    mutation deleteComment($input: DeleteCommentInput!) {
  deleteComment(input: $input) {
    ...commentFields
  }
}
    ${CommentFieldsFragmentDoc}`;
export const useDeleteCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCommentMutation, TError, DeleteCommentMutationVariables, TContext>) =>
    useMutation<DeleteCommentMutation, TError, DeleteCommentMutationVariables, TContext>(
      ['deleteComment'],
      (variables?: DeleteCommentMutationVariables) => fetchCoreApi<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, variables)(),
      options
    );
export const ListCommentsDocument = `
    query listComments($id: ID!) {
  queryComments(id: $id) {
    items {
      ...commentFields
    }
  }
}
    ${CommentFieldsFragmentDoc}`;
export const useListCommentsQuery = <
      TData = ListCommentsQuery,
      TError = unknown
    >(
      variables: ListCommentsQueryVariables,
      options?: UseQueryOptions<ListCommentsQuery, TError, TData>
    ) =>
    useQuery<ListCommentsQuery, TError, TData>(
      ['listComments', variables],
      fetchCoreApi<ListCommentsQuery, ListCommentsQueryVariables>(ListCommentsDocument, variables),
      options
    );
export const useInfiniteListCommentsQuery = <
      TData = ListCommentsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ListCommentsQueryVariables,
      variables: ListCommentsQueryVariables,
      options?: UseInfiniteQueryOptions<ListCommentsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ListCommentsQuery, TError, TData>(
      ['listComments.infinite', variables],
      (metaData) => fetchCoreApi<ListCommentsQuery, ListCommentsQueryVariables>(ListCommentsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetComplianceDocument = `
    query getCompliance($input: IDInput!) {
  topics: listOrganizationTopics {
    items {
      ...topicFields
    }
  }
}
    ${TopicFieldsFragmentDoc}`;
export const useGetComplianceQuery = <
      TData = GetComplianceQuery,
      TError = unknown
    >(
      variables: GetComplianceQueryVariables,
      options?: UseQueryOptions<GetComplianceQuery, TError, TData>
    ) =>
    useQuery<GetComplianceQuery, TError, TData>(
      ['getCompliance', variables],
      fetchCoreApi<GetComplianceQuery, GetComplianceQueryVariables>(GetComplianceDocument, variables),
      options
    );
export const useInfiniteGetComplianceQuery = <
      TData = GetComplianceQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetComplianceQueryVariables,
      variables: GetComplianceQueryVariables,
      options?: UseInfiniteQueryOptions<GetComplianceQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetComplianceQuery, TError, TData>(
      ['getCompliance.infinite', variables],
      (metaData) => fetchCoreApi<GetComplianceQuery, GetComplianceQueryVariables>(GetComplianceDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetProjectComplianceDocument = `
    query getProjectCompliance($input: IDInput!) {
  getProject(input: $input) {
    id
    name
    mandatoryTopics: complianceTopics(input: {value: true}) {
      ...mandatoryTopicFields
    }
    formulationTopics: complianceTopics(input: {value: false}) {
      ...mandatoryTopicFields
    }
  }
}
    ${MandatoryTopicFieldsFragmentDoc}`;
export const useGetProjectComplianceQuery = <
      TData = GetProjectComplianceQuery,
      TError = unknown
    >(
      variables: GetProjectComplianceQueryVariables,
      options?: UseQueryOptions<GetProjectComplianceQuery, TError, TData>
    ) =>
    useQuery<GetProjectComplianceQuery, TError, TData>(
      ['getProjectCompliance', variables],
      fetchCoreApi<GetProjectComplianceQuery, GetProjectComplianceQueryVariables>(GetProjectComplianceDocument, variables),
      options
    );
export const useInfiniteGetProjectComplianceQuery = <
      TData = GetProjectComplianceQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetProjectComplianceQueryVariables,
      variables: GetProjectComplianceQueryVariables,
      options?: UseInfiniteQueryOptions<GetProjectComplianceQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetProjectComplianceQuery, TError, TData>(
      ['getProjectCompliance.infinite', variables],
      (metaData) => fetchCoreApi<GetProjectComplianceQuery, GetProjectComplianceQueryVariables>(GetProjectComplianceDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ListLiveUserContentRequestsDocument = `
    query listLiveUserContentRequests($input: ListContentRequestsInput) {
  requests: listContentRequests(input: $input) {
    items {
      ...contentRequestFields
    }
    nextToken
  }
}
    ${ContentRequestFieldsFragmentDoc}`;
export const useListLiveUserContentRequestsQuery = <
      TData = ListLiveUserContentRequestsQuery,
      TError = unknown
    >(
      variables?: ListLiveUserContentRequestsQueryVariables,
      options?: UseQueryOptions<ListLiveUserContentRequestsQuery, TError, TData>
    ) =>
    useQuery<ListLiveUserContentRequestsQuery, TError, TData>(
      variables === undefined ? ['listLiveUserContentRequests'] : ['listLiveUserContentRequests', variables],
      fetchCoreApi<ListLiveUserContentRequestsQuery, ListLiveUserContentRequestsQueryVariables>(ListLiveUserContentRequestsDocument, variables),
      options
    );
export const useInfiniteListLiveUserContentRequestsQuery = <
      TData = ListLiveUserContentRequestsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ListLiveUserContentRequestsQueryVariables,
      variables?: ListLiveUserContentRequestsQueryVariables,
      options?: UseInfiniteQueryOptions<ListLiveUserContentRequestsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ListLiveUserContentRequestsQuery, TError, TData>(
      variables === undefined ? ['listLiveUserContentRequests.infinite'] : ['listLiveUserContentRequests.infinite', variables],
      (metaData) => fetchCoreApi<ListLiveUserContentRequestsQuery, ListLiveUserContentRequestsQueryVariables>(ListLiveUserContentRequestsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetLiveContentRequestDocument = `
    query getLiveContentRequest($input: NumberIdInput!) {
  getContentRequest(input: $input) {
    ...contentRequestFields
  }
}
    ${ContentRequestFieldsFragmentDoc}`;
export const useGetLiveContentRequestQuery = <
      TData = GetLiveContentRequestQuery,
      TError = unknown
    >(
      variables: GetLiveContentRequestQueryVariables,
      options?: UseQueryOptions<GetLiveContentRequestQuery, TError, TData>
    ) =>
    useQuery<GetLiveContentRequestQuery, TError, TData>(
      ['getLiveContentRequest', variables],
      fetchCoreApi<GetLiveContentRequestQuery, GetLiveContentRequestQueryVariables>(GetLiveContentRequestDocument, variables),
      options
    );
export const useInfiniteGetLiveContentRequestQuery = <
      TData = GetLiveContentRequestQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetLiveContentRequestQueryVariables,
      variables: GetLiveContentRequestQueryVariables,
      options?: UseInfiniteQueryOptions<GetLiveContentRequestQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetLiveContentRequestQuery, TError, TData>(
      ['getLiveContentRequest.infinite', variables],
      (metaData) => fetchCoreApi<GetLiveContentRequestQuery, GetLiveContentRequestQueryVariables>(GetLiveContentRequestDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const CreateContentRequestDocument = `
    mutation createContentRequest($input: CreateContentRequestInput!) {
  createContentRequest(input: $input) {
    createdAt
  }
}
    `;
export const useCreateContentRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateContentRequestMutation, TError, CreateContentRequestMutationVariables, TContext>) =>
    useMutation<CreateContentRequestMutation, TError, CreateContentRequestMutationVariables, TContext>(
      ['createContentRequest'],
      (variables?: CreateContentRequestMutationVariables) => fetchCoreApi<CreateContentRequestMutation, CreateContentRequestMutationVariables>(CreateContentRequestDocument, variables)(),
      options
    );
export const ListDecisionTreesDocument = `
    query listDecisionTrees($input: IDInput!) {
  getProject(input: $input) {
    id
    name
    decisionTrees {
      ...decisionTreeFields
    }
  }
}
    ${DecisionTreeFieldsFragmentDoc}`;
export const useListDecisionTreesQuery = <
      TData = ListDecisionTreesQuery,
      TError = unknown
    >(
      variables: ListDecisionTreesQueryVariables,
      options?: UseQueryOptions<ListDecisionTreesQuery, TError, TData>
    ) =>
    useQuery<ListDecisionTreesQuery, TError, TData>(
      ['listDecisionTrees', variables],
      fetchCoreApi<ListDecisionTreesQuery, ListDecisionTreesQueryVariables>(ListDecisionTreesDocument, variables),
      options
    );
export const useInfiniteListDecisionTreesQuery = <
      TData = ListDecisionTreesQuery,
      TError = unknown
    >(
      pageParamKey: keyof ListDecisionTreesQueryVariables,
      variables: ListDecisionTreesQueryVariables,
      options?: UseInfiniteQueryOptions<ListDecisionTreesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ListDecisionTreesQuery, TError, TData>(
      ['listDecisionTrees.infinite', variables],
      (metaData) => fetchCoreApi<ListDecisionTreesQuery, ListDecisionTreesQueryVariables>(ListDecisionTreesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetDecisionTreeDocument = `
    query getDecisionTree($input: IDInput!) {
  getDecisionTree(input: $input) {
    ...decisionTreeFields
    nodes {
      ...decisionTreeNodeFields
    }
  }
}
    ${DecisionTreeFieldsFragmentDoc}
${DecisionTreeNodeFieldsFragmentDoc}`;
export const useGetDecisionTreeQuery = <
      TData = GetDecisionTreeQuery,
      TError = unknown
    >(
      variables: GetDecisionTreeQueryVariables,
      options?: UseQueryOptions<GetDecisionTreeQuery, TError, TData>
    ) =>
    useQuery<GetDecisionTreeQuery, TError, TData>(
      ['getDecisionTree', variables],
      fetchCoreApi<GetDecisionTreeQuery, GetDecisionTreeQueryVariables>(GetDecisionTreeDocument, variables),
      options
    );
export const useInfiniteGetDecisionTreeQuery = <
      TData = GetDecisionTreeQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetDecisionTreeQueryVariables,
      variables: GetDecisionTreeQueryVariables,
      options?: UseInfiniteQueryOptions<GetDecisionTreeQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetDecisionTreeQuery, TError, TData>(
      ['getDecisionTree.infinite', variables],
      (metaData) => fetchCoreApi<GetDecisionTreeQuery, GetDecisionTreeQueryVariables>(GetDecisionTreeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetDecisionTreeNodeDocument = `
    query getDecisionTreeNode($input: IDInput!) {
  getDecisionTreeNode(input: $input) {
    ...decisionTreeNodeFields
  }
}
    ${DecisionTreeNodeFieldsFragmentDoc}`;
export const useGetDecisionTreeNodeQuery = <
      TData = GetDecisionTreeNodeQuery,
      TError = unknown
    >(
      variables: GetDecisionTreeNodeQueryVariables,
      options?: UseQueryOptions<GetDecisionTreeNodeQuery, TError, TData>
    ) =>
    useQuery<GetDecisionTreeNodeQuery, TError, TData>(
      ['getDecisionTreeNode', variables],
      fetchCoreApi<GetDecisionTreeNodeQuery, GetDecisionTreeNodeQueryVariables>(GetDecisionTreeNodeDocument, variables),
      options
    );
export const useInfiniteGetDecisionTreeNodeQuery = <
      TData = GetDecisionTreeNodeQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetDecisionTreeNodeQueryVariables,
      variables: GetDecisionTreeNodeQueryVariables,
      options?: UseInfiniteQueryOptions<GetDecisionTreeNodeQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetDecisionTreeNodeQuery, TError, TData>(
      ['getDecisionTreeNode.infinite', variables],
      (metaData) => fetchCoreApi<GetDecisionTreeNodeQuery, GetDecisionTreeNodeQueryVariables>(GetDecisionTreeNodeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetCurrentDecisionTreeDocument = `
    query getCurrentDecisionTree($input: IDInput!) {
  getDecisionTreeRun(input: $input) {
    id
    decisionTree {
      ...decisionTreeFields
      nodes {
        ...decisionTreeNodeFields
      }
    }
  }
}
    ${DecisionTreeFieldsFragmentDoc}
${DecisionTreeNodeFieldsFragmentDoc}`;
export const useGetCurrentDecisionTreeQuery = <
      TData = GetCurrentDecisionTreeQuery,
      TError = unknown
    >(
      variables: GetCurrentDecisionTreeQueryVariables,
      options?: UseQueryOptions<GetCurrentDecisionTreeQuery, TError, TData>
    ) =>
    useQuery<GetCurrentDecisionTreeQuery, TError, TData>(
      ['getCurrentDecisionTree', variables],
      fetchCoreApi<GetCurrentDecisionTreeQuery, GetCurrentDecisionTreeQueryVariables>(GetCurrentDecisionTreeDocument, variables),
      options
    );
export const useInfiniteGetCurrentDecisionTreeQuery = <
      TData = GetCurrentDecisionTreeQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetCurrentDecisionTreeQueryVariables,
      variables: GetCurrentDecisionTreeQueryVariables,
      options?: UseInfiniteQueryOptions<GetCurrentDecisionTreeQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetCurrentDecisionTreeQuery, TError, TData>(
      ['getCurrentDecisionTree.infinite', variables],
      (metaData) => fetchCoreApi<GetCurrentDecisionTreeQuery, GetCurrentDecisionTreeQueryVariables>(GetCurrentDecisionTreeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetDecisionTreeRunDocument = `
    query getDecisionTreeRun($input: IDInput!) {
  getDecisionTreeRun(input: $input) {
    id
    comments {
      nodeId
      userComment
    }
    nodes {
      node {
        ...decisionTreeNodeFields
      }
    }
  }
}
    ${DecisionTreeNodeFieldsFragmentDoc}`;
export const useGetDecisionTreeRunQuery = <
      TData = GetDecisionTreeRunQuery,
      TError = unknown
    >(
      variables: GetDecisionTreeRunQueryVariables,
      options?: UseQueryOptions<GetDecisionTreeRunQuery, TError, TData>
    ) =>
    useQuery<GetDecisionTreeRunQuery, TError, TData>(
      ['getDecisionTreeRun', variables],
      fetchCoreApi<GetDecisionTreeRunQuery, GetDecisionTreeRunQueryVariables>(GetDecisionTreeRunDocument, variables),
      options
    );
export const useInfiniteGetDecisionTreeRunQuery = <
      TData = GetDecisionTreeRunQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetDecisionTreeRunQueryVariables,
      variables: GetDecisionTreeRunQueryVariables,
      options?: UseInfiniteQueryOptions<GetDecisionTreeRunQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetDecisionTreeRunQuery, TError, TData>(
      ['getDecisionTreeRun.infinite', variables],
      (metaData) => fetchCoreApi<GetDecisionTreeRunQuery, GetDecisionTreeRunQueryVariables>(GetDecisionTreeRunDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const StartDecisionTreeRunDocument = `
    mutation startDecisionTreeRun($input: StartDecisionTreeRunInput!) {
  startDecisionTreeRun(input: $input) {
    id
  }
}
    `;
export const useStartDecisionTreeRunMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartDecisionTreeRunMutation, TError, StartDecisionTreeRunMutationVariables, TContext>) =>
    useMutation<StartDecisionTreeRunMutation, TError, StartDecisionTreeRunMutationVariables, TContext>(
      ['startDecisionTreeRun'],
      (variables?: StartDecisionTreeRunMutationVariables) => fetchCoreApi<StartDecisionTreeRunMutation, StartDecisionTreeRunMutationVariables>(StartDecisionTreeRunDocument, variables)(),
      options
    );
export const UpdateDecisionTreeRunHistoryDocument = `
    mutation updateDecisionTreeRunHistory($input: UpdateDecisionTreeRunHistoryInput!) {
  updateDecisionTreeRunHistory(input: $input) {
    id
  }
}
    `;
export const useUpdateDecisionTreeRunHistoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDecisionTreeRunHistoryMutation, TError, UpdateDecisionTreeRunHistoryMutationVariables, TContext>) =>
    useMutation<UpdateDecisionTreeRunHistoryMutation, TError, UpdateDecisionTreeRunHistoryMutationVariables, TContext>(
      ['updateDecisionTreeRunHistory'],
      (variables?: UpdateDecisionTreeRunHistoryMutationVariables) => fetchCoreApi<UpdateDecisionTreeRunHistoryMutation, UpdateDecisionTreeRunHistoryMutationVariables>(UpdateDecisionTreeRunHistoryDocument, variables)(),
      options
    );
export const WriteDecisionTreeRunCommentDocument = `
    mutation writeDecisionTreeRunComment($input: WriteDecisionTreeRunCommentInput!) {
  writeDecisionTreeRunComment(input: $input) {
    id
    comments {
      nodeId
      userComment
    }
  }
}
    `;
export const useWriteDecisionTreeRunCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<WriteDecisionTreeRunCommentMutation, TError, WriteDecisionTreeRunCommentMutationVariables, TContext>) =>
    useMutation<WriteDecisionTreeRunCommentMutation, TError, WriteDecisionTreeRunCommentMutationVariables, TContext>(
      ['writeDecisionTreeRunComment'],
      (variables?: WriteDecisionTreeRunCommentMutationVariables) => fetchCoreApi<WriteDecisionTreeRunCommentMutation, WriteDecisionTreeRunCommentMutationVariables>(WriteDecisionTreeRunCommentDocument, variables)(),
      options
    );
export const CreateLiveDisplayDocument = `
    mutation createLiveDisplay($input: CreateDisplayInput!) {
  createDisplay(input: $input) {
    ...displayFields
  }
}
    ${DisplayFieldsFragmentDoc}`;
export const useCreateLiveDisplayMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateLiveDisplayMutation, TError, CreateLiveDisplayMutationVariables, TContext>) =>
    useMutation<CreateLiveDisplayMutation, TError, CreateLiveDisplayMutationVariables, TContext>(
      ['createLiveDisplay'],
      (variables?: CreateLiveDisplayMutationVariables) => fetchCoreApi<CreateLiveDisplayMutation, CreateLiveDisplayMutationVariables>(CreateLiveDisplayDocument, variables)(),
      options
    );
export const GetLiveDisplayDocument = `
    query getLiveDisplay($input: IDInput!) {
  getDisplay(input: $input) {
    ...displayFields
  }
}
    ${DisplayFieldsFragmentDoc}`;
export const useGetLiveDisplayQuery = <
      TData = GetLiveDisplayQuery,
      TError = unknown
    >(
      variables: GetLiveDisplayQueryVariables,
      options?: UseQueryOptions<GetLiveDisplayQuery, TError, TData>
    ) =>
    useQuery<GetLiveDisplayQuery, TError, TData>(
      ['getLiveDisplay', variables],
      fetchCoreApi<GetLiveDisplayQuery, GetLiveDisplayQueryVariables>(GetLiveDisplayDocument, variables),
      options
    );
export const useInfiniteGetLiveDisplayQuery = <
      TData = GetLiveDisplayQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetLiveDisplayQueryVariables,
      variables: GetLiveDisplayQueryVariables,
      options?: UseInfiniteQueryOptions<GetLiveDisplayQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetLiveDisplayQuery, TError, TData>(
      ['getLiveDisplay.infinite', variables],
      (metaData) => fetchCoreApi<GetLiveDisplayQuery, GetLiveDisplayQueryVariables>(GetLiveDisplayDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const UpdateLiveDisplayFeedbackDocument = `
    mutation updateLiveDisplayFeedback($input: UpdateDisplayFeedbackInput!) {
  updateDisplayFeedback(input: $input) {
    ...displayFields
  }
}
    ${DisplayFieldsFragmentDoc}`;
export const useUpdateLiveDisplayFeedbackMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLiveDisplayFeedbackMutation, TError, UpdateLiveDisplayFeedbackMutationVariables, TContext>) =>
    useMutation<UpdateLiveDisplayFeedbackMutation, TError, UpdateLiveDisplayFeedbackMutationVariables, TContext>(
      ['updateLiveDisplayFeedback'],
      (variables?: UpdateLiveDisplayFeedbackMutationVariables) => fetchCoreApi<UpdateLiveDisplayFeedbackMutation, UpdateLiveDisplayFeedbackMutationVariables>(UpdateLiveDisplayFeedbackDocument, variables)(),
      options
    );
export const UpdateLiveDisplayDocument = `
    mutation updateLiveDisplay($input: UpdateDisplayInput!) {
  updateDisplay(input: $input) {
    ...displayFields
  }
}
    ${DisplayFieldsFragmentDoc}`;
export const useUpdateLiveDisplayMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLiveDisplayMutation, TError, UpdateLiveDisplayMutationVariables, TContext>) =>
    useMutation<UpdateLiveDisplayMutation, TError, UpdateLiveDisplayMutationVariables, TContext>(
      ['updateLiveDisplay'],
      (variables?: UpdateLiveDisplayMutationVariables) => fetchCoreApi<UpdateLiveDisplayMutation, UpdateLiveDisplayMutationVariables>(UpdateLiveDisplayDocument, variables)(),
      options
    );
export const ListCurrentNewsDocument = `
    query listCurrentNews($input: IDInput!) {
  news: listCurrentNews(input: $input) {
    ...newsFields
  }
}
    ${NewsFieldsFragmentDoc}`;
export const useListCurrentNewsQuery = <
      TData = ListCurrentNewsQuery,
      TError = unknown
    >(
      variables: ListCurrentNewsQueryVariables,
      options?: UseQueryOptions<ListCurrentNewsQuery, TError, TData>
    ) =>
    useQuery<ListCurrentNewsQuery, TError, TData>(
      ['listCurrentNews', variables],
      fetchCoreApi<ListCurrentNewsQuery, ListCurrentNewsQueryVariables>(ListCurrentNewsDocument, variables),
      options
    );
export const useInfiniteListCurrentNewsQuery = <
      TData = ListCurrentNewsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ListCurrentNewsQueryVariables,
      variables: ListCurrentNewsQueryVariables,
      options?: UseInfiniteQueryOptions<ListCurrentNewsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ListCurrentNewsQuery, TError, TData>(
      ['listCurrentNews.infinite', variables],
      (metaData) => fetchCoreApi<ListCurrentNewsQuery, ListCurrentNewsQueryVariables>(ListCurrentNewsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const IdentityNotificationsDocument = `
    query identityNotifications($nextToken: String) {
  queryIdentityNotifications(nextToken: $nextToken) {
    items {
      ...notificationFields
    }
    nextToken
  }
}
    ${NotificationFieldsFragmentDoc}`;
export const useIdentityNotificationsQuery = <
      TData = IdentityNotificationsQuery,
      TError = unknown
    >(
      variables?: IdentityNotificationsQueryVariables,
      options?: UseQueryOptions<IdentityNotificationsQuery, TError, TData>
    ) =>
    useQuery<IdentityNotificationsQuery, TError, TData>(
      variables === undefined ? ['identityNotifications'] : ['identityNotifications', variables],
      fetchCoreApi<IdentityNotificationsQuery, IdentityNotificationsQueryVariables>(IdentityNotificationsDocument, variables),
      options
    );
export const useInfiniteIdentityNotificationsQuery = <
      TData = IdentityNotificationsQuery,
      TError = unknown
    >(
      pageParamKey: keyof IdentityNotificationsQueryVariables,
      variables?: IdentityNotificationsQueryVariables,
      options?: UseInfiniteQueryOptions<IdentityNotificationsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<IdentityNotificationsQuery, TError, TData>(
      variables === undefined ? ['identityNotifications.infinite'] : ['identityNotifications.infinite', variables],
      (metaData) => fetchCoreApi<IdentityNotificationsQuery, IdentityNotificationsQueryVariables>(IdentityNotificationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const IdentityNumNotificationsDocument = `
    query identityNumNotifications {
  getUserInfo {
    numNotifications
  }
}
    `;
export const useIdentityNumNotificationsQuery = <
      TData = IdentityNumNotificationsQuery,
      TError = unknown
    >(
      variables?: IdentityNumNotificationsQueryVariables,
      options?: UseQueryOptions<IdentityNumNotificationsQuery, TError, TData>
    ) =>
    useQuery<IdentityNumNotificationsQuery, TError, TData>(
      variables === undefined ? ['identityNumNotifications'] : ['identityNumNotifications', variables],
      fetchCoreApi<IdentityNumNotificationsQuery, IdentityNumNotificationsQueryVariables>(IdentityNumNotificationsDocument, variables),
      options
    );
export const useInfiniteIdentityNumNotificationsQuery = <
      TData = IdentityNumNotificationsQuery,
      TError = unknown
    >(
      pageParamKey: keyof IdentityNumNotificationsQueryVariables,
      variables?: IdentityNumNotificationsQueryVariables,
      options?: UseInfiniteQueryOptions<IdentityNumNotificationsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<IdentityNumNotificationsQuery, TError, TData>(
      variables === undefined ? ['identityNumNotifications.infinite'] : ['identityNumNotifications.infinite', variables],
      (metaData) => fetchCoreApi<IdentityNumNotificationsQuery, IdentityNumNotificationsQueryVariables>(IdentityNumNotificationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const AcknowledgeNotificationDocument = `
    mutation acknowledgeNotification($input: AcknowledgeNotificationInput!) {
  acknowledgeNotification(input: $input) {
    eventId
  }
}
    `;
export const useAcknowledgeNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AcknowledgeNotificationMutation, TError, AcknowledgeNotificationMutationVariables, TContext>) =>
    useMutation<AcknowledgeNotificationMutation, TError, AcknowledgeNotificationMutationVariables, TContext>(
      ['acknowledgeNotification'],
      (variables?: AcknowledgeNotificationMutationVariables) => fetchCoreApi<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>(AcknowledgeNotificationDocument, variables)(),
      options
    );
export const AcknowledgeAllNotificationsDocument = `
    mutation acknowledgeAllNotifications {
  acknowledgeAllNotifications {
    eventId
  }
}
    `;
export const useAcknowledgeAllNotificationsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AcknowledgeAllNotificationsMutation, TError, AcknowledgeAllNotificationsMutationVariables, TContext>) =>
    useMutation<AcknowledgeAllNotificationsMutation, TError, AcknowledgeAllNotificationsMutationVariables, TContext>(
      ['acknowledgeAllNotifications'],
      (variables?: AcknowledgeAllNotificationsMutationVariables) => fetchCoreApi<AcknowledgeAllNotificationsMutation, AcknowledgeAllNotificationsMutationVariables>(AcknowledgeAllNotificationsDocument, variables)(),
      options
    );
export const GetNotificationDocument = `
    query getNotification($id: ID!) {
  getNotification(id: $id) {
    ...notificationFields
  }
}
    ${NotificationFieldsFragmentDoc}`;
export const useGetNotificationQuery = <
      TData = GetNotificationQuery,
      TError = unknown
    >(
      variables: GetNotificationQueryVariables,
      options?: UseQueryOptions<GetNotificationQuery, TError, TData>
    ) =>
    useQuery<GetNotificationQuery, TError, TData>(
      ['getNotification', variables],
      fetchCoreApi<GetNotificationQuery, GetNotificationQueryVariables>(GetNotificationDocument, variables),
      options
    );
export const useInfiniteGetNotificationQuery = <
      TData = GetNotificationQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetNotificationQueryVariables,
      variables: GetNotificationQueryVariables,
      options?: UseInfiniteQueryOptions<GetNotificationQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetNotificationQuery, TError, TData>(
      ['getNotification.infinite', variables],
      (metaData) => fetchCoreApi<GetNotificationQuery, GetNotificationQueryVariables>(GetNotificationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetOrganisationDocument = `
    query getOrganisation {
  org: getOrganisation {
    ...organisationFields
  }
}
    ${OrganisationFieldsFragmentDoc}`;
export const useGetOrganisationQuery = <
      TData = GetOrganisationQuery,
      TError = unknown
    >(
      variables?: GetOrganisationQueryVariables,
      options?: UseQueryOptions<GetOrganisationQuery, TError, TData>
    ) =>
    useQuery<GetOrganisationQuery, TError, TData>(
      variables === undefined ? ['getOrganisation'] : ['getOrganisation', variables],
      fetchCoreApi<GetOrganisationQuery, GetOrganisationQueryVariables>(GetOrganisationDocument, variables),
      options
    );
export const useInfiniteGetOrganisationQuery = <
      TData = GetOrganisationQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetOrganisationQueryVariables,
      variables?: GetOrganisationQueryVariables,
      options?: UseInfiniteQueryOptions<GetOrganisationQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetOrganisationQuery, TError, TData>(
      variables === undefined ? ['getOrganisation.infinite'] : ['getOrganisation.infinite', variables],
      (metaData) => fetchCoreApi<GetOrganisationQuery, GetOrganisationQueryVariables>(GetOrganisationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ListLiveProjectsDocument = `
    query listLiveProjects {
  listProjects {
    ...projectFields
  }
}
    ${ProjectFieldsFragmentDoc}`;
export const useListLiveProjectsQuery = <
      TData = ListLiveProjectsQuery,
      TError = unknown
    >(
      variables?: ListLiveProjectsQueryVariables,
      options?: UseQueryOptions<ListLiveProjectsQuery, TError, TData>
    ) =>
    useQuery<ListLiveProjectsQuery, TError, TData>(
      variables === undefined ? ['listLiveProjects'] : ['listLiveProjects', variables],
      fetchCoreApi<ListLiveProjectsQuery, ListLiveProjectsQueryVariables>(ListLiveProjectsDocument, variables),
      options
    );
export const useInfiniteListLiveProjectsQuery = <
      TData = ListLiveProjectsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ListLiveProjectsQueryVariables,
      variables?: ListLiveProjectsQueryVariables,
      options?: UseInfiniteQueryOptions<ListLiveProjectsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ListLiveProjectsQuery, TError, TData>(
      variables === undefined ? ['listLiveProjects.infinite'] : ['listLiveProjects.infinite', variables],
      (metaData) => fetchCoreApi<ListLiveProjectsQuery, ListLiveProjectsQueryVariables>(ListLiveProjectsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetLiveProjectDocument = `
    query getLiveProject($input: IDInput!) {
  getProject(input: $input) {
    ...projectFields
    commandContexts {
      ...commandContextFields
    }
  }
}
    ${ProjectFieldsFragmentDoc}
${CommandContextFieldsFragmentDoc}`;
export const useGetLiveProjectQuery = <
      TData = GetLiveProjectQuery,
      TError = unknown
    >(
      variables: GetLiveProjectQueryVariables,
      options?: UseQueryOptions<GetLiveProjectQuery, TError, TData>
    ) =>
    useQuery<GetLiveProjectQuery, TError, TData>(
      ['getLiveProject', variables],
      fetchCoreApi<GetLiveProjectQuery, GetLiveProjectQueryVariables>(GetLiveProjectDocument, variables),
      options
    );
export const useInfiniteGetLiveProjectQuery = <
      TData = GetLiveProjectQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetLiveProjectQueryVariables,
      variables: GetLiveProjectQueryVariables,
      options?: UseInfiniteQueryOptions<GetLiveProjectQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetLiveProjectQuery, TError, TData>(
      ['getLiveProject.infinite', variables],
      (metaData) => fetchCoreApi<GetLiveProjectQuery, GetLiveProjectQueryVariables>(GetLiveProjectDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const CreateSessionDocument = `
    mutation createSession($input: CreateSessionInput!) {
  createSession(input: $input) {
    ...sessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export const useCreateSessionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSessionMutation, TError, CreateSessionMutationVariables, TContext>) =>
    useMutation<CreateSessionMutation, TError, CreateSessionMutationVariables, TContext>(
      ['createSession'],
      (variables?: CreateSessionMutationVariables) => fetchCoreApi<CreateSessionMutation, CreateSessionMutationVariables>(CreateSessionDocument, variables)(),
      options
    );
export const UpdateSessionDurationDocument = `
    mutation updateSessionDuration($input: UpateSessionInput!) {
  updateSessionDuration2(input: $input) {
    ...sessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export const useUpdateSessionDurationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSessionDurationMutation, TError, UpdateSessionDurationMutationVariables, TContext>) =>
    useMutation<UpdateSessionDurationMutation, TError, UpdateSessionDurationMutationVariables, TContext>(
      ['updateSessionDuration'],
      (variables?: UpdateSessionDurationMutationVariables) => fetchCoreApi<UpdateSessionDurationMutation, UpdateSessionDurationMutationVariables>(UpdateSessionDurationDocument, variables)(),
      options
    );
export const GetLiveSessionDocument = `
    query getLiveSession($input: IDInput!) {
  getSession(input: $input) {
    ...sessionFields
    detections {
      ...detectionFields
    }
  }
}
    ${SessionFieldsFragmentDoc}
${DetectionFieldsFragmentDoc}`;
export const useGetLiveSessionQuery = <
      TData = GetLiveSessionQuery,
      TError = unknown
    >(
      variables: GetLiveSessionQueryVariables,
      options?: UseQueryOptions<GetLiveSessionQuery, TError, TData>
    ) =>
    useQuery<GetLiveSessionQuery, TError, TData>(
      ['getLiveSession', variables],
      fetchCoreApi<GetLiveSessionQuery, GetLiveSessionQueryVariables>(GetLiveSessionDocument, variables),
      options
    );
export const useInfiniteGetLiveSessionQuery = <
      TData = GetLiveSessionQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetLiveSessionQueryVariables,
      variables: GetLiveSessionQueryVariables,
      options?: UseInfiniteQueryOptions<GetLiveSessionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetLiveSessionQuery, TError, TData>(
      ['getLiveSession.infinite', variables],
      (metaData) => fetchCoreApi<GetLiveSessionQuery, GetLiveSessionQueryVariables>(GetLiveSessionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetUserEngagementStatsDocument = `
    query getUserEngagementStats($input: GetUserPerformanceStatsInput!) {
  getUserPerformanceStats {
    engagement(input: $input) {
      current {
        ...userEngagementMetricsFields
      }
      previous {
        ...userEngagementMetricsFields
      }
    }
  }
}
    ${UserEngagementMetricsFieldsFragmentDoc}`;
export const useGetUserEngagementStatsQuery = <
      TData = GetUserEngagementStatsQuery,
      TError = unknown
    >(
      variables: GetUserEngagementStatsQueryVariables,
      options?: UseQueryOptions<GetUserEngagementStatsQuery, TError, TData>
    ) =>
    useQuery<GetUserEngagementStatsQuery, TError, TData>(
      ['getUserEngagementStats', variables],
      fetchCoreApi<GetUserEngagementStatsQuery, GetUserEngagementStatsQueryVariables>(GetUserEngagementStatsDocument, variables),
      options
    );
export const useInfiniteGetUserEngagementStatsQuery = <
      TData = GetUserEngagementStatsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetUserEngagementStatsQueryVariables,
      variables: GetUserEngagementStatsQueryVariables,
      options?: UseInfiniteQueryOptions<GetUserEngagementStatsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetUserEngagementStatsQuery, TError, TData>(
      ['getUserEngagementStats.infinite', variables],
      (metaData) => fetchCoreApi<GetUserEngagementStatsQuery, GetUserEngagementStatsQueryVariables>(GetUserEngagementStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetUserComplianceStatsDocument = `
    query getUserComplianceStats($input: GetUserPerformanceStatsInput!) {
  getUserPerformanceStats {
    compliance(input: $input) {
      current {
        ...relativeMetricFields
      }
      previous {
        ...relativeMetricFields
      }
      table {
        ...topicComplianceStatFields
      }
    }
  }
}
    ${RelativeMetricFieldsFragmentDoc}
${TopicComplianceStatFieldsFragmentDoc}`;
export const useGetUserComplianceStatsQuery = <
      TData = GetUserComplianceStatsQuery,
      TError = unknown
    >(
      variables: GetUserComplianceStatsQueryVariables,
      options?: UseQueryOptions<GetUserComplianceStatsQuery, TError, TData>
    ) =>
    useQuery<GetUserComplianceStatsQuery, TError, TData>(
      ['getUserComplianceStats', variables],
      fetchCoreApi<GetUserComplianceStatsQuery, GetUserComplianceStatsQueryVariables>(GetUserComplianceStatsDocument, variables),
      options
    );
export const useInfiniteGetUserComplianceStatsQuery = <
      TData = GetUserComplianceStatsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetUserComplianceStatsQueryVariables,
      variables: GetUserComplianceStatsQueryVariables,
      options?: UseInfiniteQueryOptions<GetUserComplianceStatsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetUserComplianceStatsQuery, TError, TData>(
      ['getUserComplianceStats.infinite', variables],
      (metaData) => fetchCoreApi<GetUserComplianceStatsQuery, GetUserComplianceStatsQueryVariables>(GetUserComplianceStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetUserQualityStatsDocument = `
    query getUserQualityStats($input: GetUserPerformanceStatsInput!) {
  getUserPerformanceStats {
    quality(input: $input) {
      current {
        ...relativeMetricFields
      }
      previous {
        ...relativeMetricFields
      }
      table {
        ...topicComplianceStatFields
      }
    }
  }
}
    ${RelativeMetricFieldsFragmentDoc}
${TopicComplianceStatFieldsFragmentDoc}`;
export const useGetUserQualityStatsQuery = <
      TData = GetUserQualityStatsQuery,
      TError = unknown
    >(
      variables: GetUserQualityStatsQueryVariables,
      options?: UseQueryOptions<GetUserQualityStatsQuery, TError, TData>
    ) =>
    useQuery<GetUserQualityStatsQuery, TError, TData>(
      ['getUserQualityStats', variables],
      fetchCoreApi<GetUserQualityStatsQuery, GetUserQualityStatsQueryVariables>(GetUserQualityStatsDocument, variables),
      options
    );
export const useInfiniteGetUserQualityStatsQuery = <
      TData = GetUserQualityStatsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetUserQualityStatsQueryVariables,
      variables: GetUserQualityStatsQueryVariables,
      options?: UseInfiniteQueryOptions<GetUserQualityStatsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetUserQualityStatsQuery, TError, TData>(
      ['getUserQualityStats.infinite', variables],
      (metaData) => fetchCoreApi<GetUserQualityStatsQuery, GetUserQualityStatsQueryVariables>(GetUserQualityStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetLiveUserInfoDocument = `
    query getLiveUserInfo {
  getUserInfo {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const useGetLiveUserInfoQuery = <
      TData = GetLiveUserInfoQuery,
      TError = unknown
    >(
      variables?: GetLiveUserInfoQueryVariables,
      options?: UseQueryOptions<GetLiveUserInfoQuery, TError, TData>
    ) =>
    useQuery<GetLiveUserInfoQuery, TError, TData>(
      variables === undefined ? ['getLiveUserInfo'] : ['getLiveUserInfo', variables],
      fetchCoreApi<GetLiveUserInfoQuery, GetLiveUserInfoQueryVariables>(GetLiveUserInfoDocument, variables),
      options
    );
export const useInfiniteGetLiveUserInfoQuery = <
      TData = GetLiveUserInfoQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetLiveUserInfoQueryVariables,
      variables?: GetLiveUserInfoQueryVariables,
      options?: UseInfiniteQueryOptions<GetLiveUserInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetLiveUserInfoQuery, TError, TData>(
      variables === undefined ? ['getLiveUserInfo.infinite'] : ['getLiveUserInfo.infinite', variables],
      (metaData) => fetchCoreApi<GetLiveUserInfoQuery, GetLiveUserInfoQueryVariables>(GetLiveUserInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const UpdatePushSubscriptionDocument = `
    mutation updatePushSubscription($input: UpdatePushSubscriptionInput!) {
  updatePushSubscription(input: $input) {
    id
  }
}
    `;
export const useUpdatePushSubscriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePushSubscriptionMutation, TError, UpdatePushSubscriptionMutationVariables, TContext>) =>
    useMutation<UpdatePushSubscriptionMutation, TError, UpdatePushSubscriptionMutationVariables, TContext>(
      ['updatePushSubscription'],
      (variables?: UpdatePushSubscriptionMutationVariables) => fetchCoreApi<UpdatePushSubscriptionMutation, UpdatePushSubscriptionMutationVariables>(UpdatePushSubscriptionDocument, variables)(),
      options
    );
export const UpdatePersonalInfoDocument = `
    mutation updatePersonalInfo($input: UpdatePersonalInfoInput!) {
  updatePersonalInfo(input: $input) {
    id
  }
}
    `;
export const useUpdatePersonalInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePersonalInfoMutation, TError, UpdatePersonalInfoMutationVariables, TContext>) =>
    useMutation<UpdatePersonalInfoMutation, TError, UpdatePersonalInfoMutationVariables, TContext>(
      ['updatePersonalInfo'],
      (variables?: UpdatePersonalInfoMutationVariables) => fetchCoreApi<UpdatePersonalInfoMutation, UpdatePersonalInfoMutationVariables>(UpdatePersonalInfoDocument, variables)(),
      options
    );
export const UpdateUserSettingsDocument = `
    mutation updateUserSettings($input: UpdateUserSettingsInput!) {
  updateUserSettings(input: $input) {
    id
  }
}
    `;
export const useUpdateUserSettingsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserSettingsMutation, TError, UpdateUserSettingsMutationVariables, TContext>) =>
    useMutation<UpdateUserSettingsMutation, TError, UpdateUserSettingsMutationVariables, TContext>(
      ['updateUserSettings'],
      (variables?: UpdateUserSettingsMutationVariables) => fetchCoreApi<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(UpdateUserSettingsDocument, variables)(),
      options
    );
export const UpdatePasswordDocument = `
    mutation updatePassword($input: UpdatePasswordInput!) {
  updatePassword(input: $input) {
    id
  }
}
    `;
export const useUpdatePasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePasswordMutation, TError, UpdatePasswordMutationVariables, TContext>) =>
    useMutation<UpdatePasswordMutation, TError, UpdatePasswordMutationVariables, TContext>(
      ['updatePassword'],
      (variables?: UpdatePasswordMutationVariables) => fetchCoreApi<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, variables)(),
      options
    );